// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/iconadicionarbranco.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/iconeeditar.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/iconedeletar.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/iconealerta.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/circulocard.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/iconedeletarbranco.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/iconeinfomed.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/avatar-default.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/logologinbranco.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../img/logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../img/iconesalvarmobile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../img/iconevoltarmobile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../img/icone-pdf.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../img/icone-png.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../img/icone-x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../img/icone-editar-nota.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../img/icone-arquivo-baixar.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../img/icone-status-entregue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../img/pendente.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../img/iconevcheckbox.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../img/iconexcheckbox.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../img/demandaAtencao.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../img/atingiuOEsperado.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../img/superou-se.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../img/naoAtingiu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../img/iconebotaosalvarlink.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../img/iconebotaodeletarlink.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../img/iconebotaocheckon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../img/iconebotaocheckoff.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../img/iconebotaouncheckon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../img/iconebotaouncheckoff.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../img/iconejustificativa.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../img/iconeminhaturma.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../img/iconematricula.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../img/iconepontoverde.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../img/iconeensino.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../img/iconeturno.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../img/iconeprofessor.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../img/iconeavaliacoes.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../img/iconeavaliacoespendente.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../img/iconeprovapendente.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../img/iconeprovadownload.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../img/iconeprovaupload.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4TC0C4E.ttf) format('truetype');
}
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 200;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4bC1C4E.ttf) format('truetype');
}
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4W61C4E.ttf) format('truetype');
}
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4TC1C4E.ttf) format('truetype');
}
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4QK1C4E.ttf) format('truetype');
}
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4e6yC4E.ttf) format('truetype');
}
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4deyC4E.ttf) format('truetype');
}
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4bCyC4E.ttf) format('truetype');
}
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4ZmyC4E.ttf) format('truetype');
}
.padding-nano {
  padding: 5px 5px 5px 5px;
}
.padding-nano-top {
  padding: 5px 0 0 0;
}
.padding-nano-right {
  padding: 0 5px 0 0;
}
.padding-nano-bottom {
  padding: 0 0 5px 0;
}
.padding-nano-left {
  padding: 0 0 0 5px;
}
.padding-nano-vertical {
  padding: 5px 0;
}
.padding-nano-horizontal {
  padding: 0 5px;
}
.padding-nano-micro {
  padding: 7px 7px 7px 7px;
}
.padding-micro {
  padding: 10px 10px 10px 10px;
}
.padding-micro-top {
  padding: 10px 0 0 0;
}
.padding-micro-right {
  padding: 0 10px 0 0;
}
.padding-micro-bottom {
  padding: 0 0 10px 0;
}
.padding-micro-left {
  padding: 0 0 0 10px;
}
.padding-micro-vertical {
  padding: 10px 0;
}
.padding-micro-horizontal {
  padding: 0 10px;
}
.padding-small {
  padding: 15px 15px 15px 15px;
}
.padding-small-top {
  padding: 15px 0 0 0;
}
.padding-small-right {
  padding: 0 15px 0 0;
}
.padding-small-bottom {
  padding: 0 0 15px 0;
}
.padding-small-left {
  padding: 0 0 0 15px;
}
.padding-small-vertical {
  padding: 15px 0;
}
.padding-small-horizontal {
  padding: 0 15px;
}
.padding-medium {
  padding: 30px 30px 30px 30px;
}
.padding-medium-top {
  padding: 24px 0 0 0;
}
.padding-medium-right {
  padding: 0 30px 0 0;
}
.padding-medium-bottom {
  padding: 0 0 30px 0;
}
.padding-medium-left {
  padding: 0 0 0 30px;
}
.padding-medium-vertical {
  padding: 30px 0;
}
.padding-medium-horizontal {
  padding: 0 30px;
}
.padding-large {
  padding: 50px 50px 50px 50px;
}
.padding-large-top {
  padding: 50px 0 0 0;
}
.padding-large-right {
  padding: 0 80px 0 0;
}
.padding-large-bottom {
  padding: 0 0 50px 0;
}
.padding-large-left {
  padding: 0 0 0 50px;
}
.padding-large-vertical {
  padding: 50px 0;
}
.padding-large-horizontal {
  padding: 0 50px;
}
.padding-remove {
  padding: 0 0 0 0;
}
.padding-remove-top {
  padding-top: 0;
}
.padding-remove-right {
  padding-right: 0;
}
.padding-remove-left {
  padding-left: 0;
}
.padding-remove-bottom {
  padding-bottom: 0;
}
.padding-remove-vertical {
  padding-top: 0;
  padding-bottom: 0;
}
.padding-remove-horizontal {
  padding-left: 0;
  padding-right: 0;
}
.padding-letter-top {
  padding-top: 21px;
}
.padding-label-top {
  padding-top: 18px;
}
@media (min-width: 435px) {
  .padding-nano\\@xs {
    padding: 5px 5px 5px 5px;
  }
  .padding-nano-top\\@xs {
    padding: 5px 0 0 0;
  }
  .padding-nano-right\\@xs {
    padding: 0 5px 0 0;
  }
  .padding-nano-bottom\\@xs {
    padding: 0 0 5px 0;
  }
  .padding-nano-left\\@xs {
    padding: 0 0 0 5px;
  }
  .padding-nano-vertical\\@xs {
    padding: 5px 0;
  }
  .padding-nano-horizontal\\@xs {
    padding: 0 5px;
  }
  .padding-micro\\@xs {
    padding: 10px 10px 10px 10px;
  }
  .padding-micro-top\\@xs {
    padding: 10px 0 0 0;
  }
  .padding-micro-right\\@xs {
    padding: 0 10px 0 0;
  }
  .padding-micro-bottom\\@xs {
    padding: 0 0 10px 0;
  }
  .padding-micro-left\\@xs {
    padding: 0 0 0 10px;
  }
  .padding-micro-vertical\\@xs {
    padding: 10px 0;
  }
  .padding-micro-horizontal\\@xs {
    padding: 0 10px;
  }
  .padding-small\\@xs {
    padding: 15px 15px 15px 15px;
  }
  .padding-small-top\\@xs {
    padding: 15px 0 0 0;
  }
  .padding-small-right\\@xs {
    padding: 0 15px 0 0;
  }
  .padding-small-bottom\\@xs {
    padding: 0 0 15px 0;
  }
  .padding-small-left\\@xs {
    padding: 0 0 0 15px;
  }
  .padding-small-vertical\\@xs {
    padding: 15px 0;
  }
  .padding-small-horizontal\\@xs {
    padding: 0 15px;
  }
  .padding-medium\\@xs {
    padding: 30px 30px 30px 30px;
  }
  .padding-medium-top\\@xs {
    padding: 24px 0 0 0;
  }
  .padding-medium-right\\@xs {
    padding: 0 30px 0 0;
  }
  .padding-medium-bottom\\@xs {
    padding: 0 0 30px 0;
  }
  .padding-medium-left\\@xs {
    padding: 0 0 0 30px;
  }
  .padding-medium-vertical\\@xs {
    padding: 30px 0;
  }
  .padding-medium-horizontal\\@xs {
    padding: 0 30px;
  }
  .padding-large\\@xs {
    padding: 50px 50px 50px 50px;
  }
  .padding-large-top\\@xs {
    padding: 50px 0 0 0;
  }
  .padding-large-right\\@xs {
    padding: 0 80px 0 0;
  }
  .padding-large-bottom\\@xs {
    padding: 0 0 50px 0;
  }
  .padding-large-left\\@xs {
    padding: 0 0 0 50px;
  }
  .padding-large-vertical\\@xs {
    padding: 50px 0;
  }
  .padding-large-horizontal\\@xs {
    padding: 0 50px;
  }
  .padding-remove\\@xs {
    padding: 0 0 0 0;
  }
  .padding-remove-top\\@xs {
    padding-top: 0;
  }
  .padding-remove-right\\@xs {
    padding-right: 0;
  }
  .padding-remove-left\\@xs {
    padding-left: 0;
  }
  .padding-remove-bottom\\@xs {
    padding-bottom: 0;
  }
  .padding-remove-vertical\\@xs {
    padding-top: 0;
    padding-bottom: 0;
  }
  .padding-remove-horizontal\\@xs {
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 640px) {
  .padding-nano\\@s {
    padding: 5px 5px 5px 5px;
  }
  .padding-nano-top\\@s {
    padding: 5px 0 0 0;
  }
  .padding-nano-right\\@s {
    padding: 0 5px 0 0;
  }
  .padding-nano-bottom\\@s {
    padding: 0 0 5px 0;
  }
  .padding-nano-left\\@s {
    padding: 0 0 0 5px;
  }
  .padding-nano-vertical\\@s {
    padding: 5px 0;
  }
  .padding-nano-horizontal\\@s {
    padding: 0 5px;
  }
  .padding-micro\\@s {
    padding: 10px 10px 10px 10px;
  }
  .padding-micro-top\\@s {
    padding: 10px 0 0 0;
  }
  .padding-micro-right\\@s {
    padding: 0 10px 0 0;
  }
  .padding-micro-bottom\\@s {
    padding: 0 0 10px 0;
  }
  .padding-micro-left\\@s {
    padding: 0 0 0 10px;
  }
  .padding-micro-vertical\\@s {
    padding: 10px 0;
  }
  .padding-micro-horizontal\\@s {
    padding: 0 10px;
  }
  .padding-small\\@s {
    padding: 15px 15px 15px 15px;
  }
  .padding-small-top\\@s {
    padding: 15px 0 0 0;
  }
  .padding-small-right\\@s {
    padding: 0 15px 0 0;
  }
  .padding-small-bottom\\@s {
    padding: 0 0 15px 0;
  }
  .padding-small-left\\@s {
    padding: 0 0 0 15px;
  }
  .padding-small-vertical\\@s {
    padding: 15px 0;
  }
  .padding-small-horizontal\\@s {
    padding: 0 15px;
  }
  .padding-medium\\@s {
    padding: 30px 30px 30px 30px;
  }
  .padding-medium-top\\@s {
    padding: 24px 0 0 0;
  }
  .padding-medium-right\\@s {
    padding: 0 30px 0 0;
  }
  .padding-medium-bottom\\@s {
    padding: 0 0 30px 0;
  }
  .padding-medium-left\\@s {
    padding: 0 0 0 30px;
  }
  .padding-medium-vertical\\@s {
    padding: 30px 0;
  }
  .padding-medium-horizontal\\@s {
    padding: 0 30px;
  }
  .padding-large\\@s {
    padding: 50px 50px 50px 50px;
  }
  .padding-large-top\\@s {
    padding: 50px 0 0 0;
  }
  .padding-large-right\\@s {
    padding: 0 80px 0 0;
  }
  .padding-large-bottom\\@s {
    padding: 0 0 50px 0;
  }
  .padding-large-left\\@s {
    padding: 0 0 0 50px;
  }
  .padding-large-vertical\\@s {
    padding: 50px 0;
  }
  .padding-large-horizontal\\@s {
    padding: 0 50px;
  }
  .padding-remove\\@s {
    padding: 0 0 0 0;
  }
  .padding-remove-top\\@s {
    padding-top: 0;
  }
  .padding-remove-right\\@s {
    padding-right: 0;
  }
  .padding-remove-left\\@s {
    padding-left: 0;
  }
  .padding-remove-bottom\\@s {
    padding-bottom: 0;
  }
  .padding-remove-vertical\\@s {
    padding-top: 0;
    padding-bottom: 0;
  }
  .padding-remove-horizontal\\@s {
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 960px) {
  .padding-nano\\@m {
    padding: 5px 5px 5px 5px;
  }
  .padding-nano-top\\@m {
    padding: 5px 0 0 0;
  }
  .padding-nano-right\\@m {
    padding: 0 5px 0 0;
  }
  .padding-nano-bottom\\@m {
    padding: 0 0 5px 0;
  }
  .padding-nano-left\\@m {
    padding: 0 0 0 5px;
  }
  .padding-nano-vertical\\@m {
    padding: 5px 0;
  }
  .padding-nano-horizontal\\@m {
    padding: 0 5px;
  }
  .padding-micro\\@m {
    padding: 10px 10px 10px 10px;
  }
  .padding-micro-top\\@m {
    padding: 10px 0 0 0;
  }
  .padding-micro-right\\@m {
    padding: 0 10px 0 0;
  }
  .padding-micro-bottom\\@m {
    padding: 0 0 10px 0;
  }
  .padding-micro-left\\@m {
    padding: 0 0 0 10px;
  }
  .padding-micro-vertical\\@m {
    padding: 10px 0;
  }
  .padding-micro-horizontal\\@m {
    padding: 0 10px;
  }
  .padding-small\\@m {
    padding: 15px 15px 15px 15px;
  }
  .padding-small-top\\@m {
    padding: 15px 0 0 0;
  }
  .padding-small-right\\@m {
    padding: 0 15px 0 0;
  }
  .padding-small-bottom\\@m {
    padding: 0 0 15px 0;
  }
  .padding-small-left\\@m {
    padding: 0 0 0 15px;
  }
  .padding-small-vertical\\@m {
    padding: 15px 0;
  }
  .padding-small-horizontal\\@m {
    padding: 0 15px;
  }
  .padding-medium\\@m {
    padding: 30px 30px 30px 30px;
  }
  .padding-medium-top\\@m {
    padding: 24px 0 0 0;
  }
  .padding-medium-right\\@m {
    padding: 0 30px 0 0;
  }
  .padding-medium-bottom\\@m {
    padding: 0 0 30px 0;
  }
  .padding-medium-left\\@m {
    padding: 0 0 0 30px;
  }
  .padding-medium-vertical\\@m {
    padding: 30px 0;
  }
  .padding-medium-horizontal\\@m {
    padding: 0 30px;
  }
  .padding-large\\@m {
    padding: 50px 50px 50px 50px;
  }
  .padding-large-top\\@m {
    padding: 50px 0 0 0;
  }
  .padding-large-right\\@m {
    padding: 0 80px 0 0;
  }
  .padding-large-bottom\\@m {
    padding: 0 0 50px 0;
  }
  .padding-large-left\\@m {
    padding: 0 0 0 50px;
  }
  .padding-large-vertical\\@m {
    padding: 50px 0;
  }
  .padding-large-horizontal\\@m {
    padding: 0 50px;
  }
  .padding-remove\\@m {
    padding: 0 0 0 0;
  }
  .padding-remove-top\\@m {
    padding-top: 0;
  }
  .padding-remove-right\\@m {
    padding-right: 0;
  }
  .padding-remove-left\\@m {
    padding-left: 0;
  }
  .padding-remove-bottom\\@m {
    padding-bottom: 0;
  }
  .padding-remove-vertical\\@m {
    padding-top: 0;
    padding-bottom: 0;
  }
  .padding-remove-horizontal\\@m {
    padding-left: 0;
    padding-right: 0;
  }
  .padding-letter-top {
    padding-top: 18px;
  }
  .padding-letter-top\\@m {
    padding-top: 18px;
  }
  .padding-label-top {
    padding-top: 15px;
  }
  .padding-label-top\\@m {
    padding-top: 15px;
  }
}
@media (min-width: 1200px) {
  .padding-nano\\@l {
    padding: 5px 5px 5px 5px;
  }
  .padding-nano-top\\@l {
    padding: 5px 0 0 0;
  }
  .padding-nano-right\\@l {
    padding: 0 5px 0 0;
  }
  .padding-nano-bottom\\@l {
    padding: 0 0 5px 0;
  }
  .padding-nano-left\\@l {
    padding: 0 0 0 5px;
  }
  .padding-nano-vertical\\@l {
    padding: 5px 0;
  }
  .padding-nano-horizontal\\@l {
    padding: 0 5px;
  }
  .padding-micro\\@l {
    padding: 10px 10px 10px 10px;
  }
  .padding-micro-top\\@l {
    padding: 10px 0 0 0;
  }
  .padding-micro-right\\@l {
    padding: 0 10px 0 0;
  }
  .padding-micro-bottom\\@l {
    padding: 0 0 10px 0;
  }
  .padding-micro-left\\@l {
    padding: 0 0 0 10px;
  }
  .padding-micro-vertical\\@l {
    padding: 10px 0;
  }
  .padding-micro-horizontal\\@l {
    padding: 0 10px;
  }
  .padding-small\\@l {
    padding: 15px 15px 15px 15px;
  }
  .padding-small-top\\@l {
    padding: 15px 0 0 0;
  }
  .padding-small-right\\@l {
    padding: 0 15px 0 0;
  }
  .padding-small-bottom\\@l {
    padding: 0 0 15px 0;
  }
  .padding-small-left\\@l {
    padding: 0 0 0 15px;
  }
  .padding-small-vertical\\@l {
    padding: 15px 0;
  }
  .padding-small-horizontal\\@l {
    padding: 0 15px;
  }
  .padding-medium\\@l {
    padding: 30px 30px 30px 30px;
  }
  .padding-medium-top\\@l {
    padding: 24px 0 0 0;
  }
  .padding-medium-right\\@l {
    padding: 0 30px 0 0;
  }
  .padding-medium-bottom\\@l {
    padding: 0 0 30px 0;
  }
  .padding-medium-left\\@l {
    padding: 0 0 0 30px;
  }
  .padding-medium-vertical\\@l {
    padding: 30px 0;
  }
  .padding-medium-horizontal\\@l {
    padding: 0 30px;
  }
  .padding-large\\@l {
    padding: 50px 50px 50px 50px;
  }
  .padding-large-top\\@l {
    padding: 50px 0 0 0;
  }
  .padding-large-right\\@l {
    padding: 0 80px 0 0;
  }
  .padding-large-bottom\\@l {
    padding: 0 0 50px 0;
  }
  .padding-large-left\\@l {
    padding: 0 0 0 50px;
  }
  .padding-large-vertical\\@l {
    padding: 50px 0;
  }
  .padding-large-horizontal\\@l {
    padding: 0 50px;
  }
  .padding-remove\\@l {
    padding: 0 0 0 0;
  }
  .padding-remove-top\\@l {
    padding-top: 0;
  }
  .padding-remove-right\\@l {
    padding-right: 0;
  }
  .padding-remove-left\\@l {
    padding-left: 0;
  }
  .padding-remove-bottom\\@l {
    padding-bottom: 0;
  }
  .padding-remove-vertical\\@l {
    padding-top: 0;
    padding-bottom: 0;
  }
  .padding-remove-horizontal\\@l {
    padding-left: 0;
    padding-right: 0;
  }
  .padding-label-top\\@l {
    padding-top: 15px;
  }
}
@media (min-width: 1600px) {
  .padding-nano\\@xl {
    padding: 5px 5px 5px 5px;
  }
  .padding-nano-top\\@xl {
    padding: 5px 0 0 0;
  }
  .padding-nano-right\\@xl {
    padding: 0 5px 0 0;
  }
  .padding-nano-bottom\\@xl {
    padding: 0 0 5px 0;
  }
  .padding-nano-left\\@xl {
    padding: 0 0 0 5px;
  }
  .padding-nano-vertical\\@xl {
    padding: 5px 0;
  }
  .padding-nano-horizontal\\@xl {
    padding: 0 5px;
  }
  .padding-micro\\@xl {
    padding: 10px 10px 10px 10px;
  }
  .padding-micro-top\\@xl {
    padding: 10px 0 0 0;
  }
  .padding-micro-right\\@xl {
    padding: 0 10px 0 0;
  }
  .padding-micro-bottom\\@xl {
    padding: 0 0 10px 0;
  }
  .padding-micro-left\\@xl {
    padding: 0 0 0 10px;
  }
  .padding-micro-vertical\\@xl {
    padding: 10px 0;
  }
  .padding-micro-horizontal\\@xl {
    padding: 0 10px;
  }
  .padding-small\\@xl {
    padding: 15px 15px 15px 15px;
  }
  .padding-small-top\\@xl {
    padding: 15px 0 0 0;
  }
  .padding-small-right\\@xl {
    padding: 0 15px 0 0;
  }
  .padding-small-bottom\\@xl {
    padding: 0 0 15px 0;
  }
  .padding-small-left\\@xl {
    padding: 0 0 0 15px;
  }
  .padding-small-vertical\\@xl {
    padding: 15px 0;
  }
  .padding-small-horizontal\\@xl {
    padding: 0 15px;
  }
  .padding-medium\\@xl {
    padding: 30px 30px 30px 30px;
  }
  .padding-medium-top\\@xl {
    padding: 24px 0 0 0;
  }
  .padding-medium-right\\@xl {
    padding: 0 30px 0 0;
  }
  .padding-medium-bottom\\@xl {
    padding: 0 0 30px 0;
  }
  .padding-medium-left\\@xl {
    padding: 0 0 0 30px;
  }
  .padding-medium-vertical\\@xl {
    padding: 30px 0;
  }
  .padding-medium-horizontal\\@xl {
    padding: 0 30px;
  }
  .padding-large\\@xl {
    padding: 50px 50px 50px 50px;
  }
  .padding-large-top\\@xl {
    padding: 50px 0 0 0;
  }
  .padding-large-right\\@xl {
    padding: 0 80px 0 0;
  }
  .padding-large-bottom\\@xl {
    padding: 0 0 50px 0;
  }
  .padding-large-left\\@xl {
    padding: 0 0 0 50px;
  }
  .padding-large-vertical\\@xl {
    padding: 50px 0;
  }
  .padding-large-horizontal\\@xl {
    padding: 0 50px;
  }
  .padding-xlarge-horizontal\\@xl {
    padding: 0 100px;
  }
  .padding-remove\\@xl {
    padding: 0 0 0 0;
  }
  .padding-remove-top\\@xl {
    padding-top: 0;
  }
  .padding-remove-right\\@xl {
    padding-right: 0;
  }
  .padding-remove-left\\@xl {
    padding-left: 0;
  }
  .padding-remove-bottom\\@xl {
    padding-bottom: 0;
  }
  .padding-remove-vertical\\@xl {
    padding-top: 0;
    padding-bottom: 0;
  }
  .padding-remove-horizontal\\@xl {
    padding-left: 0;
    padding-right: 0;
  }
  .padding-letter-top {
    padding-top: 24px;
  }
  .padding-letter-top\\@m {
    padding-top: 24px;
  }
  .padding-label-top {
    padding-top: 20px;
  }
  .padding-label-top\\@m {
    padding-top: 20px;
  }
  .padding-label-top\\@l {
    padding-top: 20px;
  }
}
@media (min-width: 600px) {
  .margin-small-left\\@s {
    margin-left: 10px !important;
  }
  .margin-remove-top\\@s {
    margin-top: 0 !important;
  }
  .margin-remove\\@s {
    margin: 0 !important;
  }
}
@media (min-width: 960px) {
  .margin-remove-top\\@m {
    margin-top: 0 !important;
  }
  .margin-remove\\@m {
    margin: 0 !important;
  }
}
@media (min-width: 1200px) {
  .margin-remove-top\\@l {
    margin-top: 0 !important;
  }
  .margin-remove\\@l {
    margin: 0 !important;
  }
}
@media (min-width: 1600px) {
  .margin-remove-top\\@xl {
    margin-top: 0 !important;
  }
  .margin-remove\\@xl {
    margin: 0 !important;
  }
}
.margin-remove {
  margin: 0 0 0 0;
}
.margin-remove-top {
  margin-top: 0;
}
.margin-nano {
  margin: 5px 5px 5px 5px;
}
.margin-nano-top {
  margin: 5px 0 0 0;
}
.margin-nano-right {
  margin: 0 5px 0 0;
}
.margin-nano-bottom {
  margin: 0 0 5px 0;
}
.margin-nano-left {
  margin: 0 0 0 5px;
}
.margin-nano-vertical {
  margin: 5px 0;
}
.margin-nano-horizontal {
  margin: 0 5px;
}
.margin-micro {
  margin: 10px 10px 10px 10px;
}
.margin-micro-top {
  margin: 10px 0 0 0;
}
.margin-micro-right {
  margin: 0 10px 0 0;
}
.margin-micro-bottom {
  margin: 0 0 10px 0;
}
.margin-micro-left {
  margin: 0 0 0 10px;
}
.margin-micro-vertical {
  margin: 10px 0;
}
.margin-micro-horizontal {
  margin: 0 10px;
}
.margin-small-right-bottom {
  margin: 0 15px 15px 0;
}
@media (min-width: 1600px) {
  .margin-remove\\@xl {
    margin: 0 0 0 0;
  }
  .margin-remove-top\\@xl {
    margin-top: 0;
  }
  .margin-remove-bottom\\@xl {
    margin-bottom: 0;
  }
  .margin-remove-left\\@xl {
    margin-left: 0;
  }
  .margin-remove-right\\@xl {
    margin-right: 0;
  }
  .margin-nano\\@xl {
    margin: 5px 5px 5px 5px;
  }
  .margin-nano-top\\@xl {
    margin: 5px 0 0 0;
  }
  .margin-nano-right\\@xl {
    margin: 0 5px 0 0;
  }
  .margin-nano-bottom\\@xl {
    margin: 0 0 5px 0;
  }
  .margin-nano-left\\@xl {
    margin: 0 0 0 5px;
  }
  .margin-nano-vertical\\@xl {
    margin: 5px 0;
  }
  .margin-nano-horizontal\\@xl {
    margin: 0 5px;
  }
  .margin-micro\\@xl {
    margin: 10px 10px 10px 10px;
  }
  .margin-micro-top\\@xl {
    margin: 10px 0 0 0;
  }
  .margin-micro-right\\@xl {
    margin: 0 10px 0 0;
  }
  .margin-micro-bottom\\@xl {
    margin: 0 0 10px 0;
  }
  .margin-micro-left\\@xl {
    margin: 0 0 0 10px;
  }
  .margin-micro-vertical\\@xl {
    margin: 10px 0;
  }
  .margin-micro-horizontal\\@xl {
    margin: 0 10px;
  }
}
@media (min-width: 960px) {
  .margin-remove\\@m {
    margin: 0 0 0 0;
  }
  .margin-remove-top\\@m {
    margin-top: 0;
  }
  .margin-remove-bottom\\@m {
    margin-bottom: 0;
  }
  .margin-remove-left\\@m {
    margin-left: 0;
  }
  .margin-remove-right\\@m {
    margin-right: 0;
  }
  .margin-nano\\@m {
    margin: 5px 5px 5px 5px;
  }
  .margin-nano-top\\@m {
    margin: 5px 0 0 0;
  }
  .margin-nano-right\\@m {
    margin: 0 5px 0 0;
  }
  .margin-nano-bottom\\@m {
    margin: 0 0 5px 0;
  }
  .margin-nano-left\\@m {
    margin: 0 0 0 5px;
  }
  .margin-nano-vertical\\@m {
    margin: 5px 0;
  }
  .margin-nano-horizontal\\@m {
    margin: 0 5px;
  }
  .margin-micro\\@m {
    margin: 10px 10px 10px 10px;
  }
  .margin-micro-top\\@m {
    margin: 10px 0 0 0;
  }
  .margin-micro-right\\@m {
    margin: 0 10px 0 0;
  }
  .margin-micro-bottom\\@m {
    margin: 0 0 10px 0;
  }
  .margin-micro-left\\@m {
    margin: 0 0 0 10px;
  }
  .margin-micro-vertical\\@m {
    margin: 10px 0;
  }
  .margin-micro-horizontal\\@m {
    margin: 0 10px;
  }
  .margin-medium-top\\@m {
    margin: 24px 0 0 0;
  }
  .margin-large-right\\@m {
    margin: 0 80px 0 0;
  }
}
.width-small-medium {
  width: 200;
}
.width-micro {
  width: 100px;
}
.width-micro-small {
  width: 60px;
}
.width-nano {
  width: 50px;
}
@media (min-width: 960px) {
  .width-large\\@m {
    width: 338px;
  }
  .width-medium\\@m {
    width: 225px;
  }
  .width-small-medium\\@m {
    width: 150px;
  }
  .width-small\\@m {
    width: 112px;
  }
  .width-micro\\@m {
    width: 75px;
  }
  .width-nano\\@m {
    width: 38px;
  }
}
@media (min-width: 600px) {
  .width-large\\@s {
    width: 338px;
  }
  .width-medium\\@s {
    width: 225px;
  }
  .width-small-medium\\@s {
    width: 150px;
  }
  .width-small\\@s {
    width: 112px;
  }
  .width-micro\\@s {
    width: 75px;
  }
  .width-nano\\@s {
    width: 38px;
  }
}
@media (min-width: 1200px) {
  .width-large\\@l {
    width: 450px;
  }
  .width-medium\\@l {
    width: 300px;
  }
  .width-small-medium\\@l {
    width: 200px;
  }
  .width-small\\@l {
    width: 150px;
  }
  .width-micro\\@l {
    width: 100px;
  }
  .width-nano\\@l {
    width: 50px;
  }
}
.width-1000 {
  width: 1000px;
}
.width-1200 {
  width: 1200px;
}
@media (min-width: 640px) {
  .width-1000\\@s {
    width: 1000px;
  }
  .width-1200\\@s {
    width: 1200px;
  }
}
@media (min-width: 960px) {
  .width-1000\\@m {
    width: 1000px;
  }
  .width-1200\\@m {
    width: 1200px;
  }
  .width-1400\\@m {
    width: 1400px;
  }
}
@media (min-width: 1200px) {
  .width-1000\\@l {
    width: 1000px;
  }
  .width-1100\\@l {
    width: 1100px;
  }
  .width-1200\\@l {
    width: 1200px;
  }
  .width-1400\\@l {
    width: 1400px;
  }
}
@media (min-width: 1600px) {
  .width-1000\\@xl {
    width: 1000px;
  }
  .width-1200\\@xl {
    width: 1200px;
  }
  .width-1300\\@xl {
    width: 1300px;
  }
  .width-1400\\@xl {
    width: 1400px;
  }
  .width-1500\\@xl {
    width: 1500px;
  }
  .width-1600\\@xl {
    width: 1600px;
  }
}
.width-6-6 {
  width: 100%;
}
.width-5-6 {
  width: 83.33333333%;
}
.width-4-6 {
  width: 66.66666667%;
}
.width-3-6 {
  width: 50%;
}
.width-2-6 {
  width: 33.33333333%;
}
.width-1-6 {
  width: 16.66666667%;
}
.width-8-8 {
  width: 100%;
}
.width-7-8 {
  width: 87.5%;
}
.width-6-8 {
  width: 75%;
}
.width-5-8 {
  width: 62.5%;
}
.width-4-8 {
  width: 50%;
}
.width-3-8 {
  width: 37.5%;
}
.width-2-8 {
  width: 25%;
}
.width-1-8 {
  width: 12.5%;
}
.width-12-12 {
  width: 100%;
}
.width-11-12 {
  width: 91.66666667%;
}
.width-10-12 {
  width: 83.33333333%;
}
.width-9-12 {
  width: 75%;
}
.width-8-12 {
  width: 66.66666667%;
}
.width-7-12 {
  width: 58.33333333%;
}
.width-6-12 {
  width: 50%;
}
.width-5-12 {
  width: 41.66666667%;
}
.width-4-12 {
  width: 33.33333333%;
}
.width-3-12 {
  width: 25%;
}
.width-2-12 {
  width: 16.66666667%;
}
.width-1-12 {
  width: 8.33333333%;
}
.width-20-20 {
  width: 100%;
}
.width-19-20 {
  width: 95%;
}
.width-18-20 {
  width: 90%;
}
.width-17-20 {
  width: 85%;
}
.width-16-20 {
  width: 80%;
}
.width-15-20 {
  width: 75%;
}
.width-14-20 {
  width: 70%;
}
.width-13-20 {
  width: 65%;
}
.width-12-20 {
  width: 60%;
}
.width-11-20 {
  width: 55%;
}
.width-10-20 {
  width: 50%;
}
.width-9-20 {
  width: 45%;
}
.width-8-20 {
  width: 40%;
}
.width-7-20 {
  width: 35%;
}
.width-6-20 {
  width: 30%;
}
.width-5-20 {
  width: 25%;
}
.width-4-20 {
  width: 20%;
}
.width-3-20 {
  width: 15%;
}
.width-2-20 {
  width: 10%;
}
.width-1-20 {
  width: 5%;
}
.width-600 {
  width: 600px;
}
.width-595 {
  width: 595px;
}
.width-590 {
  width: 590px;
}
.width-585 {
  width: 585px;
}
.width-580 {
  width: 580px;
}
.width-575 {
  width: 575px;
}
.width-570 {
  width: 570px;
}
.width-565 {
  width: 565px;
}
.width-560 {
  width: 560px;
}
.width-555 {
  width: 555px;
}
.width-550 {
  width: 550px;
}
.width-545 {
  width: 545px;
}
.width-540 {
  width: 540px;
}
.width-535 {
  width: 535px;
}
.width-530 {
  width: 530px;
}
.width-525 {
  width: 525px;
}
.width-520 {
  width: 520px;
}
.width-515 {
  width: 515px;
}
.width-510 {
  width: 510px;
}
.width-505 {
  width: 505px;
}
.width-500 {
  width: 500px;
}
.width-495 {
  width: 495px;
}
.width-490 {
  width: 490px;
}
.width-485 {
  width: 485px;
}
.width-480 {
  width: 480px;
}
.width-475 {
  width: 475px;
}
.width-470 {
  width: 470px;
}
.width-465 {
  width: 465px;
}
.width-460 {
  width: 460px;
}
.width-455 {
  width: 455px;
}
.width-450 {
  width: 450px;
}
.width-445 {
  width: 445px;
}
.width-440 {
  width: 440px;
}
.width-435 {
  width: 435px;
}
.width-430 {
  width: 430px;
}
.width-425 {
  width: 425px;
}
.width-420 {
  width: 420px;
}
.width-415 {
  width: 415px;
}
.width-410 {
  width: 410px;
}
.width-405 {
  width: 405px;
}
.width-400 {
  width: 400px;
}
.width-395 {
  width: 395px;
}
.width-390 {
  width: 390px;
}
.width-385 {
  width: 385px;
}
.width-380 {
  width: 380px;
}
.width-375 {
  width: 375px;
}
.width-370 {
  width: 370px;
}
.width-365 {
  width: 365px;
}
.width-360 {
  width: 360px;
}
.width-355 {
  width: 355px;
}
.width-350 {
  width: 350px;
}
.width-345 {
  width: 345px;
}
.width-340 {
  width: 340px;
}
.width-335 {
  width: 335px;
}
.width-330 {
  width: 330px;
}
.width-325 {
  width: 325px;
}
.width-320 {
  width: 320px;
}
.width-315 {
  width: 315px;
}
.width-310 {
  width: 310px;
}
.width-305 {
  width: 305px;
}
.width-300 {
  width: 300px;
}
.width-295 {
  width: 295px;
}
.width-290 {
  width: 290px;
}
.width-285 {
  width: 285px;
}
.width-280 {
  width: 280px;
}
.width-275 {
  width: 275px;
}
.width-270 {
  width: 270px;
}
.width-265 {
  width: 265px;
}
.width-260 {
  width: 260px;
}
.width-255 {
  width: 255px;
}
.width-250 {
  width: 250px;
}
.width-245 {
  width: 245px;
}
.width-240 {
  width: 240px;
}
.width-235 {
  width: 235px;
}
.width-230 {
  width: 230px;
}
.width-225 {
  width: 225px;
}
.width-220 {
  width: 220px;
}
.width-215 {
  width: 215px;
}
.width-210 {
  width: 210px;
}
.width-205 {
  width: 205px;
}
.width-200 {
  width: 200px;
}
.width-195 {
  width: 195px;
}
.width-190 {
  width: 190px;
}
.width-185 {
  width: 185px;
}
.width-180 {
  width: 180px;
}
.width-175 {
  width: 175px;
}
.width-170 {
  width: 170px;
}
.width-165 {
  width: 165px;
}
.width-160 {
  width: 160px;
}
.width-155 {
  width: 155px;
}
.width-150 {
  width: 150px;
}
.width-145 {
  width: 145px;
}
.width-140 {
  width: 140px;
}
.width-135 {
  width: 135px;
}
.width-130 {
  width: 130px;
}
.width-125 {
  width: 125px;
}
.width-120 {
  width: 120px;
}
.width-115 {
  width: 115px;
}
.width-110 {
  width: 110px;
}
.width-105 {
  width: 105px;
}
.width-100 {
  width: 100px;
}
.width-95 {
  width: 95px;
}
.width-90 {
  width: 90px;
}
.width-85 {
  width: 85px;
}
.width-80 {
  width: 80px;
}
.width-75 {
  width: 75px;
}
.width-70 {
  width: 70px;
}
.width-65 {
  width: 65px;
}
.width-60 {
  width: 60px;
}
.width-55 {
  width: 55px;
}
.width-50 {
  width: 50px;
}
.width-45 {
  width: 45px;
}
.width-40 {
  width: 40px;
}
.width-35 {
  width: 35px;
}
.width-30 {
  width: 30px;
}
.width-25 {
  width: 25px;
}
.width-20 {
  width: 20px;
}
.width-15 {
  width: 15px;
}
.width-10 {
  width: 10px;
}
.width-5 {
  width: 5px;
}
@media (min-width: 640px) {
  .width-6-6\\@s {
    width: 100%;
  }
  .width-5-6\\@s {
    width: 83.33333333%;
  }
  .width-4-6\\@s {
    width: 66.66666667%;
  }
  .width-3-6\\@s {
    width: 50%;
  }
  .width-2-6\\@s {
    width: 33.33333333%;
  }
  .width-1-6\\@s {
    width: 16.66666667%;
  }
  .width-8-8\\@s {
    width: 100%;
  }
  .width-7-8\\@s {
    width: 87.5%;
  }
  .width-6-8\\@s {
    width: 75%;
  }
  .width-5-8\\@s {
    width: 62.5%;
  }
  .width-4-8\\@s {
    width: 50%;
  }
  .width-3-8\\@s {
    width: 37.5%;
  }
  .width-2-8\\@s {
    width: 25%;
  }
  .width-1-8\\@s {
    width: 12.5%;
  }
  .width-12-12\\@s {
    width: 100%;
  }
  .width-11-12\\@s {
    width: 91.66666667%;
  }
  .width-10-12\\@s {
    width: 83.33333333%;
  }
  .width-9-12\\@s {
    width: 75%;
  }
  .width-8-12\\@s {
    width: 66.66666667%;
  }
  .width-7-12\\@s {
    width: 58.33333333%;
  }
  .width-6-12\\@s {
    width: 50%;
  }
  .width-5-12\\@s {
    width: 41.66666667%;
  }
  .width-4-12\\@s {
    width: 33.33333333%;
  }
  .width-3-12\\@s {
    width: 25%;
  }
  .width-2-12\\@s {
    width: 16.66666667%;
  }
  .width-1-12\\@s {
    width: 8.33333333%;
  }
  .width-20-20\\@s {
    width: 100%;
  }
  .width-19-20\\@s {
    width: 95%;
  }
  .width-18-20\\@s {
    width: 90%;
  }
  .width-17-20\\@s {
    width: 85%;
  }
  .width-16-20\\@s {
    width: 80%;
  }
  .width-15-20\\@s {
    width: 75%;
  }
  .width-14-20\\@s {
    width: 70%;
  }
  .width-13-20\\@s {
    width: 65%;
  }
  .width-12-20\\@s {
    width: 60%;
  }
  .width-11-20\\@s {
    width: 55%;
  }
  .width-10-20\\@s {
    width: 50%;
  }
  .width-9-20\\@s {
    width: 45%;
  }
  .width-8-20\\@s {
    width: 40%;
  }
  .width-7-20\\@s {
    width: 35%;
  }
  .width-6-20\\@s {
    width: 30%;
  }
  .width-5-20\\@s {
    width: 25%;
  }
  .width-4-20\\@s {
    width: 20%;
  }
  .width-3-20\\@s {
    width: 15%;
  }
  .width-2-20\\@s {
    width: 10%;
  }
  .width-1-20\\@s {
    width: 5%;
  }
  .width-600\\@s {
    width: 600px;
  }
  .width-595\\@s {
    width: 595px;
  }
  .width-590\\@s {
    width: 590px;
  }
  .width-585\\@s {
    width: 585px;
  }
  .width-580\\@s {
    width: 580px;
  }
  .width-575\\@s {
    width: 575px;
  }
  .width-570\\@s {
    width: 570px;
  }
  .width-565\\@s {
    width: 565px;
  }
  .width-560\\@s {
    width: 560px;
  }
  .width-555\\@s {
    width: 555px;
  }
  .width-550\\@s {
    width: 550px;
  }
  .width-545\\@s {
    width: 545px;
  }
  .width-540\\@s {
    width: 540px;
  }
  .width-535\\@s {
    width: 535px;
  }
  .width-530\\@s {
    width: 530px;
  }
  .width-525\\@s {
    width: 525px;
  }
  .width-520\\@s {
    width: 520px;
  }
  .width-515\\@s {
    width: 515px;
  }
  .width-510\\@s {
    width: 510px;
  }
  .width-505\\@s {
    width: 505px;
  }
  .width-500\\@s {
    width: 500px;
  }
  .width-495\\@s {
    width: 495px;
  }
  .width-490\\@s {
    width: 490px;
  }
  .width-485\\@s {
    width: 485px;
  }
  .width-480\\@s {
    width: 480px;
  }
  .width-475\\@s {
    width: 475px;
  }
  .width-470\\@s {
    width: 470px;
  }
  .width-465\\@s {
    width: 465px;
  }
  .width-460\\@s {
    width: 460px;
  }
  .width-455\\@s {
    width: 455px;
  }
  .width-450\\@s {
    width: 450px;
  }
  .width-445\\@s {
    width: 445px;
  }
  .width-440\\@s {
    width: 440px;
  }
  .width-435\\@s {
    width: 435px;
  }
  .width-430\\@s {
    width: 430px;
  }
  .width-425\\@s {
    width: 425px;
  }
  .width-420\\@s {
    width: 420px;
  }
  .width-415\\@s {
    width: 415px;
  }
  .width-410\\@s {
    width: 410px;
  }
  .width-405\\@s {
    width: 405px;
  }
  .width-400\\@s {
    width: 400px;
  }
  .width-395\\@s {
    width: 395px;
  }
  .width-390\\@s {
    width: 390px;
  }
  .width-385\\@s {
    width: 385px;
  }
  .width-380\\@s {
    width: 380px;
  }
  .width-375\\@s {
    width: 375px;
  }
  .width-370\\@s {
    width: 370px;
  }
  .width-365\\@s {
    width: 365px;
  }
  .width-360\\@s {
    width: 360px;
  }
  .width-355\\@s {
    width: 355px;
  }
  .width-350\\@s {
    width: 350px;
  }
  .width-345\\@s {
    width: 345px;
  }
  .width-340\\@s {
    width: 340px;
  }
  .width-335\\@s {
    width: 335px;
  }
  .width-330\\@s {
    width: 330px;
  }
  .width-325\\@s {
    width: 325px;
  }
  .width-320\\@s {
    width: 320px;
  }
  .width-315\\@s {
    width: 315px;
  }
  .width-310\\@s {
    width: 310px;
  }
  .width-305\\@s {
    width: 305px;
  }
  .width-300\\@s {
    width: 300px;
  }
  .width-295\\@s {
    width: 295px;
  }
  .width-290\\@s {
    width: 290px;
  }
  .width-285\\@s {
    width: 285px;
  }
  .width-280\\@s {
    width: 280px;
  }
  .width-275\\@s {
    width: 275px;
  }
  .width-270\\@s {
    width: 270px;
  }
  .width-265\\@s {
    width: 265px;
  }
  .width-260\\@s {
    width: 260px;
  }
  .width-255\\@s {
    width: 255px;
  }
  .width-250\\@s {
    width: 250px;
  }
  .width-245\\@s {
    width: 245px;
  }
  .width-240\\@s {
    width: 240px;
  }
  .width-235\\@s {
    width: 235px;
  }
  .width-230\\@s {
    width: 230px;
  }
  .width-225\\@s {
    width: 225px;
  }
  .width-220\\@s {
    width: 220px;
  }
  .width-215\\@s {
    width: 215px;
  }
  .width-210\\@s {
    width: 210px;
  }
  .width-205\\@s {
    width: 205px;
  }
  .width-200\\@s {
    width: 200px;
  }
  .width-195\\@s {
    width: 195px;
  }
  .width-190\\@s {
    width: 190px;
  }
  .width-185\\@s {
    width: 185px;
  }
  .width-180\\@s {
    width: 180px;
  }
  .width-175\\@s {
    width: 175px;
  }
  .width-170\\@s {
    width: 170px;
  }
  .width-165\\@s {
    width: 165px;
  }
  .width-160\\@s {
    width: 160px;
  }
  .width-155\\@s {
    width: 155px;
  }
  .width-150\\@s {
    width: 150px;
  }
  .width-145\\@s {
    width: 145px;
  }
  .width-140\\@s {
    width: 140px;
  }
  .width-135\\@s {
    width: 135px;
  }
  .width-130\\@s {
    width: 130px;
  }
  .width-125\\@s {
    width: 125px;
  }
  .width-120\\@s {
    width: 120px;
  }
  .width-115\\@s {
    width: 115px;
  }
  .width-110\\@s {
    width: 110px;
  }
  .width-105\\@s {
    width: 105px;
  }
  .width-100\\@s {
    width: 100px;
  }
  .width-95\\@s {
    width: 95px;
  }
  .width-90\\@s {
    width: 90px;
  }
  .width-85\\@s {
    width: 85px;
  }
  .width-80\\@s {
    width: 80px;
  }
  .width-75\\@s {
    width: 75px;
  }
  .width-70\\@s {
    width: 70px;
  }
  .width-65\\@s {
    width: 65px;
  }
  .width-60\\@s {
    width: 60px;
  }
  .width-55\\@s {
    width: 55px;
  }
  .width-50\\@s {
    width: 50px;
  }
  .width-45\\@s {
    width: 45px;
  }
  .width-40\\@s {
    width: 40px;
  }
  .width-35\\@s {
    width: 35px;
  }
  .width-30\\@s {
    width: 30px;
  }
  .width-25\\@s {
    width: 25px;
  }
  .width-20\\@s {
    width: 20px;
  }
  .width-15\\@s {
    width: 15px;
  }
  .width-10\\@s {
    width: 10px;
  }
  .width-5\\@s {
    width: 5px;
  }
}
@media (min-width: 960px) {
  .width-6-6\\@m {
    width: 100%;
  }
  .width-5-6\\@m {
    width: 83.33333333%;
  }
  .width-4-6\\@m {
    width: 66.66666667%;
  }
  .width-3-6\\@m {
    width: 50%;
  }
  .width-2-6\\@m {
    width: 33.33333333%;
  }
  .width-1-6\\@m {
    width: 16.66666667%;
  }
  .width-8-8\\@m {
    width: 100%;
  }
  .width-7-8\\@m {
    width: 87.5%;
  }
  .width-6-8\\@m {
    width: 75%;
  }
  .width-5-8\\@m {
    width: 62.5%;
  }
  .width-4-8\\@m {
    width: 50%;
  }
  .width-3-8\\@m {
    width: 37.5%;
  }
  .width-2-8\\@m {
    width: 25%;
  }
  .width-1-8\\@m {
    width: 12.5%;
  }
  .width-12-12\\@m {
    width: 100%;
  }
  .width-11-12\\@m {
    width: 91.66666667%;
  }
  .width-10-12\\@m {
    width: 83.33333333%;
  }
  .width-9-12\\@m {
    width: 75%;
  }
  .width-8-12\\@m {
    width: 66.66666667%;
  }
  .width-7-12\\@m {
    width: 58.33333333%;
  }
  .width-6-12\\@m {
    width: 50%;
  }
  .width-5-12\\@m {
    width: 41.66666667%;
  }
  .width-4-12\\@m {
    width: 33.33333333%;
  }
  .width-3-12\\@m {
    width: 25%;
  }
  .width-2-12\\@m {
    width: 16.66666667%;
  }
  .width-1-12\\@m {
    width: 8.33333333%;
  }
  .width-20-20\\@m {
    width: 100%;
  }
  .width-19-20\\@m {
    width: 95%;
  }
  .width-18-20\\@m {
    width: 90%;
  }
  .width-17-20\\@m {
    width: 85%;
  }
  .width-16-20\\@m {
    width: 80%;
  }
  .width-15-20\\@m {
    width: 75%;
  }
  .width-14-20\\@m {
    width: 70%;
  }
  .width-13-20\\@m {
    width: 65%;
  }
  .width-12-20\\@m {
    width: 60%;
  }
  .width-11-20\\@m {
    width: 55%;
  }
  .width-10-20\\@m {
    width: 50%;
  }
  .width-9-20\\@m {
    width: 45%;
  }
  .width-8-20\\@m {
    width: 40%;
  }
  .width-7-20\\@m {
    width: 35%;
  }
  .width-6-20\\@m {
    width: 30%;
  }
  .width-5-20\\@m {
    width: 25%;
  }
  .width-4-20\\@m {
    width: 20%;
  }
  .width-3-20\\@m {
    width: 15%;
  }
  .width-2-20\\@m {
    width: 10%;
  }
  .width-1-20\\@m {
    width: 5%;
  }
  .width-600\\@m {
    width: 600px;
  }
  .width-595\\@m {
    width: 595px;
  }
  .width-590\\@m {
    width: 590px;
  }
  .width-585\\@m {
    width: 585px;
  }
  .width-580\\@m {
    width: 580px;
  }
  .width-575\\@m {
    width: 575px;
  }
  .width-570\\@m {
    width: 570px;
  }
  .width-565\\@m {
    width: 565px;
  }
  .width-560\\@m {
    width: 560px;
  }
  .width-555\\@m {
    width: 555px;
  }
  .width-550\\@m {
    width: 550px;
  }
  .width-545\\@m {
    width: 545px;
  }
  .width-540\\@m {
    width: 540px;
  }
  .width-535\\@m {
    width: 535px;
  }
  .width-530\\@m {
    width: 530px;
  }
  .width-525\\@m {
    width: 525px;
  }
  .width-520\\@m {
    width: 520px;
  }
  .width-515\\@m {
    width: 515px;
  }
  .width-510\\@m {
    width: 510px;
  }
  .width-505\\@m {
    width: 505px;
  }
  .width-500\\@m {
    width: 500px;
  }
  .width-495\\@m {
    width: 495px;
  }
  .width-490\\@m {
    width: 490px;
  }
  .width-485\\@m {
    width: 485px;
  }
  .width-480\\@m {
    width: 480px;
  }
  .width-475\\@m {
    width: 475px;
  }
  .width-470\\@m {
    width: 470px;
  }
  .width-465\\@m {
    width: 465px;
  }
  .width-460\\@m {
    width: 460px;
  }
  .width-455\\@m {
    width: 455px;
  }
  .width-450\\@m {
    width: 450px;
  }
  .width-445\\@m {
    width: 445px;
  }
  .width-440\\@m {
    width: 440px;
  }
  .width-435\\@m {
    width: 435px;
  }
  .width-430\\@m {
    width: 430px;
  }
  .width-425\\@m {
    width: 425px;
  }
  .width-420\\@m {
    width: 420px;
  }
  .width-415\\@m {
    width: 415px;
  }
  .width-410\\@m {
    width: 410px;
  }
  .width-405\\@m {
    width: 405px;
  }
  .width-400\\@m {
    width: 400px;
  }
  .width-395\\@m {
    width: 395px;
  }
  .width-390\\@m {
    width: 390px;
  }
  .width-385\\@m {
    width: 385px;
  }
  .width-380\\@m {
    width: 380px;
  }
  .width-375\\@m {
    width: 375px;
  }
  .width-370\\@m {
    width: 370px;
  }
  .width-365\\@m {
    width: 365px;
  }
  .width-360\\@m {
    width: 360px;
  }
  .width-355\\@m {
    width: 355px;
  }
  .width-350\\@m {
    width: 350px;
  }
  .width-345\\@m {
    width: 345px;
  }
  .width-340\\@m {
    width: 340px;
  }
  .width-335\\@m {
    width: 335px;
  }
  .width-330\\@m {
    width: 330px;
  }
  .width-325\\@m {
    width: 325px;
  }
  .width-320\\@m {
    width: 320px;
  }
  .width-315\\@m {
    width: 315px;
  }
  .width-310\\@m {
    width: 310px;
  }
  .width-305\\@m {
    width: 305px;
  }
  .width-300\\@m {
    width: 300px;
  }
  .width-295\\@m {
    width: 295px;
  }
  .width-290\\@m {
    width: 290px;
  }
  .width-285\\@m {
    width: 285px;
  }
  .width-280\\@m {
    width: 280px;
  }
  .width-275\\@m {
    width: 275px;
  }
  .width-270\\@m {
    width: 270px;
  }
  .width-265\\@m {
    width: 265px;
  }
  .width-260\\@m {
    width: 260px;
  }
  .width-255\\@m {
    width: 255px;
  }
  .width-250\\@m {
    width: 250px;
  }
  .width-245\\@m {
    width: 245px;
  }
  .width-240\\@m {
    width: 240px;
  }
  .width-235\\@m {
    width: 235px;
  }
  .width-230\\@m {
    width: 230px;
  }
  .width-225\\@m {
    width: 225px;
  }
  .width-220\\@m {
    width: 220px;
  }
  .width-215\\@m {
    width: 215px;
  }
  .width-210\\@m {
    width: 210px;
  }
  .width-205\\@m {
    width: 205px;
  }
  .width-200\\@m {
    width: 200px;
  }
  .width-195\\@m {
    width: 195px;
  }
  .width-190\\@m {
    width: 190px;
  }
  .width-185\\@m {
    width: 185px;
  }
  .width-180\\@m {
    width: 180px;
  }
  .width-175\\@m {
    width: 175px;
  }
  .width-170\\@m {
    width: 170px;
  }
  .width-165\\@m {
    width: 165px;
  }
  .width-160\\@m {
    width: 160px;
  }
  .width-155\\@m {
    width: 155px;
  }
  .width-150\\@m {
    width: 150px;
  }
  .width-145\\@m {
    width: 145px;
  }
  .width-140\\@m {
    width: 140px;
  }
  .width-135\\@m {
    width: 135px;
  }
  .width-130\\@m {
    width: 130px;
  }
  .width-125\\@m {
    width: 125px;
  }
  .width-120\\@m {
    width: 120px;
  }
  .width-115\\@m {
    width: 115px;
  }
  .width-110\\@m {
    width: 110px;
  }
  .width-105\\@m {
    width: 105px;
  }
  .width-100\\@m {
    width: 100px;
  }
  .width-95\\@m {
    width: 95px;
  }
  .width-90\\@m {
    width: 90px;
  }
  .width-85\\@m {
    width: 85px;
  }
  .width-80\\@m {
    width: 80px;
  }
  .width-75\\@m {
    width: 75px;
  }
  .width-70\\@m {
    width: 70px;
  }
  .width-65\\@m {
    width: 65px;
  }
  .width-60\\@m {
    width: 60px;
  }
  .width-55\\@m {
    width: 55px;
  }
  .width-50\\@m {
    width: 50px;
  }
  .width-45\\@m {
    width: 45px;
  }
  .width-40\\@m {
    width: 40px;
  }
  .width-35\\@m {
    width: 35px;
  }
  .width-30\\@m {
    width: 30px;
  }
  .width-25\\@m {
    width: 25px;
  }
  .width-20\\@m {
    width: 20px;
  }
  .width-15\\@m {
    width: 15px;
  }
  .width-10\\@m {
    width: 10px;
  }
  .width-5\\@m {
    width: 5px;
  }
}
@media (min-width: 1200px) {
  .width-6-6\\@l {
    width: 100%;
  }
  .width-5-6\\@l {
    width: 83.33333333%;
  }
  .width-4-6\\@l {
    width: 66.66666667%;
  }
  .width-3-6\\@l {
    width: 50%;
  }
  .width-2-6\\@l {
    width: 33.33333333%;
  }
  .width-1-6\\@l {
    width: 16.66666667%;
  }
  .width-8-8\\@l {
    width: 100%;
  }
  .width-7-8\\@l {
    width: 87.5%;
  }
  .width-6-8\\@l {
    width: 75%;
  }
  .width-5-8\\@l {
    width: 62.5%;
  }
  .width-4-8\\@l {
    width: 50%;
  }
  .width-3-8\\@l {
    width: 37.5%;
  }
  .width-2-8\\@l {
    width: 25%;
  }
  .width-1-8\\@l {
    width: 12.5%;
  }
  .width-12-12\\@l {
    width: 100%;
  }
  .width-11-12\\@l {
    width: 91.66666667%;
  }
  .width-10-12\\@l {
    width: 83.33333333%;
  }
  .width-9-12\\@l {
    width: 75%;
  }
  .width-8-12\\@l {
    width: 66.66666667%;
  }
  .width-7-12\\@l {
    width: 58.33333333%;
  }
  .width-6-12\\@l {
    width: 50%;
  }
  .width-5-12\\@l {
    width: 41.66666667%;
  }
  .width-4-12\\@l {
    width: 33.33333333%;
  }
  .width-3-12\\@l {
    width: 25%;
  }
  .width-2-12\\@l {
    width: 16.66666667%;
  }
  .width-1-12\\@l {
    width: 8.33333333%;
  }
  .width-20-20\\@l {
    width: 100%;
  }
  .width-19-20\\@l {
    width: 95%;
  }
  .width-18-20\\@l {
    width: 90%;
  }
  .width-17-20\\@l {
    width: 85%;
  }
  .width-16-20\\@l {
    width: 80%;
  }
  .width-15-20\\@l {
    width: 75%;
  }
  .width-14-20\\@l {
    width: 70%;
  }
  .width-13-20\\@l {
    width: 65%;
  }
  .width-12-20\\@l {
    width: 60%;
  }
  .width-11-20\\@l {
    width: 55%;
  }
  .width-10-20\\@l {
    width: 50%;
  }
  .width-9-20\\@l {
    width: 45%;
  }
  .width-8-20\\@l {
    width: 40%;
  }
  .width-7-20\\@l {
    width: 35%;
  }
  .width-6-20\\@l {
    width: 30%;
  }
  .width-5-20\\@l {
    width: 25%;
  }
  .width-4-20\\@l {
    width: 20%;
  }
  .width-3-20\\@l {
    width: 15%;
  }
  .width-2-20\\@l {
    width: 10%;
  }
  .width-1-20\\@l {
    width: 5%;
  }
  .width-600\\@l {
    width: 600px;
  }
  .width-595\\@l {
    width: 595px;
  }
  .width-590\\@l {
    width: 590px;
  }
  .width-585\\@l {
    width: 585px;
  }
  .width-580\\@l {
    width: 580px;
  }
  .width-575\\@l {
    width: 575px;
  }
  .width-570\\@l {
    width: 570px;
  }
  .width-565\\@l {
    width: 565px;
  }
  .width-560\\@l {
    width: 560px;
  }
  .width-555\\@l {
    width: 555px;
  }
  .width-550\\@l {
    width: 550px;
  }
  .width-545\\@l {
    width: 545px;
  }
  .width-540\\@l {
    width: 540px;
  }
  .width-535\\@l {
    width: 535px;
  }
  .width-530\\@l {
    width: 530px;
  }
  .width-525\\@l {
    width: 525px;
  }
  .width-520\\@l {
    width: 520px;
  }
  .width-515\\@l {
    width: 515px;
  }
  .width-510\\@l {
    width: 510px;
  }
  .width-505\\@l {
    width: 505px;
  }
  .width-500\\@l {
    width: 500px;
  }
  .width-495\\@l {
    width: 495px;
  }
  .width-490\\@l {
    width: 490px;
  }
  .width-485\\@l {
    width: 485px;
  }
  .width-480\\@l {
    width: 480px;
  }
  .width-475\\@l {
    width: 475px;
  }
  .width-470\\@l {
    width: 470px;
  }
  .width-465\\@l {
    width: 465px;
  }
  .width-460\\@l {
    width: 460px;
  }
  .width-455\\@l {
    width: 455px;
  }
  .width-450\\@l {
    width: 450px;
  }
  .width-445\\@l {
    width: 445px;
  }
  .width-440\\@l {
    width: 440px;
  }
  .width-435\\@l {
    width: 435px;
  }
  .width-430\\@l {
    width: 430px;
  }
  .width-425\\@l {
    width: 425px;
  }
  .width-420\\@l {
    width: 420px;
  }
  .width-415\\@l {
    width: 415px;
  }
  .width-410\\@l {
    width: 410px;
  }
  .width-405\\@l {
    width: 405px;
  }
  .width-400\\@l {
    width: 400px;
  }
  .width-395\\@l {
    width: 395px;
  }
  .width-390\\@l {
    width: 390px;
  }
  .width-385\\@l {
    width: 385px;
  }
  .width-380\\@l {
    width: 380px;
  }
  .width-375\\@l {
    width: 375px;
  }
  .width-370\\@l {
    width: 370px;
  }
  .width-365\\@l {
    width: 365px;
  }
  .width-360\\@l {
    width: 360px;
  }
  .width-355\\@l {
    width: 355px;
  }
  .width-350\\@l {
    width: 350px;
  }
  .width-345\\@l {
    width: 345px;
  }
  .width-340\\@l {
    width: 340px;
  }
  .width-335\\@l {
    width: 335px;
  }
  .width-330\\@l {
    width: 330px;
  }
  .width-325\\@l {
    width: 325px;
  }
  .width-320\\@l {
    width: 320px;
  }
  .width-315\\@l {
    width: 315px;
  }
  .width-310\\@l {
    width: 310px;
  }
  .width-305\\@l {
    width: 305px;
  }
  .width-300\\@l {
    width: 300px;
  }
  .width-295\\@l {
    width: 295px;
  }
  .width-290\\@l {
    width: 290px;
  }
  .width-285\\@l {
    width: 285px;
  }
  .width-280\\@l {
    width: 280px;
  }
  .width-275\\@l {
    width: 275px;
  }
  .width-270\\@l {
    width: 270px;
  }
  .width-265\\@l {
    width: 265px;
  }
  .width-260\\@l {
    width: 260px;
  }
  .width-255\\@l {
    width: 255px;
  }
  .width-250\\@l {
    width: 250px;
  }
  .width-245\\@l {
    width: 245px;
  }
  .width-240\\@l {
    width: 240px;
  }
  .width-235\\@l {
    width: 235px;
  }
  .width-230\\@l {
    width: 230px;
  }
  .width-225\\@l {
    width: 225px;
  }
  .width-220\\@l {
    width: 220px;
  }
  .width-215\\@l {
    width: 215px;
  }
  .width-210\\@l {
    width: 210px;
  }
  .width-205\\@l {
    width: 205px;
  }
  .width-200\\@l {
    width: 200px;
  }
  .width-195\\@l {
    width: 195px;
  }
  .width-190\\@l {
    width: 190px;
  }
  .width-185\\@l {
    width: 185px;
  }
  .width-180\\@l {
    width: 180px;
  }
  .width-175\\@l {
    width: 175px;
  }
  .width-170\\@l {
    width: 170px;
  }
  .width-165\\@l {
    width: 165px;
  }
  .width-160\\@l {
    width: 160px;
  }
  .width-155\\@l {
    width: 155px;
  }
  .width-150\\@l {
    width: 150px;
  }
  .width-145\\@l {
    width: 145px;
  }
  .width-140\\@l {
    width: 140px;
  }
  .width-135\\@l {
    width: 135px;
  }
  .width-130\\@l {
    width: 130px;
  }
  .width-125\\@l {
    width: 125px;
  }
  .width-120\\@l {
    width: 120px;
  }
  .width-115\\@l {
    width: 115px;
  }
  .width-110\\@l {
    width: 110px;
  }
  .width-105\\@l {
    width: 105px;
  }
  .width-100\\@l {
    width: 100px;
  }
  .width-95\\@l {
    width: 95px;
  }
  .width-90\\@l {
    width: 90px;
  }
  .width-85\\@l {
    width: 85px;
  }
  .width-80\\@l {
    width: 80px;
  }
  .width-75\\@l {
    width: 75px;
  }
  .width-70\\@l {
    width: 70px;
  }
  .width-65\\@l {
    width: 65px;
  }
  .width-60\\@l {
    width: 60px;
  }
  .width-55\\@l {
    width: 55px;
  }
  .width-50\\@l {
    width: 50px;
  }
  .width-45\\@l {
    width: 45px;
  }
  .width-40\\@l {
    width: 40px;
  }
  .width-35\\@l {
    width: 35px;
  }
  .width-30\\@l {
    width: 30px;
  }
  .width-25\\@l {
    width: 25px;
  }
  .width-20\\@l {
    width: 20px;
  }
  .width-15\\@l {
    width: 15px;
  }
  .width-10\\@l {
    width: 10px;
  }
  .width-5\\@l {
    width: 5px;
  }
}
@media (min-width: 1600px) {
  .width-6-6\\@xl {
    width: 100%;
  }
  .width-5-6\\@xl {
    width: 83.33333333%;
  }
  .width-4-6\\@xl {
    width: 66.66666667%;
  }
  .width-3-6\\@xl {
    width: 50%;
  }
  .width-2-6\\@xl {
    width: 33.33333333%;
  }
  .width-1-6\\@xl {
    width: 16.66666667%;
  }
  .width-8-8\\@xl {
    width: 100%;
  }
  .width-7-8\\@xl {
    width: 87.5%;
  }
  .width-6-8\\@xl {
    width: 75%;
  }
  .width-5-8\\@xl {
    width: 62.5%;
  }
  .width-4-8\\@xl {
    width: 50%;
  }
  .width-3-8\\@xl {
    width: 37.5%;
  }
  .width-2-8\\@xl {
    width: 25%;
  }
  .width-1-8\\@xl {
    width: 12.5%;
  }
  .width-12-12\\@xl {
    width: 100%;
  }
  .width-11-12\\@xl {
    width: 91.66666667%;
  }
  .width-10-12\\@xl {
    width: 83.33333333%;
  }
  .width-9-12\\@xl {
    width: 75%;
  }
  .width-8-12\\@xl {
    width: 66.66666667%;
  }
  .width-7-12\\@xl {
    width: 58.33333333%;
  }
  .width-6-12\\@xl {
    width: 50%;
  }
  .width-5-12\\@xl {
    width: 41.66666667%;
  }
  .width-4-12\\@xl {
    width: 33.33333333%;
  }
  .width-3-12\\@xl {
    width: 25%;
  }
  .width-2-12\\@xl {
    width: 16.66666667%;
  }
  .width-1-12\\@xl {
    width: 8.33333333%;
  }
  .width-20-20\\@xl {
    width: 100%;
  }
  .width-19-20\\@xl {
    width: 95%;
  }
  .width-18-20\\@xl {
    width: 90%;
  }
  .width-17-20\\@xl {
    width: 85%;
  }
  .width-16-20\\@xl {
    width: 80%;
  }
  .width-15-20\\@xl {
    width: 75%;
  }
  .width-14-20\\@xl {
    width: 70%;
  }
  .width-13-20\\@xl {
    width: 65%;
  }
  .width-12-20\\@xl {
    width: 60%;
  }
  .width-11-20\\@xl {
    width: 55%;
  }
  .width-10-20\\@xl {
    width: 50%;
  }
  .width-9-20\\@xl {
    width: 45%;
  }
  .width-8-20\\@xl {
    width: 40%;
  }
  .width-7-20\\@xl {
    width: 35%;
  }
  .width-6-20\\@xl {
    width: 30%;
  }
  .width-5-20\\@xl {
    width: 25%;
  }
  .width-4-20\\@xl {
    width: 20%;
  }
  .width-3-20\\@xl {
    width: 15%;
  }
  .width-2-20\\@xl {
    width: 10%;
  }
  .width-1-20\\@xl {
    width: 5%;
  }
  .width-600\\@xl {
    width: 600px;
  }
  .width-595\\@xl {
    width: 595px;
  }
  .width-590\\@xl {
    width: 590px;
  }
  .width-585\\@xl {
    width: 585px;
  }
  .width-580\\@xl {
    width: 580px;
  }
  .width-575\\@xl {
    width: 575px;
  }
  .width-570\\@xl {
    width: 570px;
  }
  .width-565\\@xl {
    width: 565px;
  }
  .width-560\\@xl {
    width: 560px;
  }
  .width-555\\@xl {
    width: 555px;
  }
  .width-550\\@xl {
    width: 550px;
  }
  .width-545\\@xl {
    width: 545px;
  }
  .width-540\\@xl {
    width: 540px;
  }
  .width-535\\@xl {
    width: 535px;
  }
  .width-530\\@xl {
    width: 530px;
  }
  .width-525\\@xl {
    width: 525px;
  }
  .width-520\\@xl {
    width: 520px;
  }
  .width-515\\@xl {
    width: 515px;
  }
  .width-510\\@xl {
    width: 510px;
  }
  .width-505\\@xl {
    width: 505px;
  }
  .width-500\\@xl {
    width: 500px;
  }
  .width-495\\@xl {
    width: 495px;
  }
  .width-490\\@xl {
    width: 490px;
  }
  .width-485\\@xl {
    width: 485px;
  }
  .width-480\\@xl {
    width: 480px;
  }
  .width-475\\@xl {
    width: 475px;
  }
  .width-470\\@xl {
    width: 470px;
  }
  .width-465\\@xl {
    width: 465px;
  }
  .width-460\\@xl {
    width: 460px;
  }
  .width-455\\@xl {
    width: 455px;
  }
  .width-450\\@xl {
    width: 450px;
  }
  .width-445\\@xl {
    width: 445px;
  }
  .width-440\\@xl {
    width: 440px;
  }
  .width-435\\@xl {
    width: 435px;
  }
  .width-430\\@xl {
    width: 430px;
  }
  .width-425\\@xl {
    width: 425px;
  }
  .width-420\\@xl {
    width: 420px;
  }
  .width-415\\@xl {
    width: 415px;
  }
  .width-410\\@xl {
    width: 410px;
  }
  .width-405\\@xl {
    width: 405px;
  }
  .width-400\\@xl {
    width: 400px;
  }
  .width-395\\@xl {
    width: 395px;
  }
  .width-390\\@xl {
    width: 390px;
  }
  .width-385\\@xl {
    width: 385px;
  }
  .width-380\\@xl {
    width: 380px;
  }
  .width-375\\@xl {
    width: 375px;
  }
  .width-370\\@xl {
    width: 370px;
  }
  .width-365\\@xl {
    width: 365px;
  }
  .width-360\\@xl {
    width: 360px;
  }
  .width-355\\@xl {
    width: 355px;
  }
  .width-350\\@xl {
    width: 350px;
  }
  .width-345\\@xl {
    width: 345px;
  }
  .width-340\\@xl {
    width: 340px;
  }
  .width-335\\@xl {
    width: 335px;
  }
  .width-330\\@xl {
    width: 330px;
  }
  .width-325\\@xl {
    width: 325px;
  }
  .width-320\\@xl {
    width: 320px;
  }
  .width-315\\@xl {
    width: 315px;
  }
  .width-310\\@xl {
    width: 310px;
  }
  .width-305\\@xl {
    width: 305px;
  }
  .width-300\\@xl {
    width: 300px;
  }
  .width-295\\@xl {
    width: 295px;
  }
  .width-290\\@xl {
    width: 290px;
  }
  .width-285\\@xl {
    width: 285px;
  }
  .width-280\\@xl {
    width: 280px;
  }
  .width-275\\@xl {
    width: 275px;
  }
  .width-270\\@xl {
    width: 270px;
  }
  .width-265\\@xl {
    width: 265px;
  }
  .width-260\\@xl {
    width: 260px;
  }
  .width-255\\@xl {
    width: 255px;
  }
  .width-250\\@xl {
    width: 250px;
  }
  .width-245\\@xl {
    width: 245px;
  }
  .width-240\\@xl {
    width: 240px;
  }
  .width-235\\@xl {
    width: 235px;
  }
  .width-230\\@xl {
    width: 230px;
  }
  .width-225\\@xl {
    width: 225px;
  }
  .width-220\\@xl {
    width: 220px;
  }
  .width-215\\@xl {
    width: 215px;
  }
  .width-210\\@xl {
    width: 210px;
  }
  .width-205\\@xl {
    width: 205px;
  }
  .width-200\\@xl {
    width: 200px;
  }
  .width-195\\@xl {
    width: 195px;
  }
  .width-190\\@xl {
    width: 190px;
  }
  .width-185\\@xl {
    width: 185px;
  }
  .width-180\\@xl {
    width: 180px;
  }
  .width-175\\@xl {
    width: 175px;
  }
  .width-170\\@xl {
    width: 170px;
  }
  .width-165\\@xl {
    width: 165px;
  }
  .width-160\\@xl {
    width: 160px;
  }
  .width-155\\@xl {
    width: 155px;
  }
  .width-150\\@xl {
    width: 150px;
  }
  .width-145\\@xl {
    width: 145px;
  }
  .width-140\\@xl {
    width: 140px;
  }
  .width-135\\@xl {
    width: 135px;
  }
  .width-130\\@xl {
    width: 130px;
  }
  .width-125\\@xl {
    width: 125px;
  }
  .width-120\\@xl {
    width: 120px;
  }
  .width-115\\@xl {
    width: 115px;
  }
  .width-110\\@xl {
    width: 110px;
  }
  .width-105\\@xl {
    width: 105px;
  }
  .width-100\\@xl {
    width: 100px;
  }
  .width-95\\@xl {
    width: 95px;
  }
  .width-90\\@xl {
    width: 90px;
  }
  .width-85\\@xl {
    width: 85px;
  }
  .width-80\\@xl {
    width: 80px;
  }
  .width-75\\@xl {
    width: 75px;
  }
  .width-70\\@xl {
    width: 70px;
  }
  .width-65\\@xl {
    width: 65px;
  }
  .width-60\\@xl {
    width: 60px;
  }
  .width-55\\@xl {
    width: 55px;
  }
  .width-50\\@xl {
    width: 50px;
  }
  .width-45\\@xl {
    width: 45px;
  }
  .width-40\\@xl {
    width: 40px;
  }
  .width-35\\@xl {
    width: 35px;
  }
  .width-30\\@xl {
    width: 30px;
  }
  .width-25\\@xl {
    width: 25px;
  }
  .width-20\\@xl {
    width: 20px;
  }
  .width-15\\@xl {
    width: 15px;
  }
  .width-10\\@xl {
    width: 10px;
  }
  .width-5\\@xl {
    width: 5px;
  }
}
.child-width-1-8 > * {
  width: calc(100% / 8);
}
@media (min-width: 640px) {
  .child-width-1-8\\@s > * {
    width: calc(100% / 8);
  }
}
@media (min-width: 960px) {
  .child-width-1-8\\@m > * {
    width: calc(100% / 8);
  }
}
@media (min-width: 1200px) {
  .child-width-1-8\\@l > * {
    width: calc(100% / 8);
  }
}
@media (min-width: 1600px) {
  .child-width-1-8\\@xl > * {
    width: calc(100% / 8);
  }
}
.uk-width-1-8 {
  width: calc(100% / 8);
}
.icone-adicionar {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  width: 20px;
  height: 20px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-editar {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  width: 16px;
  height: 16px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-excluir {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
  width: 14px;
  height: 16px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-alerta {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
  width: 47px;
  height: 47px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  flex-shrink: 0;
  aspect-ratio: 1 / 1;
}
.icone-circulo-card-aluno {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) !important;
  width: 12px;
  height: 12px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-excluir-card-aluno {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) !important;
  width: 12px;
  height: 13px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-info-medicas-card-aluno {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) !important;
  width: 35px;
  height: 25px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-avatar {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) !important;
  width: 40px;
  height: 40px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-logo-menu {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) !important;
  width: 104px;
  height: 46px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-logo-login {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) !important;
  width: 150px;
  height: 66px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-salvar-mobile {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) !important;
  width: 35px;
  height: 35px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-voltar-mobile {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) !important;
  width: 35px;
  height: 35px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-pdf {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) !important;
  width: 16px;
  height: 20px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-png {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) !important;
  width: 16px;
  height: 20px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-x {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) !important;
  width: 11px;
  height: 11px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-editar-nota {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) !important;
  width: 22px;
  height: 22px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-arquivo-baixar {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) !important;
  width: 20px;
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-status-entregue {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) !important;
  width: 20px;
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-status-pendente {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) !important;
  width: 20px;
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.checkbox-presente {
  width: 22px;
  height: 22px;
  border: 2px solid #ddd;
  border-radius: 50%;
  background-color: #ddd;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) !important;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 12px 12px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.2s ease;
}
.checkbox-ausente {
  width: 22px;
  height: 22px;
  border: 2px solid #ddd;
  border-radius: 50%;
  background-color: #ddd;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) !important;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 10px 10px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.2s ease;
}
.demanda-atencao {
  width: 40px;
  height: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) !important;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 30px 30px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.2s ease;
}
.atingiu-o-esperado {
  width: 40px;
  height: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) !important;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 30px 30px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.2s ease;
}
.superou-se {
  width: 40px;
  height: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) !important;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 30px 30px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.2s ease;
}
.nao-atingiu {
  width: 40px;
  height: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) !important;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 30px 30px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.2s ease;
}
.fonte-icone-mobile {
  font-size: 11px !important;
}
.icone-adicionar-link {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) !important;
  width: 40px;
  height: 40px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-deletar-link {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) !important;
  width: 40px;
  height: 40px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-check-on {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) !important;
  width: 20px;
  height: 20px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-check-off {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) !important;
  width: 20px;
  height: 20px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-uncheck-on {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) !important;
  width: 20px;
  height: 20px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-uncheck-off {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) !important;
  width: 20px;
  height: 20px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-justificativa {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) !important;
  width: 20px;
  height: 20px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-minha-turma {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___}) !important;
  width: 24px;
  height: 24px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-matricula {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___}) !important;
  width: 20px;
  height: 20px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-status {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___}) !important;
  width: 20px;
  height: 20px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-ensino {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___}) !important;
  width: 20px;
  height: 20px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-ensino-grande {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___}) !important;
  width: 30px;
  height: 30px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-turno {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) !important;
  width: 20px;
  height: 20px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-professor {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) !important;
  width: 20px;
  height: 16px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-avaliacoes {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___}) !important;
  width: 20px;
  height: 20px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-avaliacoes-pendente {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___}) !important;
  width: 30px;
  height: 30px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-prova-pendente {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___}) !important;
  width: 30px;
  height: 30px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-prova-download {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___}) !important;
  width: 18px;
  height: 23px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-prova-upload {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___}) !important;
  width: 18px;
  height: 23px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.icone-prova-deletar {
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
  width: 18px;
  height: 23px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
@media (max-width: 768px) {
  .icone-logo-menu {
    width: 80px;
    height: 30px;
  }
}
@media (min-width: 768px) and (max-width: 959px) {
  .icone-logo-menu {
    width: 90px !important;
    height: 38px !important;
  }
}
@media (max-width: 959px) {
  .icone-logo-menu {
    width: 70px !important;
    height: 28px !important;
  }
}
:root {
  --cor-azul: #06337a;
  --cor-azul-escuro: #001C40;
  --cor-branco: #fff;
  --cor-cinza-input: #e7e9f3;
}
body,
* {
  font-family: "Outfit", sans-serif !important;
}
.uk-background-primary {
  background-color: var(--cor-azul) !important;
}
.uk-background-secondary {
  background-color: #25367e17 !important;
}
.background-azul-escuro {
  background-color: var(--cor-azul-escuro) !important;
}
.uk-text-primary {
  color: var(--cor-azul) !important;
}
.uk-text-default {
  font-size: 17px !important;
}
.uk-text-large {
  font-size: 20px !important;
}
.text-white {
  color: var(--cor-branco) !important;
}
.text-black {
  color: #000 !important;
}
.bg-input,
input:disabled,
select:disabled {
  background-color: var(--cor-cinza-input) !important;
}
.bg-input:not(:disabled) {
  background-color: var(--cor-cinza-input) !important;
}
.botao-adicionar {
  text-transform: none;
}
.uk-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.tamanho-input-padrao {
  height: 36px;
}
.botoes-acoes {
  gap: 8px;
}
.uk-modal-dialog[role="alertdialog"] {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}
.uk-modal-dialog[role="alertdialog"] .uk-modal-body {
  border-radius: 10px 10px 0 0;
}
.uk-modal-dialog[role="alertdialog"] .uk-modal-footer {
  border-radius: 0 0 10px 10px;
}
.uk-modal-dialog[role="alertdialog"] .uk-button {
  border-radius: 8px;
  height: 36px;
}
.espacamento-interno-pequeno {
  padding: 5px 10px;
}
.active-page .pagination-button {
  background-color: var(--cor-azul);
  color: white;
  width: 100%;
}
.borda-grid {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
}
.linha-borda-grid {
  border-bottom: 1px solid #e5e5e5;
}
.titulo-card-ativar-conta {
  font-size: 25px;
}
.largura-minima-acoes {
  min-width: 75px;
  text-align: left;
  align-items: start;
}
.uk-card-top {
  padding: 10px 12px;
}
.uk-div-hover {
  transition: background-color 0.1s ease-in-out;
}
.uk-div-hover:hover {
  background-color: #ffd;
}
.altura-linha-tabela {
  height: 69px !important;
}
@media (max-width: 959px) {
  .uk-offcanvas-bar {
    width: 280px !important;
    background-color: white !important;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  }
  .mobile-menu-header {
    color: var(--cor-azul) !important;
    border-radius: 0;
  }
  .mobile-menu-header h3 {
    font-size: 18px;
    font-weight: bold;
    margin: 0 !important;
  }
  .uk-offcanvas-bar .uk-background-muted {
    background-color: #f8f9fa !important;
    border-radius: 8px;
    border: 1px solid #e9ecef;
  }
  .uk-offcanvas-bar .uk-nav-default {
    margin-top: 0;
  }
  .uk-offcanvas-bar .uk-nav-default > li {
    border-bottom: 1px solid #f0f0f0;
  }
  .uk-offcanvas-bar .uk-nav-default > li > a {
    padding: 5px 10px;
    font-size: 16px;
    font-weight: 600;
    color: var(--cor-azul) !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: none;
    transition: all 0.3s ease;
  }
  .uk-offcanvas-bar .uk-nav-default > li > a:hover {
    background-color: #f8f9fa;
    color: var(--cor-azul) !important;
  }
  .uk-offcanvas-bar .uk-nav-default > li.uk-active > a,
  .uk-offcanvas-bar .uk-nav-default > li.uk-open > a {
    background-color: var(--cor-azul) !important;
    color: white !important;
  }
  .uk-offcanvas-bar .uk-nav-sub {
    background-color: #f8f9fa;
    margin: 10px 0;
    padding: 0 5px;
    display: none;
  }
  .uk-offcanvas-bar .uk-parent.uk-open .uk-nav-sub {
    display: block;
  }
  .uk-offcanvas-bar .uk-nav-sub > li > a {
    padding-left: 50px;
    font-size: 14px;
    font-weight: 400;
    color: #666 !important;
    border-bottom: none;
  }
  .uk-offcanvas-bar .uk-nav-sub > li > a:hover {
    background-color: #e9ecef;
    color: var(--cor-azul) !important;
  }
  .uk-offcanvas-bar .uk-nav-sub > li.uk-active > a {
    font-size: 18px;
    color: var(--cor-azul) !important;
    text-decoration: underline;
  }
  .mobile-menu-icon {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    opacity: 0.7;
  }
  .uk-offcanvas-bar .uk-nav-divider {
    margin: 20px 0;
    border-top: 1px solid #e9ecef;
  }
  .uk-navbar {
    min-height: 60px !important;
  }
  .uk-offcanvas-bar .uk-nav-default > li.uk-active > a {
    font-weight: 700;
  }
  .uk-offcanvas-bar .uk-nav-sub > li.uk-active > a {
    font-weight: 600;
  }
}
@media (max-width: 959px) {
  .uk-offcanvas-bar a {
    min-height: 30px;
    display: flex;
    align-items: center;
  }
}
.uk-text-extra-small {
  font-size: 12px !important;
}
.uk-width-large {
  width: 355px !important;
}
.uk-background-secondary {
  background-color: #25367e17 !important;
}
.uk-text-medium {
  font-size: 16px !important;
}
.uk-modal-dialog.uk-modal-body {
  padding: 2rem !important;
}
.uk-modal-title {
  font-size: 20px !important;
  text-align: center !important;
  color: var(--cor-azul) !important;
}
.borda-esquerda {
  border-left: 12px solid #06337A;
  border-radius: 10px;
}
.progresso-barra {
  background-color: #eee;
}
.progresso-barra::-webkit-progress-value {
  background-color: #16A34A;
}
.progresso-barra::-moz-progress-bar {
  background-color: #16A34A;
}
.progresso-barra::-ms-fill {
  background-color: #16A34A;
}
.progresso-barra::-webkit-progress-bar {
  background-color: #eee;
}
.background-warning {
  background-color: #FAA669 !important;
}
.apexcharts-legend {
  overflow: hidden !important;
}
.uk-opacity-50 {
  opacity: 0.5;
}
`, "",{"version":3,"sources":["https:/fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap","webpack://./src/styles/index.less","webpack://./src/styles/padding.less","webpack://./src/styles/margin.less","webpack://./src/styles/width.less","webpack://./src/styles/icons.less"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2GAAA;ACCF;ADCA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2GAAA;ACCF;ADCA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2GAAA;ACCF;ADCA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2GAAA;ACCF;ADCA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2GAAA;ACCF;ADCA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2GAAA;ACCF;ADCA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2GAAA;ACCF;ADCA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2GAAA;ACCF;ADCA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2GAAA;ACCF;ACbA;EAhDI,wBAAA;ADgEJ;ACfA;EAjDI,kBAAA;ADmEJ;ACjBA;EAlDI,kBAAA;ADsEJ;ACnBA;EAnDI,kBAAA;ADyEJ;ACrBA;EApDI,kBAAA;AD4EJ;ACvBA;EArDI,cAAA;AD+EJ;ACzBA;EAtDI,cAAA;ADkFJ;AC1BA;EAxDI,wBAAA;ADqFJ;AC3BA;EA1DI,4BAAA;ADwFJ;AC7BA;EA3DI,mBAAA;AD2FJ;AC/BA;EA5DI,mBAAA;AD8FJ;ACjCA;EA7DI,mBAAA;ADiGJ;ACnCA;EA9DI,mBAAA;ADoGJ;ACrCA;EA/DI,eAAA;ADuGJ;ACvCA;EAhEI,eAAA;AD0GJ;ACxCA;EAlEI,4BAAA;AD6GJ;AC1CA;EAnEI,mBAAA;ADgHJ;AC5CA;EApEI,mBAAA;ADmHJ;AC9CA;EArEI,mBAAA;ADsHJ;AChDA;EAtEI,mBAAA;ADyHJ;AClDA;EAvEI,eAAA;AD4HJ;ACpDA;EAxEI,eAAA;AD+HJ;ACrDA;EA1EI,4BAAA;ADkIJ;ACvDA;EA3EI,mBAAA;ADqIJ;ACzDA;EA5EI,mBAAA;ADwIJ;AC3DA;EA7EI,mBAAA;AD2IJ;AC7DA;EA9EI,mBAAA;AD8IJ;AC/DA;EA/EI,eAAA;ADiJJ;ACjEA;EAhFI,eAAA;ADoJJ;AClEA;EAlFI,4BAAA;ADuJJ;ACpEA;EAnFI,mBAAA;AD0JJ;ACtEA;EApFI,mBAAA;AD6JJ;ACxEA;EArFI,mBAAA;ADgKJ;AC1EA;EAtFI,mBAAA;ADmKJ;AC5EA;EAvFI,eAAA;ADsKJ;AC9EA;EAxFI,eAAA;ADyKJ;AC/EA;EA1FI,gBAAA;AD4KJ;ACjFA;EAAsB,cAAA;ADoFtB;ACnFA;EAAwB,gBAAA;ADsFxB;ACrFA;EAAuB,eAAA;ADwFvB;ACvFA;EAAyB,iBAAA;AD0FzB;ACzFA;EAA2B,cAAA;EAAgB,iBAAA;AD6F3C;AC5FA;EAA6B,eAAA;EAAiB,gBAAA;ADgG9C;AC9FA;EAAsB,iBAAA;ADiGtB;AC/FA;EAAqB,iBAAA;ADkGrB;AChGA;EACI;IAvGA,wBAAA;ED0MF;EClGE;IAxGA,kBAAA;ED6MF;ECpGE;IAzGA,kBAAA;EDgNF;ECtGE;IA1GA,kBAAA;EDmNF;ECxGE;IA3GA,kBAAA;EDsNF;EC1GE;IA5GA,cAAA;EDyNF;EC5GE;IA7GA,cAAA;ED4NF;EC7GE;IA/GA,4BAAA;ED+NF;EC/GE;IAhHA,mBAAA;EDkOF;ECjHE;IAjHA,mBAAA;EDqOF;ECnHE;IAlHA,mBAAA;EDwOF;ECrHE;IAnHA,mBAAA;ED2OF;ECvHE;IApHA,eAAA;ED8OF;ECzHE;IArHA,eAAA;EDiPF;EC1HE;IAvHA,4BAAA;EDoPF;EC5HE;IAxHA,mBAAA;EDuPF;EC9HE;IAzHA,mBAAA;ED0PF;EChIE;IA1HA,mBAAA;ED6PF;EClIE;IA3HA,mBAAA;EDgQF;ECpIE;IA5HA,eAAA;EDmQF;ECtIE;IA7HA,eAAA;EDsQF;ECvIE;IA/HA,4BAAA;EDyQF;ECzIE;IAhIA,mBAAA;ED4QF;EC3IE;IAjIA,mBAAA;ED+QF;EC7IE;IAlIA,mBAAA;EDkRF;EC/IE;IAnIA,mBAAA;EDqRF;ECjJE;IApIA,eAAA;EDwRF;ECnJE;IArIA,eAAA;ED2RF;ECpJE;IAvIA,4BAAA;ED8RF;ECtJE;IAxIA,mBAAA;EDiSF;ECxJE;IAzIA,mBAAA;EDoSF;EC1JE;IA1IA,mBAAA;EDuSF;EC5JE;IA3IA,mBAAA;ED0SF;EC9JE;IA5IA,eAAA;ED6SF;EChKE;IA7IA,eAAA;EDgTF;ECjKE;IA/IA,gBAAA;EDmTF;ECnKE;IAA0B,cAAA;EDsK5B;ECrKE;IAA4B,gBAAA;EDwK9B;ECvKE;IAA2B,eAAA;ED0K7B;ECzKE;IAA6B,iBAAA;ED4K/B;EC3KE;IAA+B,cAAA;IAAgB,iBAAA;ED+KjD;EC9KE;IAAiC,eAAA;IAAiB,gBAAA;EDkLpD;AACF;AChLA;EACI;IAzJA,wBAAA;ED4UF;EClLE;IA1JA,kBAAA;ED+UF;ECpLE;IA3JA,kBAAA;EDkVF;ECtLE;IA5JA,kBAAA;EDqVF;ECxLE;IA7JA,kBAAA;EDwVF;EC1LE;IA9JA,cAAA;ED2VF;EC5LE;IA/JA,cAAA;ED8VF;EC7LE;IAjKA,4BAAA;EDiWF;EC/LE;IAlKA,mBAAA;EDoWF;ECjME;IAnKA,mBAAA;EDuWF;ECnME;IApKA,mBAAA;ED0WF;ECrME;IArKA,mBAAA;ED6WF;ECvME;IAtKA,eAAA;EDgXF;ECzME;IAvKA,eAAA;EDmXF;EC1ME;IAzKA,4BAAA;EDsXF;EC5ME;IA1KA,mBAAA;EDyXF;EC9ME;IA3KA,mBAAA;ED4XF;EChNE;IA5KA,mBAAA;ED+XF;EClNE;IA7KA,mBAAA;EDkYF;ECpNE;IA9KA,eAAA;EDqYF;ECtNE;IA/KA,eAAA;EDwYF;ECvNE;IAjLA,4BAAA;ED2YF;ECzNE;IAlLA,mBAAA;ED8YF;EC3NE;IAnLA,mBAAA;EDiZF;EC7NE;IApLA,mBAAA;EDoZF;EC/NE;IArLA,mBAAA;EDuZF;ECjOE;IAtLA,eAAA;ED0ZF;ECnOE;IAvLA,eAAA;ED6ZF;ECpOE;IAzLA,4BAAA;EDgaF;ECtOE;IA1LA,mBAAA;EDmaF;ECxOE;IA3LA,mBAAA;EDsaF;EC1OE;IA5LA,mBAAA;EDyaF;EC5OE;IA7LA,mBAAA;ED4aF;EC9OE;IA9LA,eAAA;ED+aF;EChPE;IA/LA,eAAA;EDkbF;ECjPE;IAjMA,gBAAA;EDqbF;ECnPE;IAAyB,cAAA;EDsP3B;ECrPE;IAA2B,gBAAA;EDwP7B;ECvPE;IAA0B,eAAA;ED0P5B;ECzPE;IAA4B,iBAAA;ED4P9B;EC3PE;IAA8B,cAAA;IAAgB,iBAAA;ED+PhD;EC9PE;IAAgC,eAAA;IAAiB,gBAAA;EDkQnD;AACF;AChQA;EACI;IA3MA,wBAAA;ED8cF;EClQE;IA5MA,kBAAA;EDidF;ECpQE;IA7MA,kBAAA;EDodF;ECtQE;IA9MA,kBAAA;EDudF;ECxQE;IA/MA,kBAAA;ED0dF;EC1QE;IAhNA,cAAA;ED6dF;EC5QE;IAjNA,cAAA;EDgeF;EC7QE;IAnNA,4BAAA;EDmeF;EC/QE;IApNA,mBAAA;EDseF;ECjRE;IArNA,mBAAA;EDyeF;ECnRE;IAtNA,mBAAA;ED4eF;ECrRE;IAvNA,mBAAA;ED+eF;ECvRE;IAxNA,eAAA;EDkfF;ECzRE;IAzNA,eAAA;EDqfF;EC1RE;IA3NA,4BAAA;EDwfF;EC5RE;IA5NA,mBAAA;ED2fF;EC9RE;IA7NA,mBAAA;ED8fF;EChSE;IA9NA,mBAAA;EDigBF;EClSE;IA/NA,mBAAA;EDogBF;ECpSE;IAhOA,eAAA;EDugBF;ECtSE;IAjOA,eAAA;ED0gBF;ECvSE;IAnOA,4BAAA;ED6gBF;ECzSE;IApOA,mBAAA;EDghBF;EC3SE;IArOA,mBAAA;EDmhBF;EC7SE;IAtOA,mBAAA;EDshBF;EC/SE;IAvOA,mBAAA;EDyhBF;ECjTE;IAxOA,eAAA;ED4hBF;ECnTE;IAzOA,eAAA;ED+hBF;ECpTE;IA3OA,4BAAA;EDkiBF;ECtTE;IA5OA,mBAAA;EDqiBF;ECxTE;IA7OA,mBAAA;EDwiBF;EC1TE;IA9OA,mBAAA;ED2iBF;EC5TE;IA/OA,mBAAA;ED8iBF;EC9TE;IAhPA,eAAA;EDijBF;EChUE;IAjPA,eAAA;EDojBF;ECjUE;IAnPA,gBAAA;EDujBF;ECnUE;IAAyB,cAAA;EDsU3B;ECrUE;IAA2B,gBAAA;EDwU7B;ECvUE;IAA0B,eAAA;ED0U5B;ECzUE;IAA4B,iBAAA;ED4U9B;EC3UE;IAA8B,cAAA;IAAgB,iBAAA;ED+UhD;EC9UE;IAAgC,eAAA;IAAiB,gBAAA;EDkVnD;EChVE;IAAsB,iBAAA;EDmVxB;EClVE;IAAyB,iBAAA;EDqV3B;ECnVE;IAAqB,iBAAA;EDsVvB;ECrVE;IAAwB,iBAAA;EDwV1B;AACF;ACtVA;EACI;IAnQA,wBAAA;ED4lBF;ECxVE;IApQA,kBAAA;ED+lBF;EC1VE;IArQA,kBAAA;EDkmBF;EC5VE;IAtQA,kBAAA;EDqmBF;EC9VE;IAvQA,kBAAA;EDwmBF;EChWE;IAxQA,cAAA;ED2mBF;EClWE;IAzQA,cAAA;ED8mBF;ECnWE;IA3QA,4BAAA;EDinBF;ECrWE;IA5QA,mBAAA;EDonBF;ECvWE;IA7QA,mBAAA;EDunBF;ECzWE;IA9QA,mBAAA;ED0nBF;EC3WE;IA/QA,mBAAA;ED6nBF;EC7WE;IAhRA,eAAA;EDgoBF;EC/WE;IAjRA,eAAA;EDmoBF;EChXE;IAnRA,4BAAA;EDsoBF;EClXE;IApRA,mBAAA;EDyoBF;ECpXE;IArRA,mBAAA;ED4oBF;ECtXE;IAtRA,mBAAA;ED+oBF;ECxXE;IAvRA,mBAAA;EDkpBF;EC1XE;IAxRA,eAAA;EDqpBF;EC5XE;IAzRA,eAAA;EDwpBF;EC7XE;IA3RA,4BAAA;ED2pBF;EC/XE;IA5RA,mBAAA;ED8pBF;ECjYE;IA7RA,mBAAA;EDiqBF;ECnYE;IA9RA,mBAAA;EDoqBF;ECrYE;IA/RA,mBAAA;EDuqBF;ECvYE;IAhSA,eAAA;ED0qBF;ECzYE;IAjSA,eAAA;ED6qBF;EC1YE;IAnSA,4BAAA;EDgrBF;EC5YE;IApSA,mBAAA;EDmrBF;EC9YE;IArSA,mBAAA;EDsrBF;EChZE;IAtSA,mBAAA;EDyrBF;EClZE;IAvSA,mBAAA;ED4rBF;ECpZE;IAxSA,eAAA;ED+rBF;ECtZE;IAzSA,eAAA;EDksBF;ECvZE;IA3SA,gBAAA;EDqsBF;ECzZE;IAAyB,cAAA;ED4Z3B;EC3ZE;IAA2B,gBAAA;ED8Z7B;EC7ZE;IAA0B,eAAA;EDga5B;EC/ZE;IAA4B,iBAAA;EDka9B;ECjaE;IAA8B,cAAA;IAAgB,iBAAA;EDqahD;ECpaE;IAAgC,eAAA;IAAiB,gBAAA;EDwanD;ECtaE;IAAwB,iBAAA;EDya1B;AACF;ACvaA;EACI;IAvTA,wBAAA;EDiuBF;ECzaE;IAxTA,kBAAA;EDouBF;EC3aE;IAzTA,kBAAA;EDuuBF;EC7aE;IA1TA,kBAAA;ED0uBF;EC/aE;IA3TA,kBAAA;ED6uBF;ECjbE;IA5TA,cAAA;EDgvBF;ECnbE;IA7TA,cAAA;EDmvBF;ECpbE;IA/TA,4BAAA;EDsvBF;ECtbE;IAhUA,mBAAA;EDyvBF;ECxbE;IAjUA,mBAAA;ED4vBF;EC1bE;IAlUA,mBAAA;ED+vBF;EC5bE;IAnUA,mBAAA;EDkwBF;EC9bE;IApUA,eAAA;EDqwBF;EChcE;IArUA,eAAA;EDwwBF;ECjcE;IAvUA,4BAAA;ED2wBF;ECncE;IAxUA,mBAAA;ED8wBF;ECrcE;IAzUA,mBAAA;EDixBF;ECvcE;IA1UA,mBAAA;EDoxBF;ECzcE;IA3UA,mBAAA;EDuxBF;EC3cE;IA5UA,eAAA;ED0xBF;EC7cE;IA7UA,eAAA;ED6xBF;EC9cE;IA/UA,4BAAA;EDgyBF;EChdE;IAhVA,mBAAA;EDmyBF;ECldE;IAjVA,mBAAA;EDsyBF;ECpdE;IAlVA,mBAAA;EDyyBF;ECtdE;IAnVA,mBAAA;ED4yBF;ECxdE;IApVA,eAAA;ED+yBF;EC1dE;IArVA,eAAA;EDkzBF;EC3dE;IAvVA,4BAAA;EDqzBF;EC7dE;IAxVA,mBAAA;EDwzBF;EC/dE;IAzVA,mBAAA;ED2zBF;ECjeE;IA1VA,mBAAA;ED8zBF;ECneE;IA3VA,mBAAA;EDi0BF;ECreE;IA5VA,eAAA;EDo0BF;ECveE;IA7VA,eAAA;EDu0BF;ECxeE;IA/VA,gBAAA;ED00BF;ECzeE;IAjWA,gBAAA;ED60BF;EC3eE;IAA0B,cAAA;ED8e5B;EC7eE;IAA4B,gBAAA;EDgf9B;EC/eE;IAA2B,eAAA;EDkf7B;ECjfE;IAA6B,iBAAA;EDof/B;ECnfE;IAA+B,cAAA;IAAgB,iBAAA;EDufjD;ECtfE;IAAiC,eAAA;IAAiB,gBAAA;ED0fpD;ECxfE;IAAsB,iBAAA;ED2fxB;EC1fE;IAAyB,iBAAA;ED6f3B;EC3fE;IAAqB,iBAAA;ED8fvB;EC7fE;IAAwB,iBAAA;EDggB1B;EC/fE;IAAwB,iBAAA;EDkgB1B;AACF;AEl3BA;EACI;IACI,4BAAA;EFo3BN;EEl3BE;IACI,wBAAA;EFo3BN;EEl3BE;IACI,oBAAA;EFo3BN;AACF;AEj3BA;EACI;IACI,wBAAA;EFm3BN;EEj3BE;IACI,oBAAA;EFm3BN;AACF;AEh3BA;EACI;IACI,wBAAA;EFk3BN;EEh3BE;IACI,oBAAA;EFk3BN;AACF;AE/2BA;EACI;IACI,wBAAA;EFi3BN;EE/2BE;IACI,oBAAA;EFi3BN;AACF;AEj1BA;EA5BI,eAAA;AFg3BJ;AEn1BA;EAAqB,aAAA;AFs1BrB;AEp1BA;EA/BI,uBAAA;AFs3BJ;AEt1BA;EAhCI,iBAAA;AFy3BJ;AEx1BA;EAjCI,iBAAA;AF43BJ;AE11BA;EAlCI,iBAAA;AF+3BJ;AE51BA;EAnCI,iBAAA;AFk4BJ;AE91BA;EApCI,aAAA;AFq4BJ;AEh2BA;EArCI,aAAA;AFw4BJ;AEj2BA;EAvCI,2BAAA;AF24BJ;AEn2BA;EAxCI,kBAAA;AF84BJ;AEr2BA;EAzCI,kBAAA;AFi5BJ;AEv2BA;EA1CI,kBAAA;AFo5BJ;AEz2BA;EA3CI,kBAAA;AFu5BJ;AE32BA;EA5CI,cAAA;AF05BJ;AE72BA;EA7CI,cAAA;AF65BJ;AE92BA;EA/CI,qBAAA;AFg6BJ;AE/2BA;EACI;IAlDA,eAAA;EFo6BF;EEj3BE;IAAyB,aAAA;EFo3B3B;EEn3BE;IAA4B,gBAAA;EFs3B9B;EEr3BE;IAA0B,cAAA;EFw3B5B;EEv3BE;IAA2B,eAAA;EF03B7B;EEx3BE;IAxDA,uBAAA;EFm7BF;EE13BE;IAzDA,iBAAA;EFs7BF;EE53BE;IA1DA,iBAAA;EFy7BF;EE93BE;IA3DA,iBAAA;EF47BF;EEh4BE;IA5DA,iBAAA;EF+7BF;EEl4BE;IA7DA,aAAA;EFk8BF;EEp4BE;IA9DA,aAAA;EFq8BF;EEr4BE;IAhEA,2BAAA;EFw8BF;EEv4BE;IAjEA,kBAAA;EF28BF;EEz4BE;IAlEA,kBAAA;EF88BF;EE34BE;IAnEA,kBAAA;EFi9BF;EE74BE;IApEA,kBAAA;EFo9BF;EE/4BE;IArEA,cAAA;EFu9BF;EEj5BE;IAtEA,cAAA;EF09BF;AACF;AEl5BA;EACI;IA1EA,eAAA;EF+9BF;EEp5BE;IAAwB,aAAA;EFu5B1B;EEt5BE;IAA2B,gBAAA;EFy5B7B;EEx5BE;IAAyB,cAAA;EF25B3B;EE15BE;IAA0B,eAAA;EF65B5B;EE35BE;IAhFA,uBAAA;EF8+BF;EE75BE;IAjFA,iBAAA;EFi/BF;EE/5BE;IAlFA,iBAAA;EFo/BF;EEj6BE;IAnFA,iBAAA;EFu/BF;EEn6BE;IApFA,iBAAA;EF0/BF;EEr6BE;IArFA,aAAA;EF6/BF;EEv6BE;IAtFA,aAAA;EFggCF;EEx6BE;IAxFA,2BAAA;EFmgCF;EE16BE;IAzFA,kBAAA;EFsgCF;EE56BE;IA1FA,kBAAA;EFygCF;EE96BE;IA3FA,kBAAA;EF4gCF;EEh7BE;IA5FA,kBAAA;EF+gCF;EEl7BE;IA7FA,cAAA;EFkhCF;EEp7BE;IA9FA,cAAA;EFqhCF;EEr7BE;IAhGA,kBAAA;EFwhCF;EEt7BE;IAlGA,kBAAA;EF2hCF;AACF;AGpkCA;EACI,UAAA;AHskCJ;AGnkCA;EACI,YAAA;AHqkCJ;AGlkCA;EACI,WAAA;AHokCJ;AGjkCA;EACI,WAAA;AHmkCJ;AGhkCA;EACI;IACI,YAAA;EHkkCN;EG/jCE;IACI,YAAA;EHikCN;EG9jCE;IACI,YAAA;EHgkCN;EG7jCE;IACI,YAAA;EH+jCN;EG5jCE;IACI,WAAA;EH8jCN;EG3jCE;IACI,WAAA;EH6jCN;AACF;AG1jCA;EACI;IACI,YAAA;EH4jCN;EGzjCE;IACI,YAAA;EH2jCN;EGxjCE;IACI,YAAA;EH0jCN;EGvjCE;IACI,YAAA;EHyjCN;EGtjCE;IACI,WAAA;EHwjCN;EGrjCE;IACI,WAAA;EHujCN;AACF;AGpjCA;EACI;IACI,YAAA;EHsjCN;EGnjCE;IACI,YAAA;EHqjCN;EGljCE;IACI,YAAA;EHojCN;EGjjCE;IACI,YAAA;EHmjCN;EGhjCE;IACI,YAAA;EHkjCN;EG/iCE;IACI,WAAA;EHijCN;AACF;AGziCA;EAHI,aAAA;AH+iCJ;AG3iCA;EAJI,aAAA;AHkjCJ;AG5iCA;EACI;IAPA,aAAA;EHsjCF;EG9iCE;IARA,aAAA;EHyjCF;AACF;AG/iCA;EACI;IAZA,aAAA;EH8jCF;EGjjCE;IAbA,aAAA;EHikCF;EGnjCE;IAdA,aAAA;EHokCF;AACF;AGpjCA;EACI;IAlBA,aAAA;EHykCF;EGtjCE;IAnBA,aAAA;EH4kCF;EGxjCE;IApBA,aAAA;EH+kCF;EG1jCE;IArBA,aAAA;EHklCF;AACF;AG3jCA;EACI;IAzBA,aAAA;EHulCF;EG7jCE;IA1BA,aAAA;EH0lCF;EG/jCE;IA3BA,aAAA;EH6lCF;EGjkCE;IA5BA,aAAA;EHgmCF;EGnkCE;IA7BA,aAAA;EHmmCF;EGrkCE;IA9BA,aAAA;EHsmCF;AACF;AGnkCS;EACG,WAAA;AHqkCZ;AGtkCS;EACG,mBAAA;AHwkCZ;AGzkCS;EACG,mBAAA;AH2kCZ;AG5kCS;EACG,UAAA;AH8kCZ;AG/kCS;EACG,mBAAA;AHilCZ;AGllCS;EACG,mBAAA;AHolCZ;AGrlCS;EACG,WAAA;AHulCZ;AGxlCS;EACG,YAAA;AH0lCZ;AG3lCS;EACG,UAAA;AH6lCZ;AG9lCS;EACG,YAAA;AHgmCZ;AGjmCS;EACG,UAAA;AHmmCZ;AGpmCS;EACG,YAAA;AHsmCZ;AGvmCS;EACG,UAAA;AHymCZ;AG1mCS;EACG,YAAA;AH4mCZ;AG7mCS;EACG,WAAA;AH+mCZ;AGhnCS;EACG,mBAAA;AHknCZ;AGnnCS;EACG,mBAAA;AHqnCZ;AGtnCS;EACG,UAAA;AHwnCZ;AGznCS;EACG,mBAAA;AH2nCZ;AG5nCS;EACG,mBAAA;AH8nCZ;AG/nCS;EACG,UAAA;AHioCZ;AGloCS;EACG,mBAAA;AHooCZ;AGroCS;EACG,mBAAA;AHuoCZ;AGxoCS;EACG,UAAA;AH0oCZ;AG3oCS;EACG,mBAAA;AH6oCZ;AG9oCS;EACG,kBAAA;AHgpCZ;AGjpCS;EACG,WAAA;AHmpCZ;AGppCS;EACG,UAAA;AHspCZ;AGvpCS;EACG,UAAA;AHypCZ;AG1pCS;EACG,UAAA;AH4pCZ;AG7pCS;EACG,UAAA;AH+pCZ;AGhqCS;EACG,UAAA;AHkqCZ;AGnqCS;EACG,UAAA;AHqqCZ;AGtqCS;EACG,UAAA;AHwqCZ;AGzqCS;EACG,UAAA;AH2qCZ;AG5qCS;EACG,UAAA;AH8qCZ;AG/qCS;EACG,UAAA;AHirCZ;AGlrCS;EACG,UAAA;AHorCZ;AGrrCS;EACG,UAAA;AHurCZ;AGxrCS;EACG,UAAA;AH0rCZ;AG3rCS;EACG,UAAA;AH6rCZ;AG9rCS;EACG,UAAA;AHgsCZ;AGjsCS;EACG,UAAA;AHmsCZ;AGpsCS;EACG,UAAA;AHssCZ;AGvsCS;EACG,UAAA;AHysCZ;AG1sCS;EACG,SAAA;AH4sCZ;AGjrCS;EACG,YAAA;AHmrCZ;AGprCS;EACG,YAAA;AHsrCZ;AGvrCS;EACG,YAAA;AHyrCZ;AG1rCS;EACG,YAAA;AH4rCZ;AG7rCS;EACG,YAAA;AH+rCZ;AGhsCS;EACG,YAAA;AHksCZ;AGnsCS;EACG,YAAA;AHqsCZ;AGtsCS;EACG,YAAA;AHwsCZ;AGzsCS;EACG,YAAA;AH2sCZ;AG5sCS;EACG,YAAA;AH8sCZ;AG/sCS;EACG,YAAA;AHitCZ;AGltCS;EACG,YAAA;AHotCZ;AGrtCS;EACG,YAAA;AHutCZ;AGxtCS;EACG,YAAA;AH0tCZ;AG3tCS;EACG,YAAA;AH6tCZ;AG9tCS;EACG,YAAA;AHguCZ;AGjuCS;EACG,YAAA;AHmuCZ;AGpuCS;EACG,YAAA;AHsuCZ;AGvuCS;EACG,YAAA;AHyuCZ;AG1uCS;EACG,YAAA;AH4uCZ;AG7uCS;EACG,YAAA;AH+uCZ;AGhvCS;EACG,YAAA;AHkvCZ;AGnvCS;EACG,YAAA;AHqvCZ;AGtvCS;EACG,YAAA;AHwvCZ;AGzvCS;EACG,YAAA;AH2vCZ;AG5vCS;EACG,YAAA;AH8vCZ;AG/vCS;EACG,YAAA;AHiwCZ;AGlwCS;EACG,YAAA;AHowCZ;AGrwCS;EACG,YAAA;AHuwCZ;AGxwCS;EACG,YAAA;AH0wCZ;AG3wCS;EACG,YAAA;AH6wCZ;AG9wCS;EACG,YAAA;AHgxCZ;AGjxCS;EACG,YAAA;AHmxCZ;AGpxCS;EACG,YAAA;AHsxCZ;AGvxCS;EACG,YAAA;AHyxCZ;AG1xCS;EACG,YAAA;AH4xCZ;AG7xCS;EACG,YAAA;AH+xCZ;AGhyCS;EACG,YAAA;AHkyCZ;AGnyCS;EACG,YAAA;AHqyCZ;AGtyCS;EACG,YAAA;AHwyCZ;AGzyCS;EACG,YAAA;AH2yCZ;AG5yCS;EACG,YAAA;AH8yCZ;AG/yCS;EACG,YAAA;AHizCZ;AGlzCS;EACG,YAAA;AHozCZ;AGrzCS;EACG,YAAA;AHuzCZ;AGxzCS;EACG,YAAA;AH0zCZ;AG3zCS;EACG,YAAA;AH6zCZ;AG9zCS;EACG,YAAA;AHg0CZ;AGj0CS;EACG,YAAA;AHm0CZ;AGp0CS;EACG,YAAA;AHs0CZ;AGv0CS;EACG,YAAA;AHy0CZ;AG10CS;EACG,YAAA;AH40CZ;AG70CS;EACG,YAAA;AH+0CZ;AGh1CS;EACG,YAAA;AHk1CZ;AGn1CS;EACG,YAAA;AHq1CZ;AGt1CS;EACG,YAAA;AHw1CZ;AGz1CS;EACG,YAAA;AH21CZ;AG51CS;EACG,YAAA;AH81CZ;AG/1CS;EACG,YAAA;AHi2CZ;AGl2CS;EACG,YAAA;AHo2CZ;AGr2CS;EACG,YAAA;AHu2CZ;AGx2CS;EACG,YAAA;AH02CZ;AG32CS;EACG,YAAA;AH62CZ;AG92CS;EACG,YAAA;AHg3CZ;AGj3CS;EACG,YAAA;AHm3CZ;AGp3CS;EACG,YAAA;AHs3CZ;AGv3CS;EACG,YAAA;AHy3CZ;AG13CS;EACG,YAAA;AH43CZ;AG73CS;EACG,YAAA;AH+3CZ;AGh4CS;EACG,YAAA;AHk4CZ;AGn4CS;EACG,YAAA;AHq4CZ;AGt4CS;EACG,YAAA;AHw4CZ;AGz4CS;EACG,YAAA;AH24CZ;AG54CS;EACG,YAAA;AH84CZ;AG/4CS;EACG,YAAA;AHi5CZ;AGl5CS;EACG,YAAA;AHo5CZ;AGr5CS;EACG,YAAA;AHu5CZ;AGx5CS;EACG,YAAA;AH05CZ;AG35CS;EACG,YAAA;AH65CZ;AG95CS;EACG,YAAA;AHg6CZ;AGj6CS;EACG,YAAA;AHm6CZ;AGp6CS;EACG,YAAA;AHs6CZ;AGv6CS;EACG,YAAA;AHy6CZ;AG16CS;EACG,YAAA;AH46CZ;AG76CS;EACG,YAAA;AH+6CZ;AGh7CS;EACG,YAAA;AHk7CZ;AGn7CS;EACG,YAAA;AHq7CZ;AGt7CS;EACG,YAAA;AHw7CZ;AGz7CS;EACG,YAAA;AH27CZ;AG57CS;EACG,YAAA;AH87CZ;AG/7CS;EACG,YAAA;AHi8CZ;AGl8CS;EACG,YAAA;AHo8CZ;AGr8CS;EACG,YAAA;AHu8CZ;AGx8CS;EACG,YAAA;AH08CZ;AG38CS;EACG,YAAA;AH68CZ;AG98CS;EACG,YAAA;AHg9CZ;AGj9CS;EACG,YAAA;AHm9CZ;AGp9CS;EACG,YAAA;AHs9CZ;AGv9CS;EACG,YAAA;AHy9CZ;AG19CS;EACG,YAAA;AH49CZ;AG79CS;EACG,YAAA;AH+9CZ;AGh+CS;EACG,WAAA;AHk+CZ;AGn+CS;EACG,WAAA;AHq+CZ;AGt+CS;EACG,WAAA;AHw+CZ;AGz+CS;EACG,WAAA;AH2+CZ;AG5+CS;EACG,WAAA;AH8+CZ;AG/+CS;EACG,WAAA;AHi/CZ;AGl/CS;EACG,WAAA;AHo/CZ;AGr/CS;EACG,WAAA;AHu/CZ;AGx/CS;EACG,WAAA;AH0/CZ;AG3/CS;EACG,WAAA;AH6/CZ;AG9/CS;EACG,WAAA;AHggDZ;AGjgDS;EACG,WAAA;AHmgDZ;AGpgDS;EACG,WAAA;AHsgDZ;AGvgDS;EACG,WAAA;AHygDZ;AG1gDS;EACG,WAAA;AH4gDZ;AG7gDS;EACG,WAAA;AH+gDZ;AGhhDS;EACG,WAAA;AHkhDZ;AGnhDS;EACG,WAAA;AHqhDZ;AGthDS;EACG,UAAA;AHwhDZ;AGzgDA;EAhCS;IACG,WAAA;EH4iDV;EG7iDO;IACG,mBAAA;EH+iDV;EGhjDO;IACG,mBAAA;EHkjDV;EGnjDO;IACG,UAAA;EHqjDV;EGtjDO;IACG,mBAAA;EHwjDV;EGzjDO;IACG,mBAAA;EH2jDV;EG5jDO;IACG,WAAA;EH8jDV;EG/jDO;IACG,YAAA;EHikDV;EGlkDO;IACG,UAAA;EHokDV;EGrkDO;IACG,YAAA;EHukDV;EGxkDO;IACG,UAAA;EH0kDV;EG3kDO;IACG,YAAA;EH6kDV;EG9kDO;IACG,UAAA;EHglDV;EGjlDO;IACG,YAAA;EHmlDV;EGplDO;IACG,WAAA;EHslDV;EGvlDO;IACG,mBAAA;EHylDV;EG1lDO;IACG,mBAAA;EH4lDV;EG7lDO;IACG,UAAA;EH+lDV;EGhmDO;IACG,mBAAA;EHkmDV;EGnmDO;IACG,mBAAA;EHqmDV;EGtmDO;IACG,UAAA;EHwmDV;EGzmDO;IACG,mBAAA;EH2mDV;EG5mDO;IACG,mBAAA;EH8mDV;EG/mDO;IACG,UAAA;EHinDV;EGlnDO;IACG,mBAAA;EHonDV;EGrnDO;IACG,kBAAA;EHunDV;EGxnDO;IACG,WAAA;EH0nDV;EG3nDO;IACG,UAAA;EH6nDV;EG9nDO;IACG,UAAA;EHgoDV;EGjoDO;IACG,UAAA;EHmoDV;EGpoDO;IACG,UAAA;EHsoDV;EGvoDO;IACG,UAAA;EHyoDV;EG1oDO;IACG,UAAA;EH4oDV;EG7oDO;IACG,UAAA;EH+oDV;EGhpDO;IACG,UAAA;EHkpDV;EGnpDO;IACG,UAAA;EHqpDV;EGtpDO;IACG,UAAA;EHwpDV;EGzpDO;IACG,UAAA;EH2pDV;EG5pDO;IACG,UAAA;EH8pDV;EG/pDO;IACG,UAAA;EHiqDV;EGlqDO;IACG,UAAA;EHoqDV;EGrqDO;IACG,UAAA;EHuqDV;EGxqDO;IACG,UAAA;EH0qDV;EG3qDO;IACG,UAAA;EH6qDV;EG9qDO;IACG,UAAA;EHgrDV;EGjrDO;IACG,SAAA;EHmrDV;EGxqDO;IACG,YAAA;EH0qDV;EG3qDO;IACG,YAAA;EH6qDV;EG9qDO;IACG,YAAA;EHgrDV;EGjrDO;IACG,YAAA;EHmrDV;EGprDO;IACG,YAAA;EHsrDV;EGvrDO;IACG,YAAA;EHyrDV;EG1rDO;IACG,YAAA;EH4rDV;EG7rDO;IACG,YAAA;EH+rDV;EGhsDO;IACG,YAAA;EHksDV;EGnsDO;IACG,YAAA;EHqsDV;EGtsDO;IACG,YAAA;EHwsDV;EGzsDO;IACG,YAAA;EH2sDV;EG5sDO;IACG,YAAA;EH8sDV;EG/sDO;IACG,YAAA;EHitDV;EGltDO;IACG,YAAA;EHotDV;EGrtDO;IACG,YAAA;EHutDV;EGxtDO;IACG,YAAA;EH0tDV;EG3tDO;IACG,YAAA;EH6tDV;EG9tDO;IACG,YAAA;EHguDV;EGjuDO;IACG,YAAA;EHmuDV;EGpuDO;IACG,YAAA;EHsuDV;EGvuDO;IACG,YAAA;EHyuDV;EG1uDO;IACG,YAAA;EH4uDV;EG7uDO;IACG,YAAA;EH+uDV;EGhvDO;IACG,YAAA;EHkvDV;EGnvDO;IACG,YAAA;EHqvDV;EGtvDO;IACG,YAAA;EHwvDV;EGzvDO;IACG,YAAA;EH2vDV;EG5vDO;IACG,YAAA;EH8vDV;EG/vDO;IACG,YAAA;EHiwDV;EGlwDO;IACG,YAAA;EHowDV;EGrwDO;IACG,YAAA;EHuwDV;EGxwDO;IACG,YAAA;EH0wDV;EG3wDO;IACG,YAAA;EH6wDV;EG9wDO;IACG,YAAA;EHgxDV;EGjxDO;IACG,YAAA;EHmxDV;EGpxDO;IACG,YAAA;EHsxDV;EGvxDO;IACG,YAAA;EHyxDV;EG1xDO;IACG,YAAA;EH4xDV;EG7xDO;IACG,YAAA;EH+xDV;EGhyDO;IACG,YAAA;EHkyDV;EGnyDO;IACG,YAAA;EHqyDV;EGtyDO;IACG,YAAA;EHwyDV;EGzyDO;IACG,YAAA;EH2yDV;EG5yDO;IACG,YAAA;EH8yDV;EG/yDO;IACG,YAAA;EHizDV;EGlzDO;IACG,YAAA;EHozDV;EGrzDO;IACG,YAAA;EHuzDV;EGxzDO;IACG,YAAA;EH0zDV;EG3zDO;IACG,YAAA;EH6zDV;EG9zDO;IACG,YAAA;EHg0DV;EGj0DO;IACG,YAAA;EHm0DV;EGp0DO;IACG,YAAA;EHs0DV;EGv0DO;IACG,YAAA;EHy0DV;EG10DO;IACG,YAAA;EH40DV;EG70DO;IACG,YAAA;EH+0DV;EGh1DO;IACG,YAAA;EHk1DV;EGn1DO;IACG,YAAA;EHq1DV;EGt1DO;IACG,YAAA;EHw1DV;EGz1DO;IACG,YAAA;EH21DV;EG51DO;IACG,YAAA;EH81DV;EG/1DO;IACG,YAAA;EHi2DV;EGl2DO;IACG,YAAA;EHo2DV;EGr2DO;IACG,YAAA;EHu2DV;EGx2DO;IACG,YAAA;EH02DV;EG32DO;IACG,YAAA;EH62DV;EG92DO;IACG,YAAA;EHg3DV;EGj3DO;IACG,YAAA;EHm3DV;EGp3DO;IACG,YAAA;EHs3DV;EGv3DO;IACG,YAAA;EHy3DV;EG13DO;IACG,YAAA;EH43DV;EG73DO;IACG,YAAA;EH+3DV;EGh4DO;IACG,YAAA;EHk4DV;EGn4DO;IACG,YAAA;EHq4DV;EGt4DO;IACG,YAAA;EHw4DV;EGz4DO;IACG,YAAA;EH24DV;EG54DO;IACG,YAAA;EH84DV;EG/4DO;IACG,YAAA;EHi5DV;EGl5DO;IACG,YAAA;EHo5DV;EGr5DO;IACG,YAAA;EHu5DV;EGx5DO;IACG,YAAA;EH05DV;EG35DO;IACG,YAAA;EH65DV;EG95DO;IACG,YAAA;EHg6DV;EGj6DO;IACG,YAAA;EHm6DV;EGp6DO;IACG,YAAA;EHs6DV;EGv6DO;IACG,YAAA;EHy6DV;EG16DO;IACG,YAAA;EH46DV;EG76DO;IACG,YAAA;EH+6DV;EGh7DO;IACG,YAAA;EHk7DV;EGn7DO;IACG,YAAA;EHq7DV;EGt7DO;IACG,YAAA;EHw7DV;EGz7DO;IACG,YAAA;EH27DV;EG57DO;IACG,YAAA;EH87DV;EG/7DO;IACG,YAAA;EHi8DV;EGl8DO;IACG,YAAA;EHo8DV;EGr8DO;IACG,YAAA;EHu8DV;EGx8DO;IACG,YAAA;EH08DV;EG38DO;IACG,YAAA;EH68DV;EG98DO;IACG,YAAA;EHg9DV;EGj9DO;IACG,YAAA;EHm9DV;EGp9DO;IACG,YAAA;EHs9DV;EGv9DO;IACG,WAAA;EHy9DV;EG19DO;IACG,WAAA;EH49DV;EG79DO;IACG,WAAA;EH+9DV;EGh+DO;IACG,WAAA;EHk+DV;EGn+DO;IACG,WAAA;EHq+DV;EGt+DO;IACG,WAAA;EHw+DV;EGz+DO;IACG,WAAA;EH2+DV;EG5+DO;IACG,WAAA;EH8+DV;EG/+DO;IACG,WAAA;EHi/DV;EGl/DO;IACG,WAAA;EHo/DV;EGr/DO;IACG,WAAA;EHu/DV;EGx/DO;IACG,WAAA;EH0/DV;EG3/DO;IACG,WAAA;EH6/DV;EG9/DO;IACG,WAAA;EHggEV;EGjgEO;IACG,WAAA;EHmgEV;EGpgEO;IACG,WAAA;EHsgEV;EGvgEO;IACG,WAAA;EHygEV;EG1gEO;IACG,WAAA;EH4gEV;EG7gEO;IACG,UAAA;EH+gEV;AACF;AGr/DA;EAxCS;IACG,WAAA;EHgiEV;EGjiEO;IACG,mBAAA;EHmiEV;EGpiEO;IACG,mBAAA;EHsiEV;EGviEO;IACG,UAAA;EHyiEV;EG1iEO;IACG,mBAAA;EH4iEV;EG7iEO;IACG,mBAAA;EH+iEV;EGhjEO;IACG,WAAA;EHkjEV;EGnjEO;IACG,YAAA;EHqjEV;EGtjEO;IACG,UAAA;EHwjEV;EGzjEO;IACG,YAAA;EH2jEV;EG5jEO;IACG,UAAA;EH8jEV;EG/jEO;IACG,YAAA;EHikEV;EGlkEO;IACG,UAAA;EHokEV;EGrkEO;IACG,YAAA;EHukEV;EGxkEO;IACG,WAAA;EH0kEV;EG3kEO;IACG,mBAAA;EH6kEV;EG9kEO;IACG,mBAAA;EHglEV;EGjlEO;IACG,UAAA;EHmlEV;EGplEO;IACG,mBAAA;EHslEV;EGvlEO;IACG,mBAAA;EHylEV;EG1lEO;IACG,UAAA;EH4lEV;EG7lEO;IACG,mBAAA;EH+lEV;EGhmEO;IACG,mBAAA;EHkmEV;EGnmEO;IACG,UAAA;EHqmEV;EGtmEO;IACG,mBAAA;EHwmEV;EGzmEO;IACG,kBAAA;EH2mEV;EG5mEO;IACG,WAAA;EH8mEV;EG/mEO;IACG,UAAA;EHinEV;EGlnEO;IACG,UAAA;EHonEV;EGrnEO;IACG,UAAA;EHunEV;EGxnEO;IACG,UAAA;EH0nEV;EG3nEO;IACG,UAAA;EH6nEV;EG9nEO;IACG,UAAA;EHgoEV;EGjoEO;IACG,UAAA;EHmoEV;EGpoEO;IACG,UAAA;EHsoEV;EGvoEO;IACG,UAAA;EHyoEV;EG1oEO;IACG,UAAA;EH4oEV;EG7oEO;IACG,UAAA;EH+oEV;EGhpEO;IACG,UAAA;EHkpEV;EGnpEO;IACG,UAAA;EHqpEV;EGtpEO;IACG,UAAA;EHwpEV;EGzpEO;IACG,UAAA;EH2pEV;EG5pEO;IACG,UAAA;EH8pEV;EG/pEO;IACG,UAAA;EHiqEV;EGlqEO;IACG,UAAA;EHoqEV;EGrqEO;IACG,SAAA;EHuqEV;EG5pEO;IACG,YAAA;EH8pEV;EG/pEO;IACG,YAAA;EHiqEV;EGlqEO;IACG,YAAA;EHoqEV;EGrqEO;IACG,YAAA;EHuqEV;EGxqEO;IACG,YAAA;EH0qEV;EG3qEO;IACG,YAAA;EH6qEV;EG9qEO;IACG,YAAA;EHgrEV;EGjrEO;IACG,YAAA;EHmrEV;EGprEO;IACG,YAAA;EHsrEV;EGvrEO;IACG,YAAA;EHyrEV;EG1rEO;IACG,YAAA;EH4rEV;EG7rEO;IACG,YAAA;EH+rEV;EGhsEO;IACG,YAAA;EHksEV;EGnsEO;IACG,YAAA;EHqsEV;EGtsEO;IACG,YAAA;EHwsEV;EGzsEO;IACG,YAAA;EH2sEV;EG5sEO;IACG,YAAA;EH8sEV;EG/sEO;IACG,YAAA;EHitEV;EGltEO;IACG,YAAA;EHotEV;EGrtEO;IACG,YAAA;EHutEV;EGxtEO;IACG,YAAA;EH0tEV;EG3tEO;IACG,YAAA;EH6tEV;EG9tEO;IACG,YAAA;EHguEV;EGjuEO;IACG,YAAA;EHmuEV;EGpuEO;IACG,YAAA;EHsuEV;EGvuEO;IACG,YAAA;EHyuEV;EG1uEO;IACG,YAAA;EH4uEV;EG7uEO;IACG,YAAA;EH+uEV;EGhvEO;IACG,YAAA;EHkvEV;EGnvEO;IACG,YAAA;EHqvEV;EGtvEO;IACG,YAAA;EHwvEV;EGzvEO;IACG,YAAA;EH2vEV;EG5vEO;IACG,YAAA;EH8vEV;EG/vEO;IACG,YAAA;EHiwEV;EGlwEO;IACG,YAAA;EHowEV;EGrwEO;IACG,YAAA;EHuwEV;EGxwEO;IACG,YAAA;EH0wEV;EG3wEO;IACG,YAAA;EH6wEV;EG9wEO;IACG,YAAA;EHgxEV;EGjxEO;IACG,YAAA;EHmxEV;EGpxEO;IACG,YAAA;EHsxEV;EGvxEO;IACG,YAAA;EHyxEV;EG1xEO;IACG,YAAA;EH4xEV;EG7xEO;IACG,YAAA;EH+xEV;EGhyEO;IACG,YAAA;EHkyEV;EGnyEO;IACG,YAAA;EHqyEV;EGtyEO;IACG,YAAA;EHwyEV;EGzyEO;IACG,YAAA;EH2yEV;EG5yEO;IACG,YAAA;EH8yEV;EG/yEO;IACG,YAAA;EHizEV;EGlzEO;IACG,YAAA;EHozEV;EGrzEO;IACG,YAAA;EHuzEV;EGxzEO;IACG,YAAA;EH0zEV;EG3zEO;IACG,YAAA;EH6zEV;EG9zEO;IACG,YAAA;EHg0EV;EGj0EO;IACG,YAAA;EHm0EV;EGp0EO;IACG,YAAA;EHs0EV;EGv0EO;IACG,YAAA;EHy0EV;EG10EO;IACG,YAAA;EH40EV;EG70EO;IACG,YAAA;EH+0EV;EGh1EO;IACG,YAAA;EHk1EV;EGn1EO;IACG,YAAA;EHq1EV;EGt1EO;IACG,YAAA;EHw1EV;EGz1EO;IACG,YAAA;EH21EV;EG51EO;IACG,YAAA;EH81EV;EG/1EO;IACG,YAAA;EHi2EV;EGl2EO;IACG,YAAA;EHo2EV;EGr2EO;IACG,YAAA;EHu2EV;EGx2EO;IACG,YAAA;EH02EV;EG32EO;IACG,YAAA;EH62EV;EG92EO;IACG,YAAA;EHg3EV;EGj3EO;IACG,YAAA;EHm3EV;EGp3EO;IACG,YAAA;EHs3EV;EGv3EO;IACG,YAAA;EHy3EV;EG13EO;IACG,YAAA;EH43EV;EG73EO;IACG,YAAA;EH+3EV;EGh4EO;IACG,YAAA;EHk4EV;EGn4EO;IACG,YAAA;EHq4EV;EGt4EO;IACG,YAAA;EHw4EV;EGz4EO;IACG,YAAA;EH24EV;EG54EO;IACG,YAAA;EH84EV;EG/4EO;IACG,YAAA;EHi5EV;EGl5EO;IACG,YAAA;EHo5EV;EGr5EO;IACG,YAAA;EHu5EV;EGx5EO;IACG,YAAA;EH05EV;EG35EO;IACG,YAAA;EH65EV;EG95EO;IACG,YAAA;EHg6EV;EGj6EO;IACG,YAAA;EHm6EV;EGp6EO;IACG,YAAA;EHs6EV;EGv6EO;IACG,YAAA;EHy6EV;EG16EO;IACG,YAAA;EH46EV;EG76EO;IACG,YAAA;EH+6EV;EGh7EO;IACG,YAAA;EHk7EV;EGn7EO;IACG,YAAA;EHq7EV;EGt7EO;IACG,YAAA;EHw7EV;EGz7EO;IACG,YAAA;EH27EV;EG57EO;IACG,YAAA;EH87EV;EG/7EO;IACG,YAAA;EHi8EV;EGl8EO;IACG,YAAA;EHo8EV;EGr8EO;IACG,YAAA;EHu8EV;EGx8EO;IACG,YAAA;EH08EV;EG38EO;IACG,WAAA;EH68EV;EG98EO;IACG,WAAA;EHg9EV;EGj9EO;IACG,WAAA;EHm9EV;EGp9EO;IACG,WAAA;EHs9EV;EGv9EO;IACG,WAAA;EHy9EV;EG19EO;IACG,WAAA;EH49EV;EG79EO;IACG,WAAA;EH+9EV;EGh+EO;IACG,WAAA;EHk+EV;EGn+EO;IACG,WAAA;EHq+EV;EGt+EO;IACG,WAAA;EHw+EV;EGz+EO;IACG,WAAA;EH2+EV;EG5+EO;IACG,WAAA;EH8+EV;EG/+EO;IACG,WAAA;EHi/EV;EGl/EO;IACG,WAAA;EHo/EV;EGr/EO;IACG,WAAA;EHu/EV;EGx/EO;IACG,WAAA;EH0/EV;EG3/EO;IACG,WAAA;EH6/EV;EG9/EO;IACG,WAAA;EHggFV;EGjgFO;IACG,UAAA;EHmgFV;AACF;AGj+EA;EAhDS;IACG,WAAA;EHohFV;EGrhFO;IACG,mBAAA;EHuhFV;EGxhFO;IACG,mBAAA;EH0hFV;EG3hFO;IACG,UAAA;EH6hFV;EG9hFO;IACG,mBAAA;EHgiFV;EGjiFO;IACG,mBAAA;EHmiFV;EGpiFO;IACG,WAAA;EHsiFV;EGviFO;IACG,YAAA;EHyiFV;EG1iFO;IACG,UAAA;EH4iFV;EG7iFO;IACG,YAAA;EH+iFV;EGhjFO;IACG,UAAA;EHkjFV;EGnjFO;IACG,YAAA;EHqjFV;EGtjFO;IACG,UAAA;EHwjFV;EGzjFO;IACG,YAAA;EH2jFV;EG5jFO;IACG,WAAA;EH8jFV;EG/jFO;IACG,mBAAA;EHikFV;EGlkFO;IACG,mBAAA;EHokFV;EGrkFO;IACG,UAAA;EHukFV;EGxkFO;IACG,mBAAA;EH0kFV;EG3kFO;IACG,mBAAA;EH6kFV;EG9kFO;IACG,UAAA;EHglFV;EGjlFO;IACG,mBAAA;EHmlFV;EGplFO;IACG,mBAAA;EHslFV;EGvlFO;IACG,UAAA;EHylFV;EG1lFO;IACG,mBAAA;EH4lFV;EG7lFO;IACG,kBAAA;EH+lFV;EGhmFO;IACG,WAAA;EHkmFV;EGnmFO;IACG,UAAA;EHqmFV;EGtmFO;IACG,UAAA;EHwmFV;EGzmFO;IACG,UAAA;EH2mFV;EG5mFO;IACG,UAAA;EH8mFV;EG/mFO;IACG,UAAA;EHinFV;EGlnFO;IACG,UAAA;EHonFV;EGrnFO;IACG,UAAA;EHunFV;EGxnFO;IACG,UAAA;EH0nFV;EG3nFO;IACG,UAAA;EH6nFV;EG9nFO;IACG,UAAA;EHgoFV;EGjoFO;IACG,UAAA;EHmoFV;EGpoFO;IACG,UAAA;EHsoFV;EGvoFO;IACG,UAAA;EHyoFV;EG1oFO;IACG,UAAA;EH4oFV;EG7oFO;IACG,UAAA;EH+oFV;EGhpFO;IACG,UAAA;EHkpFV;EGnpFO;IACG,UAAA;EHqpFV;EGtpFO;IACG,UAAA;EHwpFV;EGzpFO;IACG,SAAA;EH2pFV;EGhpFO;IACG,YAAA;EHkpFV;EGnpFO;IACG,YAAA;EHqpFV;EGtpFO;IACG,YAAA;EHwpFV;EGzpFO;IACG,YAAA;EH2pFV;EG5pFO;IACG,YAAA;EH8pFV;EG/pFO;IACG,YAAA;EHiqFV;EGlqFO;IACG,YAAA;EHoqFV;EGrqFO;IACG,YAAA;EHuqFV;EGxqFO;IACG,YAAA;EH0qFV;EG3qFO;IACG,YAAA;EH6qFV;EG9qFO;IACG,YAAA;EHgrFV;EGjrFO;IACG,YAAA;EHmrFV;EGprFO;IACG,YAAA;EHsrFV;EGvrFO;IACG,YAAA;EHyrFV;EG1rFO;IACG,YAAA;EH4rFV;EG7rFO;IACG,YAAA;EH+rFV;EGhsFO;IACG,YAAA;EHksFV;EGnsFO;IACG,YAAA;EHqsFV;EGtsFO;IACG,YAAA;EHwsFV;EGzsFO;IACG,YAAA;EH2sFV;EG5sFO;IACG,YAAA;EH8sFV;EG/sFO;IACG,YAAA;EHitFV;EGltFO;IACG,YAAA;EHotFV;EGrtFO;IACG,YAAA;EHutFV;EGxtFO;IACG,YAAA;EH0tFV;EG3tFO;IACG,YAAA;EH6tFV;EG9tFO;IACG,YAAA;EHguFV;EGjuFO;IACG,YAAA;EHmuFV;EGpuFO;IACG,YAAA;EHsuFV;EGvuFO;IACG,YAAA;EHyuFV;EG1uFO;IACG,YAAA;EH4uFV;EG7uFO;IACG,YAAA;EH+uFV;EGhvFO;IACG,YAAA;EHkvFV;EGnvFO;IACG,YAAA;EHqvFV;EGtvFO;IACG,YAAA;EHwvFV;EGzvFO;IACG,YAAA;EH2vFV;EG5vFO;IACG,YAAA;EH8vFV;EG/vFO;IACG,YAAA;EHiwFV;EGlwFO;IACG,YAAA;EHowFV;EGrwFO;IACG,YAAA;EHuwFV;EGxwFO;IACG,YAAA;EH0wFV;EG3wFO;IACG,YAAA;EH6wFV;EG9wFO;IACG,YAAA;EHgxFV;EGjxFO;IACG,YAAA;EHmxFV;EGpxFO;IACG,YAAA;EHsxFV;EGvxFO;IACG,YAAA;EHyxFV;EG1xFO;IACG,YAAA;EH4xFV;EG7xFO;IACG,YAAA;EH+xFV;EGhyFO;IACG,YAAA;EHkyFV;EGnyFO;IACG,YAAA;EHqyFV;EGtyFO;IACG,YAAA;EHwyFV;EGzyFO;IACG,YAAA;EH2yFV;EG5yFO;IACG,YAAA;EH8yFV;EG/yFO;IACG,YAAA;EHizFV;EGlzFO;IACG,YAAA;EHozFV;EGrzFO;IACG,YAAA;EHuzFV;EGxzFO;IACG,YAAA;EH0zFV;EG3zFO;IACG,YAAA;EH6zFV;EG9zFO;IACG,YAAA;EHg0FV;EGj0FO;IACG,YAAA;EHm0FV;EGp0FO;IACG,YAAA;EHs0FV;EGv0FO;IACG,YAAA;EHy0FV;EG10FO;IACG,YAAA;EH40FV;EG70FO;IACG,YAAA;EH+0FV;EGh1FO;IACG,YAAA;EHk1FV;EGn1FO;IACG,YAAA;EHq1FV;EGt1FO;IACG,YAAA;EHw1FV;EGz1FO;IACG,YAAA;EH21FV;EG51FO;IACG,YAAA;EH81FV;EG/1FO;IACG,YAAA;EHi2FV;EGl2FO;IACG,YAAA;EHo2FV;EGr2FO;IACG,YAAA;EHu2FV;EGx2FO;IACG,YAAA;EH02FV;EG32FO;IACG,YAAA;EH62FV;EG92FO;IACG,YAAA;EHg3FV;EGj3FO;IACG,YAAA;EHm3FV;EGp3FO;IACG,YAAA;EHs3FV;EGv3FO;IACG,YAAA;EHy3FV;EG13FO;IACG,YAAA;EH43FV;EG73FO;IACG,YAAA;EH+3FV;EGh4FO;IACG,YAAA;EHk4FV;EGn4FO;IACG,YAAA;EHq4FV;EGt4FO;IACG,YAAA;EHw4FV;EGz4FO;IACG,YAAA;EH24FV;EG54FO;IACG,YAAA;EH84FV;EG/4FO;IACG,YAAA;EHi5FV;EGl5FO;IACG,YAAA;EHo5FV;EGr5FO;IACG,YAAA;EHu5FV;EGx5FO;IACG,YAAA;EH05FV;EG35FO;IACG,YAAA;EH65FV;EG95FO;IACG,YAAA;EHg6FV;EGj6FO;IACG,YAAA;EHm6FV;EGp6FO;IACG,YAAA;EHs6FV;EGv6FO;IACG,YAAA;EHy6FV;EG16FO;IACG,YAAA;EH46FV;EG76FO;IACG,YAAA;EH+6FV;EGh7FO;IACG,YAAA;EHk7FV;EGn7FO;IACG,YAAA;EHq7FV;EGt7FO;IACG,YAAA;EHw7FV;EGz7FO;IACG,YAAA;EH27FV;EG57FO;IACG,YAAA;EH87FV;EG/7FO;IACG,WAAA;EHi8FV;EGl8FO;IACG,WAAA;EHo8FV;EGr8FO;IACG,WAAA;EHu8FV;EGx8FO;IACG,WAAA;EH08FV;EG38FO;IACG,WAAA;EH68FV;EG98FO;IACG,WAAA;EHg9FV;EGj9FO;IACG,WAAA;EHm9FV;EGp9FO;IACG,WAAA;EHs9FV;EGv9FO;IACG,WAAA;EHy9FV;EG19FO;IACG,WAAA;EH49FV;EG79FO;IACG,WAAA;EH+9FV;EGh+FO;IACG,WAAA;EHk+FV;EGn+FO;IACG,WAAA;EHq+FV;EGt+FO;IACG,WAAA;EHw+FV;EGz+FO;IACG,WAAA;EH2+FV;EG5+FO;IACG,WAAA;EH8+FV;EG/+FO;IACG,WAAA;EHi/FV;EGl/FO;IACG,WAAA;EHo/FV;EGr/FO;IACG,UAAA;EHu/FV;AACF;AG78FA;EAxDS;IACG,WAAA;EHwgGV;EGzgGO;IACG,mBAAA;EH2gGV;EG5gGO;IACG,mBAAA;EH8gGV;EG/gGO;IACG,UAAA;EHihGV;EGlhGO;IACG,mBAAA;EHohGV;EGrhGO;IACG,mBAAA;EHuhGV;EGxhGO;IACG,WAAA;EH0hGV;EG3hGO;IACG,YAAA;EH6hGV;EG9hGO;IACG,UAAA;EHgiGV;EGjiGO;IACG,YAAA;EHmiGV;EGpiGO;IACG,UAAA;EHsiGV;EGviGO;IACG,YAAA;EHyiGV;EG1iGO;IACG,UAAA;EH4iGV;EG7iGO;IACG,YAAA;EH+iGV;EGhjGO;IACG,WAAA;EHkjGV;EGnjGO;IACG,mBAAA;EHqjGV;EGtjGO;IACG,mBAAA;EHwjGV;EGzjGO;IACG,UAAA;EH2jGV;EG5jGO;IACG,mBAAA;EH8jGV;EG/jGO;IACG,mBAAA;EHikGV;EGlkGO;IACG,UAAA;EHokGV;EGrkGO;IACG,mBAAA;EHukGV;EGxkGO;IACG,mBAAA;EH0kGV;EG3kGO;IACG,UAAA;EH6kGV;EG9kGO;IACG,mBAAA;EHglGV;EGjlGO;IACG,kBAAA;EHmlGV;EGplGO;IACG,WAAA;EHslGV;EGvlGO;IACG,UAAA;EHylGV;EG1lGO;IACG,UAAA;EH4lGV;EG7lGO;IACG,UAAA;EH+lGV;EGhmGO;IACG,UAAA;EHkmGV;EGnmGO;IACG,UAAA;EHqmGV;EGtmGO;IACG,UAAA;EHwmGV;EGzmGO;IACG,UAAA;EH2mGV;EG5mGO;IACG,UAAA;EH8mGV;EG/mGO;IACG,UAAA;EHinGV;EGlnGO;IACG,UAAA;EHonGV;EGrnGO;IACG,UAAA;EHunGV;EGxnGO;IACG,UAAA;EH0nGV;EG3nGO;IACG,UAAA;EH6nGV;EG9nGO;IACG,UAAA;EHgoGV;EGjoGO;IACG,UAAA;EHmoGV;EGpoGO;IACG,UAAA;EHsoGV;EGvoGO;IACG,UAAA;EHyoGV;EG1oGO;IACG,UAAA;EH4oGV;EG7oGO;IACG,SAAA;EH+oGV;EGpoGO;IACG,YAAA;EHsoGV;EGvoGO;IACG,YAAA;EHyoGV;EG1oGO;IACG,YAAA;EH4oGV;EG7oGO;IACG,YAAA;EH+oGV;EGhpGO;IACG,YAAA;EHkpGV;EGnpGO;IACG,YAAA;EHqpGV;EGtpGO;IACG,YAAA;EHwpGV;EGzpGO;IACG,YAAA;EH2pGV;EG5pGO;IACG,YAAA;EH8pGV;EG/pGO;IACG,YAAA;EHiqGV;EGlqGO;IACG,YAAA;EHoqGV;EGrqGO;IACG,YAAA;EHuqGV;EGxqGO;IACG,YAAA;EH0qGV;EG3qGO;IACG,YAAA;EH6qGV;EG9qGO;IACG,YAAA;EHgrGV;EGjrGO;IACG,YAAA;EHmrGV;EGprGO;IACG,YAAA;EHsrGV;EGvrGO;IACG,YAAA;EHyrGV;EG1rGO;IACG,YAAA;EH4rGV;EG7rGO;IACG,YAAA;EH+rGV;EGhsGO;IACG,YAAA;EHksGV;EGnsGO;IACG,YAAA;EHqsGV;EGtsGO;IACG,YAAA;EHwsGV;EGzsGO;IACG,YAAA;EH2sGV;EG5sGO;IACG,YAAA;EH8sGV;EG/sGO;IACG,YAAA;EHitGV;EGltGO;IACG,YAAA;EHotGV;EGrtGO;IACG,YAAA;EHutGV;EGxtGO;IACG,YAAA;EH0tGV;EG3tGO;IACG,YAAA;EH6tGV;EG9tGO;IACG,YAAA;EHguGV;EGjuGO;IACG,YAAA;EHmuGV;EGpuGO;IACG,YAAA;EHsuGV;EGvuGO;IACG,YAAA;EHyuGV;EG1uGO;IACG,YAAA;EH4uGV;EG7uGO;IACG,YAAA;EH+uGV;EGhvGO;IACG,YAAA;EHkvGV;EGnvGO;IACG,YAAA;EHqvGV;EGtvGO;IACG,YAAA;EHwvGV;EGzvGO;IACG,YAAA;EH2vGV;EG5vGO;IACG,YAAA;EH8vGV;EG/vGO;IACG,YAAA;EHiwGV;EGlwGO;IACG,YAAA;EHowGV;EGrwGO;IACG,YAAA;EHuwGV;EGxwGO;IACG,YAAA;EH0wGV;EG3wGO;IACG,YAAA;EH6wGV;EG9wGO;IACG,YAAA;EHgxGV;EGjxGO;IACG,YAAA;EHmxGV;EGpxGO;IACG,YAAA;EHsxGV;EGvxGO;IACG,YAAA;EHyxGV;EG1xGO;IACG,YAAA;EH4xGV;EG7xGO;IACG,YAAA;EH+xGV;EGhyGO;IACG,YAAA;EHkyGV;EGnyGO;IACG,YAAA;EHqyGV;EGtyGO;IACG,YAAA;EHwyGV;EGzyGO;IACG,YAAA;EH2yGV;EG5yGO;IACG,YAAA;EH8yGV;EG/yGO;IACG,YAAA;EHizGV;EGlzGO;IACG,YAAA;EHozGV;EGrzGO;IACG,YAAA;EHuzGV;EGxzGO;IACG,YAAA;EH0zGV;EG3zGO;IACG,YAAA;EH6zGV;EG9zGO;IACG,YAAA;EHg0GV;EGj0GO;IACG,YAAA;EHm0GV;EGp0GO;IACG,YAAA;EHs0GV;EGv0GO;IACG,YAAA;EHy0GV;EG10GO;IACG,YAAA;EH40GV;EG70GO;IACG,YAAA;EH+0GV;EGh1GO;IACG,YAAA;EHk1GV;EGn1GO;IACG,YAAA;EHq1GV;EGt1GO;IACG,YAAA;EHw1GV;EGz1GO;IACG,YAAA;EH21GV;EG51GO;IACG,YAAA;EH81GV;EG/1GO;IACG,YAAA;EHi2GV;EGl2GO;IACG,YAAA;EHo2GV;EGr2GO;IACG,YAAA;EHu2GV;EGx2GO;IACG,YAAA;EH02GV;EG32GO;IACG,YAAA;EH62GV;EG92GO;IACG,YAAA;EHg3GV;EGj3GO;IACG,YAAA;EHm3GV;EGp3GO;IACG,YAAA;EHs3GV;EGv3GO;IACG,YAAA;EHy3GV;EG13GO;IACG,YAAA;EH43GV;EG73GO;IACG,YAAA;EH+3GV;EGh4GO;IACG,YAAA;EHk4GV;EGn4GO;IACG,YAAA;EHq4GV;EGt4GO;IACG,YAAA;EHw4GV;EGz4GO;IACG,YAAA;EH24GV;EG54GO;IACG,YAAA;EH84GV;EG/4GO;IACG,YAAA;EHi5GV;EGl5GO;IACG,YAAA;EHo5GV;EGr5GO;IACG,YAAA;EHu5GV;EGx5GO;IACG,YAAA;EH05GV;EG35GO;IACG,YAAA;EH65GV;EG95GO;IACG,YAAA;EHg6GV;EGj6GO;IACG,YAAA;EHm6GV;EGp6GO;IACG,YAAA;EHs6GV;EGv6GO;IACG,YAAA;EHy6GV;EG16GO;IACG,YAAA;EH46GV;EG76GO;IACG,YAAA;EH+6GV;EGh7GO;IACG,YAAA;EHk7GV;EGn7GO;IACG,WAAA;EHq7GV;EGt7GO;IACG,WAAA;EHw7GV;EGz7GO;IACG,WAAA;EH27GV;EG57GO;IACG,WAAA;EH87GV;EG/7GO;IACG,WAAA;EHi8GV;EGl8GO;IACG,WAAA;EHo8GV;EGr8GO;IACG,WAAA;EHu8GV;EGx8GO;IACG,WAAA;EH08GV;EG38GO;IACG,WAAA;EH68GV;EG98GO;IACG,WAAA;EHg9GV;EGj9GO;IACG,WAAA;EHm9GV;EGp9GO;IACG,WAAA;EHs9GV;EGv9GO;IACG,WAAA;EHy9GV;EG19GO;IACG,WAAA;EH49GV;EG79GO;IACG,WAAA;EH+9GV;EGh+GO;IACG,WAAA;EHk+GV;EGn+GO;IACG,WAAA;EHq+GV;EGt+GO;IACG,WAAA;EHw+GV;EGz+GO;IACG,UAAA;EH2+GV;AACF;AGr7GA;EAHI,qBAAA;AH27GJ;AGt7GA;EACI;IANA,qBAAA;EH+7GF;AACF;AGv7GA;EACI;IAVA,qBAAA;EHo8GF;AACF;AGx7GA;EACI;IAdA,qBAAA;EHy8GF;AACF;AGz7GA;EACI;IAlBA,qBAAA;EH88GF;AACF;AG17GA;EACI,qBAAA;AH47GJ;AIlqHA;EACI,qBAAA;EACA,oEAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJoqHJ;AIjqHA;EACI,qBAAA;EACA,oEAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJmqHJ;AIhqHA;EACI,qBAAA;EACA,oEAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJkqHJ;AI/pHA;EACI,qBAAA;EACA,oEAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;AJiqHJ;AI9pHA;EACI,qBAAA;EACA,oEAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJgqHJ;AI7pHA;EACI,qBAAA;EACA,oEAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJ+pHJ;AI5pHA;EACI,qBAAA;EACA,oEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJ8pHJ;AI3pHA;EACI,qBAAA;EACA,oEAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJ6pHJ;AI1pHA;EACI,qBAAA;EACA,oEAAA;EACA,YAAA;EACA,YAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;AJ4pHJ;AIzpHA;EACI,qBAAA;EACA,oEAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJ2pHJ;AIxpHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJ0pHJ;AIvpHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJypHJ;AItpHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJwpHJ;AIrpHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJupHJ;AIppHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJspHJ;AInpHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;AJqpHJ;AIlpHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;AJopHJ;AIjpHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;AJmpHJ;AIhpHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;AJkpHJ;AI/oHA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,qEAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sCAAA;AJipHJ;AI9oHA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,qEAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sCAAA;AJgpHJ;AI7oHA;EACI,WAAA;EACA,YAAA;EACA,qEAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sCAAA;AJ+oHJ;AI5oHA;EACI,WAAA;EACA,YAAA;EACA,qEAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sCAAA;AJ8oHJ;AI3oHA;EACI,WAAA;EACA,YAAA;EACA,qEAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sCAAA;AJ6oHJ;AI1oHA;EACI,WAAA;EACA,YAAA;EACA,qEAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sCAAA;AJ4oHJ;AIzoHA;EACI,0BAAA;AJ2oHJ;AIxoHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJ0oHJ;AIvoHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJyoHJ;AItoHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJwoHJ;AIroHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJuoHJ;AIpoHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJsoHJ;AInoHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJqoHJ;AIloHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJooHJ;AIjoHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJmoHJ;AIhoHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJkoHJ;AI/nHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJioHJ;AI9nHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJgoHJ;AI7nHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJ+nHJ;AI5nHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJ8nHJ;AI3nHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJ6nHJ;AI1nHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJ4nHJ;AIznHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJ2nHJ;AIxnHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJ0nHJ;AIvnHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJynHJ;AItnHA;EACI,qBAAA;EACA,qEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJwnHJ;AIrnHA;EACI,qBAAA;EACA,oEAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AJunHJ;AIpnHA;EACI;IACI,WAAA;IACA,YAAA;EJsnHN;AACF;AInnHA;EACI;IACI,sBAAA;IACA,uBAAA;EJqnHN;AACF;AIlnHA;EACI;IACI,sBAAA;IACA,uBAAA;EJonHN;AACF;AA3lIA;EACI,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,0BAAA;AA6lIJ;AA1lIA;;EAEI,4CAAA;AA4lIJ;AAzlIA;EACI,4CAAA;AA2lIJ;AAxlIA;EACI,sCAAA;AA0lIJ;AAvlIA;EACI,mDAAA;AAylIJ;AAtlIA;EACI,iCAAA;AAwlIJ;AArlIA;EACI,0BAAA;AAulIJ;AAplIA;EACI,0BAAA;AAslIJ;AAnlIA;EACI,mCAAA;AAqlIJ;AAllIA;EACI,sBAAA;AAolIJ;AAjlIA;;;EAGI,mDAAA;AAmlIJ;AAhlIA;EACI,mDAAA;AAklIJ;AA/kIA;EACI,oBAAA;AAilIJ;AA9kIA;EACI,mBAAA;EACA,YAAA;AAglIJ;AA7kIA;EACI,YAAA;AA+kIJ;AA5kIA;EACI,QAAA;AA8kIJ;AA3kIA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AA6kIJ;AA3kII;EACI,4BAAA;AA6kIR;AA1kII;EACI,4BAAA;AA4kIR;AAzkII;EACI,kBAAA;EACA,YAAA;AA2kIR;AAvkIA;EACI,iBAAA;AAykIJ;AAtkIA;EACI,iCAAA;EACA,YAAA;EACA,WAAA;AAwkIJ;AArkIA;EACI,yBAAA;EACA,kBAAA;AAukIJ;AApkIA;EACI,gCAAA;AAskIJ;AAnkIA;EACI,eAAA;AAqkIJ;AAlkIA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAokIJ;AAjkIA;EACI,kBAAA;AAmkIJ;AAhkIA;EACI,6CAAA;AAkkIJ;AA/jIA;EACI,sBAAA;AAikIJ;AA9jIA;EACI,uBAAA;AAgkIJ;AA7jIA;EACI;IACI,uBAAA;IACA,kCAAA;IACA,yCAAA;EA+jIN;EA5jIE;IACI,iCAAA;IACA,gBAAA;EA8jIN;EA3jIE;IACI,eAAA;IACA,iBAAA;IACA,oBAAA;EA6jIN;EA1jIE;IACI,oCAAA;IACA,kBAAA;IACA,yBAAA;EA4jIN;EAzjIE;IACI,aAAA;EA2jIN;EAxjIE;IACI,gCAAA;EA0jIN;EAvjIE;IACI,iBAAA;IACA,eAAA;IACA,gBAAA;IACA,iCAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,mBAAA;IACA,yBAAA;EAyjIN;EAtjIE;IACI,yBAAA;IACA,iCAAA;EAwjIN;EArjIE;;IAEI,4CAAA;IACA,uBAAA;EAujIN;EApjIE;IACI,yBAAA;IACA,cAAA;IACA,cAAA;IACA,aAAA;EAsjIN;EAnjIE;IACI,cAAA;EAqjIN;EAljIE;IACI,kBAAA;IACA,eAAA;IACA,gBAAA;IACA,sBAAA;IACA,mBAAA;EAojIN;EAjjIE;IACI,yBAAA;IACA,iCAAA;EAmjIN;EAhjIE;IACI,eAAA;IACA,iCAAA;IACA,0BAAA;EAkjIN;EA/iIE;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,YAAA;EAijIN;EA9iIE;IACI,cAAA;IACA,6BAAA;EAgjIN;EA7iIE;IACI,2BAAA;EA+iIN;EA5iIG;IACI,gBAAA;EA8iIP;EA3iIG;IACI,gBAAA;EA6iIP;AACF;AA1iIA;EACI;IACI,gBAAA;IACA,aAAA;IACA,mBAAA;EA4iIN;AACF;AAziIA;EACI,0BAAA;AA2iIJ;AAxiIA;EACI,uBAAA;AA0iIJ;AAviIA;EACI,sCAAA;AAyiIJ;AAtiIA;EACI,0BAAA;AAwiIJ;AAriIA;EACI,wBAAA;AAuiIJ;AApiIA;EACI,0BAAA;EACA,6BAAA;EACA,iCAAA;AAsiIJ;AAniIA;EACI,+BAAA;EACA,mBAAA;AAqiIJ;AAliIA;EAaI,sBAAA;AAwhIJ;AApiII;EACE,yBAAA;AAsiIN;AApiII;EACE,yBAAA;AAsiIN;AApiII;EACE,yBAAA;AAsiIN;AApiII;EACE,sBAAA;AAsiIN;AAjiIA;EACI,oCAAA;AAmiIJ;AAhiIA;EACE,2BAAA;AAkiIF;AA/hIA;EACI,YAAA;AAiiIJ","sourcesContent":["@font-face {\n  font-family: 'Outfit';\n  font-style: normal;\n  font-weight: 100;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4TC0C4E.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Outfit';\n  font-style: normal;\n  font-weight: 200;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4bC1C4E.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Outfit';\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4W61C4E.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Outfit';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4TC1C4E.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Outfit';\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4QK1C4E.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Outfit';\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4e6yC4E.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Outfit';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4deyC4E.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Outfit';\n  font-style: normal;\n  font-weight: 800;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4bCyC4E.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Outfit';\n  font-style: normal;\n  font-weight: 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/outfit/v15/QGYyz_MVcBeNP4NjuGObqx1XmO1I4ZmyC4E.ttf) format('truetype');\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap\");\n@import \"./padding.less\";\n@import \"./margin.less\";\n@import \"./width.less\";\n@import \"./icons.less\";\n\n:root {\n    --cor-azul: #06337a;\n    --cor-azul-escuro: #001C40;\n    --cor-branco: #fff;\n    --cor-cinza-input: #e7e9f3;\n}\n\nbody,\n* {\n    font-family: \"Outfit\", sans-serif !important;\n}\n\n.uk-background-primary {\n    background-color: var(--cor-azul) !important;\n}\n\n.uk-background-secondary {\n    background-color: #25367e17 !important;\n}\n\n.background-azul-escuro {\n    background-color: var(--cor-azul-escuro) !important;\n}\n\n.uk-text-primary {\n    color: var(--cor-azul) !important;\n}\n\n.uk-text-default {\n    font-size: 17px !important;\n}\n\n.uk-text-large {\n    font-size: 20px !important;\n}\n\n.text-white {\n    color: var(--cor-branco) !important;\n}\n\n.text-black {\n    color: #000 !important;\n}\n\n.bg-input,\ninput:disabled,\nselect:disabled {\n    background-color: var(--cor-cinza-input) !important;\n}\n\n.bg-input:not(:disabled) {\n    background-color: var(--cor-cinza-input) !important;\n}\n\n.botao-adicionar {\n    text-transform: none;\n}\n\n.uk-disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\n.tamanho-input-padrao {\n    height: 36px;\n}\n\n.botoes-acoes {\n    gap: 8px;\n}\n\n.uk-modal-dialog[role=\"alertdialog\"] {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n\n    & .uk-modal-body {\n        border-radius: 10px 10px 0 0;\n    }\n\n    & .uk-modal-footer {\n        border-radius: 0 0 10px 10px;\n    }\n\n    & .uk-button {\n        border-radius: 8px;\n        height: 36px;\n    }\n}\n\n.espacamento-interno-pequeno {\n    padding: 5px 10px;\n}\n\n.active-page .pagination-button {\n    background-color: var(--cor-azul);\n    color: white;\n    width: 100%;\n}\n\n.borda-grid {\n    border: 1px solid #e5e5e5;\n    border-radius: 4px;\n}\n\n.linha-borda-grid {\n    border-bottom: 1px solid #e5e5e5;\n}\n\n.titulo-card-ativar-conta {\n    font-size: 25px;\n}\n\n.largura-minima-acoes {\n    min-width: 75px;\n    text-align: left;\n    align-items: start;\n}\n\n.uk-card-top {\n    padding: 10px 12px;\n}\n\n.uk-div-hover {\n    transition: background-color 0.1s ease-in-out;\n}\n\n.uk-div-hover:hover {\n    background-color: #ffd;\n}\n\n.altura-linha-tabela {\n    height: 69px !important;\n}\n\n@media (max-width: 959px) {\n    .uk-offcanvas-bar {\n        width: 280px !important;\n        background-color: white !important;\n        box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\n    }\n    \n    .mobile-menu-header {\n        color: var(--cor-azul) !important;\n        border-radius: 0;\n    }\n    \n    .mobile-menu-header h3 {\n        font-size: 18px;\n        font-weight: bold;\n        margin: 0 !important;       \n    }\n    \n    .uk-offcanvas-bar .uk-background-muted {\n        background-color: #f8f9fa !important;\n        border-radius: 8px;\n        border: 1px solid #e9ecef;\n    }\n    \n    .uk-offcanvas-bar .uk-nav-default {\n        margin-top: 0;\n    }\n    \n    .uk-offcanvas-bar .uk-nav-default > li {\n        border-bottom: 1px solid #f0f0f0;\n    }\n    \n    .uk-offcanvas-bar .uk-nav-default > li > a {\n        padding: 5px 10px;\n        font-size: 16px;\n        font-weight: 600;\n        color: var(--cor-azul) !important;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        border-bottom: none;\n        transition: all 0.3s ease;\n    }\n    \n    .uk-offcanvas-bar .uk-nav-default > li > a:hover {\n        background-color: #f8f9fa;\n        color: var(--cor-azul) !important;\n    }\n    \n    .uk-offcanvas-bar .uk-nav-default > li.uk-active > a,\n    .uk-offcanvas-bar .uk-nav-default > li.uk-open > a {\n        background-color: var(--cor-azul) !important;\n        color: white !important;\n    }\n    \n    .uk-offcanvas-bar .uk-nav-sub {\n        background-color: #f8f9fa;\n        margin: 10px 0;\n        padding: 0 5px;\n        display: none;\n    }\n    \n    .uk-offcanvas-bar .uk-parent.uk-open .uk-nav-sub {\n        display: block;\n    }\n    \n    .uk-offcanvas-bar .uk-nav-sub > li > a {\n        padding-left: 50px;\n        font-size: 14px;\n        font-weight: 400;\n        color: #666 !important;\n        border-bottom: none;\n    }\n    \n    .uk-offcanvas-bar .uk-nav-sub > li > a:hover {\n        background-color: #e9ecef;\n        color: var(--cor-azul) !important;\n    }\n    \n    .uk-offcanvas-bar .uk-nav-sub > li.uk-active > a {\n        font-size: 18px;\n        color: var(--cor-azul) !important;\n        text-decoration: underline;\n    }\n    \n    .mobile-menu-icon {\n        width: 20px;\n        height: 20px;\n        margin-right: 12px;\n        opacity: 0.7;\n    }\n\n    .uk-offcanvas-bar .uk-nav-divider {\n        margin: 20px 0;\n        border-top: 1px solid #e9ecef;\n    }\n\n    .uk-navbar {\n        min-height: 60px !important;\n    }\n\n     .uk-offcanvas-bar .uk-nav-default > li.uk-active > a {\n         font-weight: 700;\n     }\n     \n     .uk-offcanvas-bar .uk-nav-sub > li.uk-active > a {\n         font-weight: 600;\n     }\n }\n\n@media (max-width: 959px) {\n    .uk-offcanvas-bar a {\n        min-height: 30px;\n        display: flex;\n        align-items: center;\n    }\n}\n\n.uk-text-extra-small {\n    font-size: 12px !important;\n}\n\n.uk-width-large {\n    width: 355px !important;\n}\n\n.uk-background-secondary {\n    background-color: #25367e17 !important;\n}\n\n.uk-text-medium {\n    font-size: 16px !important;\n}\n\n.uk-modal-dialog.uk-modal-body {\n    padding: 2rem !important;\n}\n\n.uk-modal-title {\n    font-size: 20px !important;\n    text-align: center !important;\n    color: var(--cor-azul) !important;\n}\n\n.borda-esquerda {\n    border-left: 12px solid #06337A;\n    border-radius: 10px;\n}\n\n.progresso-barra {\n    &::-webkit-progress-value {\n      background-color: #16A34A; \n    }\n    &::-moz-progress-bar {\n      background-color: #16A34A;\n    }\n    &::-ms-fill {\n      background-color: #16A34A;\n    }\n    &::-webkit-progress-bar {\n      background-color: #eee;\n    }\n    background-color: #eee;\n}\n\n.background-warning {\n    background-color: #FAA669 !important;\n}\n\n.apexcharts-legend {\n  overflow: hidden !important;\n}\n\n.uk-opacity-50 {\n    opacity: 0.5;\n}\n",".base-padding(@padding) {\n    padding: @padding;\n}\n\n@none: 0 0 0 0;\n@nano: 5px 5px 5px 5px;\n@nano-top: 5px 0 0 0;\n@nano-right: 0 5px 0 0;\n@nano-bottom: 0 0 5px 0;\n@nano-left: 0 0 0 5px;\n@nano-vertical: 5px 0;\n@nano-horizontal: 0 5px;\n\n@nano-micro: 7px 7px 7px 7px;\n\n@micro: 10px 10px 10px 10px;\n@micro-top: 10px 0 0 0;\n@micro-right: 0 10px 0 0;\n@micro-bottom: 0 0 10px 0;\n@micro-left: 0 0 0 10px;\n@micro-vertical: 10px 0;\n@micro-horizontal: 0 10px;\n\n@small: 15px 15px 15px 15px;\n@small-top: 15px 0 0 0;\n@small-right: 0 15px 0 0;\n@small-bottom: 0 0 15px 0;\n@small-left: 0 0 0 15px;\n@small-vertical: 15px 0;\n@small-horizontal: 0 15px;\n\n@medium: 30px 30px 30px 30px;\n@medium-top: 30px 0 0 0;\n@medium-right: 0 30px 0 0;\n@medium-bottom: 0 0 30px 0;\n@medium-left: 0 0 0 30px;\n@medium-vertical: 30px 0;\n@medium-horizontal: 0 30px;\n\n@large: 50px 50px 50px 50px;\n@large-top: 50px 0 0 0;\n@large-right: 0 50px 0 0;\n@large-bottom: 0 0 50px 0;\n@large-left: 0 0 0 50px;\n@large-vertical: 50px 0;\n@large-horizontal: 0 50px;\n@xlarge-horizontal: 0 100px;\n\n//padding-nano\n.padding-nano { .base-padding(@nano); }\n.padding-nano-top { .base-padding(@nano-top); }\n.padding-nano-right { .base-padding(@nano-right); }\n.padding-nano-bottom { .base-padding(@nano-bottom); }\n.padding-nano-left { .base-padding(@nano-left); }\n.padding-nano-vertical { .base-padding(@nano-vertical); }\n.padding-nano-horizontal { .base-padding(@nano-horizontal); }\n\n.padding-nano-micro { .base-padding(@nano-micro); }\n\n.padding-micro { .base-padding(@micro); }\n.padding-micro-top { .base-padding(@micro-top); }\n.padding-micro-right { .base-padding(@micro-right); }\n.padding-micro-bottom { .base-padding(@micro-bottom); }\n.padding-micro-left { .base-padding(@micro-left); }\n.padding-micro-vertical { .base-padding(@micro-vertical); }\n.padding-micro-horizontal { .base-padding(@micro-horizontal); }\n\n.padding-small { .base-padding(@small); }\n.padding-small-top { .base-padding(@small-top); }\n.padding-small-right { .base-padding(@small-right); }\n.padding-small-bottom { .base-padding(@small-bottom); }\n.padding-small-left { .base-padding(@small-left); }\n.padding-small-vertical { .base-padding(@small-vertical); }\n.padding-small-horizontal { .base-padding(@small-horizontal); }\n\n.padding-medium { .base-padding(@medium); }\n.padding-medium-top { .base-padding(@medium-top); }\n.padding-medium-right { .base-padding(@medium-right); }\n.padding-medium-bottom { .base-padding(@medium-bottom); }\n.padding-medium-left { .base-padding(@medium-left); }\n.padding-medium-vertical { .base-padding(@medium-vertical); }\n.padding-medium-horizontal { .base-padding(@medium-horizontal); }\n\n.padding-large { .base-padding(@large); }\n.padding-large-top { .base-padding(@large-top); }\n.padding-large-right { .base-padding(@large-right); }\n.padding-large-bottom { .base-padding(@large-bottom); }\n.padding-large-left { .base-padding(@large-left); }\n.padding-large-vertical { .base-padding(@large-vertical); }\n.padding-large-horizontal { .base-padding(@large-horizontal); }\n\n.padding-remove { .base-padding(@none); }\n.padding-remove-top { padding-top: 0; }\n.padding-remove-right { padding-right: 0; }\n.padding-remove-left { padding-left: 0; }\n.padding-remove-bottom { padding-bottom: 0; }\n.padding-remove-vertical { padding-top: 0; padding-bottom: 0; }\n.padding-remove-horizontal { padding-left: 0; padding-right: 0; }\n\n.padding-letter-top { padding-top: 21px; }\n\n.padding-label-top { padding-top: 18px; }\n\n@media(min-width: 435px) {\n    .padding-nano\\@xs { .base-padding(@nano); }\n    .padding-nano-top\\@xs { .base-padding(@nano-top); }\n    .padding-nano-right\\@xs { .base-padding(@nano-right); }\n    .padding-nano-bottom\\@xs { .base-padding(@nano-bottom); }\n    .padding-nano-left\\@xs { .base-padding(@nano-left); }\n    .padding-nano-vertical\\@xs { .base-padding(@nano-vertical); }\n    .padding-nano-horizontal\\@xs { .base-padding(@nano-horizontal); }\n\n    .padding-micro\\@xs { .base-padding(@micro); }\n    .padding-micro-top\\@xs { .base-padding(@micro-top); }\n    .padding-micro-right\\@xs { .base-padding(@micro-right); }\n    .padding-micro-bottom\\@xs { .base-padding(@micro-bottom); }\n    .padding-micro-left\\@xs { .base-padding(@micro-left); }\n    .padding-micro-vertical\\@xs { .base-padding(@micro-vertical); }\n    .padding-micro-horizontal\\@xs { .base-padding(@micro-horizontal); }\n\n    .padding-small\\@xs { .base-padding(@small); }\n    .padding-small-top\\@xs { .base-padding(@small-top); }\n    .padding-small-right\\@xs { .base-padding(@small-right); }\n    .padding-small-bottom\\@xs { .base-padding(@small-bottom); }\n    .padding-small-left\\@xs { .base-padding(@small-left); }\n    .padding-small-vertical\\@xs { .base-padding(@small-vertical); }\n    .padding-small-horizontal\\@xs { .base-padding(@small-horizontal); }\n\n    .padding-medium\\@xs { .base-padding(@medium); }\n    .padding-medium-top\\@xs { .base-padding(@medium-top); }\n    .padding-medium-right\\@xs { .base-padding(@medium-right); }\n    .padding-medium-bottom\\@xs { .base-padding(@medium-bottom); }\n    .padding-medium-left\\@xs { .base-padding(@medium-left); }\n    .padding-medium-vertical\\@xs { .base-padding(@medium-vertical); }\n    .padding-medium-horizontal\\@xs { .base-padding(@medium-horizontal); }\n\n    .padding-large\\@xs { .base-padding(@large); }\n    .padding-large-top\\@xs { .base-padding(@large-top); }\n    .padding-large-right\\@xs { .base-padding(@large-right); }\n    .padding-large-bottom\\@xs { .base-padding(@large-bottom); }\n    .padding-large-left\\@xs { .base-padding(@large-left); }\n    .padding-large-vertical\\@xs { .base-padding(@large-vertical); }\n    .padding-large-horizontal\\@xs { .base-padding(@large-horizontal); }\n\n    .padding-remove\\@xs { .base-padding(@none); }\n    .padding-remove-top\\@xs { padding-top: 0; }\n    .padding-remove-right\\@xs { padding-right: 0; }\n    .padding-remove-left\\@xs { padding-left: 0; }\n    .padding-remove-bottom\\@xs { padding-bottom: 0; }\n    .padding-remove-vertical\\@xs { padding-top: 0; padding-bottom: 0; }\n    .padding-remove-horizontal\\@xs { padding-left: 0; padding-right: 0; }\n}\n\n@media(min-width: 640px) {\n    .padding-nano\\@s { .base-padding(@nano); }\n    .padding-nano-top\\@s { .base-padding(@nano-top); }\n    .padding-nano-right\\@s { .base-padding(@nano-right); }\n    .padding-nano-bottom\\@s { .base-padding(@nano-bottom); }\n    .padding-nano-left\\@s { .base-padding(@nano-left); }\n    .padding-nano-vertical\\@s { .base-padding(@nano-vertical); }\n    .padding-nano-horizontal\\@s { .base-padding(@nano-horizontal); }\n\n    .padding-micro\\@s { .base-padding(@micro); }\n    .padding-micro-top\\@s { .base-padding(@micro-top); }\n    .padding-micro-right\\@s { .base-padding(@micro-right); }\n    .padding-micro-bottom\\@s { .base-padding(@micro-bottom); }\n    .padding-micro-left\\@s { .base-padding(@micro-left); }\n    .padding-micro-vertical\\@s { .base-padding(@micro-vertical); }\n    .padding-micro-horizontal\\@s { .base-padding(@micro-horizontal); }\n\n    .padding-small\\@s { .base-padding(@small); }\n    .padding-small-top\\@s { .base-padding(@small-top); }\n    .padding-small-right\\@s { .base-padding(@small-right); }\n    .padding-small-bottom\\@s { .base-padding(@small-bottom); }\n    .padding-small-left\\@s { .base-padding(@small-left); }\n    .padding-small-vertical\\@s { .base-padding(@small-vertical); }\n    .padding-small-horizontal\\@s { .base-padding(@small-horizontal); }\n\n    .padding-medium\\@s { .base-padding(@medium); }\n    .padding-medium-top\\@s { .base-padding(@medium-top); }\n    .padding-medium-right\\@s { .base-padding(@medium-right); }\n    .padding-medium-bottom\\@s { .base-padding(@medium-bottom); }\n    .padding-medium-left\\@s { .base-padding(@medium-left); }\n    .padding-medium-vertical\\@s { .base-padding(@medium-vertical); }\n    .padding-medium-horizontal\\@s { .base-padding(@medium-horizontal); }\n\n    .padding-large\\@s { .base-padding(@large); }\n    .padding-large-top\\@s { .base-padding(@large-top); }\n    .padding-large-right\\@s { .base-padding(@large-right); }\n    .padding-large-bottom\\@s { .base-padding(@large-bottom); }\n    .padding-large-left\\@s { .base-padding(@large-left); }\n    .padding-large-vertical\\@s { .base-padding(@large-vertical); }\n    .padding-large-horizontal\\@s { .base-padding(@large-horizontal); }\n\n    .padding-remove\\@s { .base-padding(@none); }\n    .padding-remove-top\\@s { padding-top: 0; }\n    .padding-remove-right\\@s { padding-right: 0; }\n    .padding-remove-left\\@s { padding-left: 0; }\n    .padding-remove-bottom\\@s { padding-bottom: 0; }\n    .padding-remove-vertical\\@s { padding-top: 0; padding-bottom: 0; }\n    .padding-remove-horizontal\\@s { padding-left: 0; padding-right: 0; }\n}\n\n@media(min-width: 960px) {\n    .padding-nano\\@m { .base-padding(@nano); }\n    .padding-nano-top\\@m { .base-padding(@nano-top); }\n    .padding-nano-right\\@m { .base-padding(@nano-right); }\n    .padding-nano-bottom\\@m { .base-padding(@nano-bottom); }\n    .padding-nano-left\\@m { .base-padding(@nano-left); }\n    .padding-nano-vertical\\@m { .base-padding(@nano-vertical); }\n    .padding-nano-horizontal\\@m { .base-padding(@nano-horizontal); }\n\n    .padding-micro\\@m { .base-padding(@micro); }\n    .padding-micro-top\\@m { .base-padding(@micro-top); }\n    .padding-micro-right\\@m { .base-padding(@micro-right); }\n    .padding-micro-bottom\\@m { .base-padding(@micro-bottom); }\n    .padding-micro-left\\@m { .base-padding(@micro-left); }\n    .padding-micro-vertical\\@m { .base-padding(@micro-vertical); }\n    .padding-micro-horizontal\\@m { .base-padding(@micro-horizontal); }\n\n    .padding-small\\@m { .base-padding(@small); }\n    .padding-small-top\\@m { .base-padding(@small-top); }\n    .padding-small-right\\@m { .base-padding(@small-right); }\n    .padding-small-bottom\\@m { .base-padding(@small-bottom); }\n    .padding-small-left\\@m { .base-padding(@small-left); }\n    .padding-small-vertical\\@m { .base-padding(@small-vertical); }\n    .padding-small-horizontal\\@m { .base-padding(@small-horizontal); }\n\n    .padding-medium\\@m { .base-padding(@medium); }\n    .padding-medium-top\\@m { .base-padding(@medium-top); }\n    .padding-medium-right\\@m { .base-padding(@medium-right); }\n    .padding-medium-bottom\\@m { .base-padding(@medium-bottom); }\n    .padding-medium-left\\@m { .base-padding(@medium-left); }\n    .padding-medium-vertical\\@m { .base-padding(@medium-vertical); }\n    .padding-medium-horizontal\\@m { .base-padding(@medium-horizontal); }\n\n    .padding-large\\@m { .base-padding(@large); }\n    .padding-large-top\\@m { .base-padding(@large-top); }\n    .padding-large-right\\@m { .base-padding(@large-right); }\n    .padding-large-bottom\\@m { .base-padding(@large-bottom); }\n    .padding-large-left\\@m { .base-padding(@large-left); }\n    .padding-large-vertical\\@m { .base-padding(@large-vertical); }\n    .padding-large-horizontal\\@m { .base-padding(@large-horizontal); }\n\n    .padding-remove\\@m { .base-padding(@none); }\n    .padding-remove-top\\@m { padding-top: 0; }\n    .padding-remove-right\\@m { padding-right: 0; }\n    .padding-remove-left\\@m { padding-left: 0; }\n    .padding-remove-bottom\\@m { padding-bottom: 0; }\n    .padding-remove-vertical\\@m { padding-top: 0; padding-bottom: 0; }\n    .padding-remove-horizontal\\@m { padding-left: 0; padding-right: 0; }\n\n    .padding-letter-top { padding-top: 18px; }\n    .padding-letter-top\\@m { padding-top: 18px; }\n\n    .padding-label-top { padding-top: 15px; }\n    .padding-label-top\\@m { padding-top: 15px; }\n}\n\n@media(min-width: 1200px) {\n    .padding-nano\\@l { .base-padding(@nano); }\n    .padding-nano-top\\@l { .base-padding(@nano-top); }\n    .padding-nano-right\\@l { .base-padding(@nano-right); }\n    .padding-nano-bottom\\@l { .base-padding(@nano-bottom); }\n    .padding-nano-left\\@l { .base-padding(@nano-left); }\n    .padding-nano-vertical\\@l { .base-padding(@nano-vertical); }\n    .padding-nano-horizontal\\@l { .base-padding(@nano-horizontal); }\n\n    .padding-micro\\@l { .base-padding(@micro); }\n    .padding-micro-top\\@l { .base-padding(@micro-top); }\n    .padding-micro-right\\@l { .base-padding(@micro-right); }\n    .padding-micro-bottom\\@l { .base-padding(@micro-bottom); }\n    .padding-micro-left\\@l { .base-padding(@micro-left); }\n    .padding-micro-vertical\\@l { .base-padding(@micro-vertical); }\n    .padding-micro-horizontal\\@l { .base-padding(@micro-horizontal); }\n\n    .padding-small\\@l { .base-padding(@small); }\n    .padding-small-top\\@l { .base-padding(@small-top); }\n    .padding-small-right\\@l { .base-padding(@small-right); }\n    .padding-small-bottom\\@l { .base-padding(@small-bottom); }\n    .padding-small-left\\@l { .base-padding(@small-left); }\n    .padding-small-vertical\\@l { .base-padding(@small-vertical); }\n    .padding-small-horizontal\\@l { .base-padding(@small-horizontal); }\n\n    .padding-medium\\@l { .base-padding(@medium); }\n    .padding-medium-top\\@l { .base-padding(@medium-top); }\n    .padding-medium-right\\@l { .base-padding(@medium-right); }\n    .padding-medium-bottom\\@l { .base-padding(@medium-bottom); }\n    .padding-medium-left\\@l { .base-padding(@medium-left); }\n    .padding-medium-vertical\\@l { .base-padding(@medium-vertical); }\n    .padding-medium-horizontal\\@l { .base-padding(@medium-horizontal); }\n\n    .padding-large\\@l { .base-padding(@large); }\n    .padding-large-top\\@l { .base-padding(@large-top); }\n    .padding-large-right\\@l { .base-padding(@large-right); }\n    .padding-large-bottom\\@l { .base-padding(@large-bottom); }\n    .padding-large-left\\@l { .base-padding(@large-left); }\n    .padding-large-vertical\\@l { .base-padding(@large-vertical); }\n    .padding-large-horizontal\\@l { .base-padding(@large-horizontal); }\n\n    .padding-remove\\@l { .base-padding(@none); }\n    .padding-remove-top\\@l { padding-top: 0; }\n    .padding-remove-right\\@l { padding-right: 0; }\n    .padding-remove-left\\@l { padding-left: 0; }\n    .padding-remove-bottom\\@l { padding-bottom: 0; }\n    .padding-remove-vertical\\@l { padding-top: 0; padding-bottom: 0; }\n    .padding-remove-horizontal\\@l { padding-left: 0; padding-right: 0; }\n\n    .padding-label-top\\@l { padding-top: 15px; }\n}\n\n@media(min-width: 1600px) {\n    .padding-nano\\@xl { .base-padding(@nano); }\n    .padding-nano-top\\@xl { .base-padding(@nano-top); }\n    .padding-nano-right\\@xl { .base-padding(@nano-right); }\n    .padding-nano-bottom\\@xl { .base-padding(@nano-bottom); }\n    .padding-nano-left\\@xl { .base-padding(@nano-left); }\n    .padding-nano-vertical\\@xl { .base-padding(@nano-vertical); }\n    .padding-nano-horizontal\\@xl { .base-padding(@nano-horizontal); }\n\n    .padding-micro\\@xl { .base-padding(@micro); }\n    .padding-micro-top\\@xl { .base-padding(@micro-top); }\n    .padding-micro-right\\@xl { .base-padding(@micro-right); }\n    .padding-micro-bottom\\@xl { .base-padding(@micro-bottom); }\n    .padding-micro-left\\@xl { .base-padding(@micro-left); }\n    .padding-micro-vertical\\@xl { .base-padding(@micro-vertical); }\n    .padding-micro-horizontal\\@xl { .base-padding(@micro-horizontal); }\n\n    .padding-small\\@xl { .base-padding(@small); }\n    .padding-small-top\\@xl { .base-padding(@small-top); }\n    .padding-small-right\\@xl { .base-padding(@small-right); }\n    .padding-small-bottom\\@xl { .base-padding(@small-bottom); }\n    .padding-small-left\\@xl { .base-padding(@small-left); }\n    .padding-small-vertical\\@xl { .base-padding(@small-vertical); }\n    .padding-small-horizontal\\@xl { .base-padding(@small-horizontal); }\n\n    .padding-medium\\@xl { .base-padding(@medium); }\n    .padding-medium-top\\@xl { .base-padding(@medium-top); }\n    .padding-medium-right\\@xl { .base-padding(@medium-right); }\n    .padding-medium-bottom\\@xl { .base-padding(@medium-bottom); }\n    .padding-medium-left\\@xl { .base-padding(@medium-left); }\n    .padding-medium-vertical\\@xl { .base-padding(@medium-vertical); }\n    .padding-medium-horizontal\\@xl { .base-padding(@medium-horizontal); }\n\n    .padding-large\\@xl { .base-padding(@large); }\n    .padding-large-top\\@xl { .base-padding(@large-top); }\n    .padding-large-right\\@xl { .base-padding(@large-right); }\n    .padding-large-bottom\\@xl { .base-padding(@large-bottom); }\n    .padding-large-left\\@xl { .base-padding(@large-left); }\n    .padding-large-vertical\\@xl { .base-padding(@large-vertical); }\n    .padding-large-horizontal\\@xl { .base-padding(@large-horizontal); }\n\n    .padding-xlarge-horizontal\\@xl { .base-padding(@xlarge-horizontal); }\n\n    .padding-remove\\@xl { .base-padding(@none); }\n    .padding-remove-top\\@xl { padding-top: 0; }\n    .padding-remove-right\\@xl { padding-right: 0; }\n    .padding-remove-left\\@xl { padding-left: 0; }\n    .padding-remove-bottom\\@xl { padding-bottom: 0; }\n    .padding-remove-vertical\\@xl { padding-top: 0; padding-bottom: 0; }\n    .padding-remove-horizontal\\@xl { padding-left: 0; padding-right: 0; }\n\n    .padding-letter-top { padding-top: 24px; }\n    .padding-letter-top\\@m { padding-top: 24px; }\n\n    .padding-label-top { padding-top: 20px; }\n    .padding-label-top\\@m { padding-top: 20px; }\n    .padding-label-top\\@l { padding-top: 20px; }\n}\n","@media (min-width: 600px) {\n    .margin-small-left\\@s {\n        margin-left: 10px !important;\n    }\n    .margin-remove-top\\@s {\n        margin-top: 0 !important;\n    }\n    .margin-remove\\@s {\n        margin: 0 !important;\n    }\n}\n\n@media (min-width: 960px) {\n    .margin-remove-top\\@m {\n        margin-top: 0 !important;\n    }\n    .margin-remove\\@m {\n        margin: 0 !important;\n    }\n}\n\n@media (min-width: 1200px) {\n    .margin-remove-top\\@l {\n        margin-top: 0 !important;\n    }\n    .margin-remove\\@l {\n        margin: 0 !important;\n    }\n}\n\n@media (min-width: 1600px) {\n    .margin-remove-top\\@xl {\n        margin-top: 0 !important;\n    }\n    .margin-remove\\@xl {\n        margin: 0 !important;\n    }\n}\n\n.base-margin(@margin) {\n    margin: @margin;\n}\n\n@none: 0 0 0 0;\n@nano: 5px 5px 5px 5px;\n@nano-top: 5px 0 0 0;\n@nano-right: 0 5px 0 0;\n@nano-bottom: 0 0 5px 0;\n@nano-left: 0 0 0 5px;\n@nano-vertical: 5px 0;\n@nano-horizontal: 0 5px;\n\n@none: 0 0 0 0;\n@micro: 10px 10px 10px 10px;\n@micro-top: 10px 0 0 0;\n@micro-right: 0 10px 0 0;\n@micro-bottom: 0 0 10px 0;\n@micro-left: 0 0 0 10px;\n@micro-vertical: 10px 0;\n@micro-horizontal: 0 10px;\n\n@small-top-right: 15px 15px 0 0;\n@small-right-bottom: 0 15px 15px 0;\n\n@medium-top: 24px 0 0 0;\n\n@large-right: 0 80px 0 0;\n\n.margin-remove { .base-margin(@none); }\n.margin-remove-top { margin-top: 0; }\n\n.margin-nano { .base-margin(@nano); }\n.margin-nano-top { .base-margin(@nano-top); }\n.margin-nano-right { .base-margin(@nano-right); }\n.margin-nano-bottom { .base-margin(@nano-bottom); }\n.margin-nano-left { .base-margin(@nano-left); }\n.margin-nano-vertical { .base-margin(@nano-vertical); }\n.margin-nano-horizontal { .base-margin(@nano-horizontal); }\n\n.margin-micro { .base-margin(@micro); }\n.margin-micro-top { .base-margin(@micro-top); }\n.margin-micro-right { .base-margin(@micro-right); }\n.margin-micro-bottom { .base-margin(@micro-bottom); }\n.margin-micro-left { .base-margin(@micro-left); }\n.margin-micro-vertical { .base-margin(@micro-vertical); }\n.margin-micro-horizontal { .base-margin(@micro-horizontal); }\n\n.margin-small-right-bottom { .base-margin(@small-right-bottom); }\n\n@media(min-width: 1600px) {\n    .margin-remove\\@xl { .base-margin(@none); }\n    .margin-remove-top\\@xl { margin-top: 0; }\n    .margin-remove-bottom\\@xl { margin-bottom: 0; }\n    .margin-remove-left\\@xl { margin-left: 0; }\n    .margin-remove-right\\@xl { margin-right: 0; }\n\n    .margin-nano\\@xl { .base-margin(@nano); }\n    .margin-nano-top\\@xl { .base-margin(@nano-top); }\n    .margin-nano-right\\@xl { .base-margin(@nano-right); }\n    .margin-nano-bottom\\@xl { .base-margin(@nano-bottom); }\n    .margin-nano-left\\@xl { .base-margin(@nano-left); }\n    .margin-nano-vertical\\@xl { .base-margin(@nano-vertical); }\n    .margin-nano-horizontal\\@xl { .base-margin(@nano-horizontal); }\n\n    .margin-micro\\@xl { .base-margin(@micro); }\n    .margin-micro-top\\@xl { .base-margin(@micro-top); }\n    .margin-micro-right\\@xl { .base-margin(@micro-right); }\n    .margin-micro-bottom\\@xl { .base-margin(@micro-bottom); }\n    .margin-micro-left\\@xl { .base-margin(@micro-left); }\n    .margin-micro-vertical\\@xl { .base-margin(@micro-vertical); }\n    .margin-micro-horizontal\\@xl { .base-margin(@micro-horizontal); }\n}\n\n@media(min-width: 960px) {\n    .margin-remove\\@m { .base-margin(@none); }\n    .margin-remove-top\\@m { margin-top: 0; }\n    .margin-remove-bottom\\@m { margin-bottom: 0; }\n    .margin-remove-left\\@m { margin-left: 0; }\n    .margin-remove-right\\@m { margin-right: 0; }\n\n    .margin-nano\\@m { .base-margin(@nano); }\n    .margin-nano-top\\@m { .base-margin(@nano-top); }\n    .margin-nano-right\\@m { .base-margin(@nano-right); }\n    .margin-nano-bottom\\@m { .base-margin(@nano-bottom); }\n    .margin-nano-left\\@m { .base-margin(@nano-left); }\n    .margin-nano-vertical\\@m { .base-margin(@nano-vertical); }\n    .margin-nano-horizontal\\@m { .base-margin(@nano-horizontal); }\n\n    .margin-micro\\@m { .base-margin(@micro); }\n    .margin-micro-top\\@m { .base-margin(@micro-top); }\n    .margin-micro-right\\@m { .base-margin(@micro-right); }\n    .margin-micro-bottom\\@m { .base-margin(@micro-bottom); }\n    .margin-micro-left\\@m { .base-margin(@micro-left); }\n    .margin-micro-vertical\\@m { .base-margin(@micro-vertical); }\n    .margin-micro-horizontal\\@m { .base-margin(@micro-horizontal); }\n\n    .margin-medium-top\\@m { .base-margin(@medium-top); }\n\n    .margin-large-right\\@m { .base-margin(@large-right); }\n}\n",".width-small-medium {\n    width: 200;\n}\n\n.width-micro {\n    width: 100px;\n}\n\n.width-micro-small {\n    width: 60px;\n}\n\n.width-nano {\n    width: 50px;\n}\n\n@media(min-width: 960px) {\n    .width-large\\@m {\n        width: 338px;\n    }\n\n    .width-medium\\@m {\n        width: 225px;\n    }\n\n    .width-small-medium\\@m {\n        width: 150px;\n    }\n\n    .width-small\\@m {\n        width: 112px;\n    }\n\n    .width-micro\\@m {\n        width: 75px;\n    }\n\n    .width-nano\\@m {\n        width: 38px;\n    }\n}\n\n@media(min-width: 600px) {\n    .width-large\\@s {\n        width: 338px;\n    }\n\n    .width-medium\\@s {\n        width: 225px;\n    }\n\n    .width-small-medium\\@s {\n        width: 150px;\n    }\n\n    .width-small\\@s {\n        width: 112px;\n    }\n\n    .width-micro\\@s {\n        width: 75px;\n    }\n\n    .width-nano\\@s {\n        width: 38px;\n    }\n}\n\n@media(min-width: 1200px) {\n    .width-large\\@l {\n        width: 450px;\n    }\n\n    .width-medium\\@l {\n        width: 300px;\n    }\n\n    .width-small-medium\\@l {\n        width: 200px;\n    }\n\n    .width-small\\@l {\n        width: 150px;\n    }\n\n    .width-micro\\@l {\n        width: 100px;\n    }\n\n    .width-nano\\@l {\n        width: 50px;\n    }\n}\n\n// width fixos\n.base-width(@width) {\n    width: @width;\n}\n\n.width-1000 { .base-width(1000px); }\n.width-1200 { .base-width(1200px); }\n\n@media (min-width: 640px) {\n    .width-1000\\@s { .base-width(1000px); }\n    .width-1200\\@s { .base-width(1200px); }\n}\n\n@media (min-width: 960px) {\n    .width-1000\\@m { .base-width(1000px); }\n    .width-1200\\@m { .base-width(1200px); }\n    .width-1400\\@m { .base-width(1400px); }\n}\n\n@media (min-width: 1200px) {\n    .width-1000\\@l { .base-width(1000px); }\n    .width-1100\\@l { .base-width(1100px); }\n    .width-1200\\@l { .base-width(1200px); }\n    .width-1400\\@l { .base-width(1400px); }\n}\n\n@media (min-width: 1600px) {\n    .width-1000\\@xl { .base-width(1000px); }\n    .width-1200\\@xl { .base-width(1200px); }\n    .width-1300\\@xl { .base-width(1300px); }\n    .width-1400\\@xl { .base-width(1400px); }\n    .width-1500\\@xl { .base-width(1500px); }\n    .width-1600\\@xl { .base-width(1600px); }\n}\n\n//grid\n.generate-grid-classes(@columns, @suffix) when (@suffix =null) {\n    .loop-grid-classes(@index) when (@index > 0) {\n        .width-@{index}-@{columns} {\n            width: percentage((@index / @columns));\n        }\n\n        .loop-grid-classes(@index - 1);\n    }\n\n    .loop-grid-classes(@columns);\n}\n\n.generate-grid-classes(@columns, @suffix) when not (@suffix =null) {\n    .loop-grid-classes(@index) when (@index > 0) {\n        .width-@{index}-@{columns}@{suffix} {\n            width: percentage((@index / @columns));\n        }\n\n        .loop-grid-classes(@index - 1);\n    }\n\n    .loop-grid-classes(@columns);\n}\n\n.generate-fixed-width-classes(@suffix) {\n    .loop-width-classes(@index) when (@index > 0) {\n        .width-@{index}@{suffix} when not (@suffix =null) {\n            width:~\"@{index}px\";\n        }\n\n        .width-@{index} when (@suffix =null) {\n            width:~\"@{index}px\";\n        }\n\n        .loop-width-classes(@index - 5);\n    }\n\n    .loop-width-classes(600);\n}\n\n.generate-grid-classes(6, null);\n.generate-grid-classes(8, null);\n.generate-grid-classes(12, null);\n.generate-grid-classes(20, null);\n.generate-fixed-width-classes(null);\n\n@media (min-width: 640px) {\n    .generate-grid-classes(6, \\@s);\n    .generate-grid-classes(8, \\@s);\n    .generate-grid-classes(12, \\@s);\n    .generate-grid-classes(20, \\@s);\n    .generate-fixed-width-classes(\\@s);\n}\n\n@media (min-width: 960px) {\n    .generate-grid-classes(6, \\@m);\n    .generate-grid-classes(8, \\@m);\n    .generate-grid-classes(12, \\@m);\n    .generate-grid-classes(20, \\@m);\n    .generate-fixed-width-classes(\\@m);\n}\n\n@media (min-width: 1200px) {\n    .generate-grid-classes(6, \\@l);\n    .generate-grid-classes(8, \\@l);\n    .generate-grid-classes(12, \\@l);\n    .generate-grid-classes(20, \\@l);\n    .generate-fixed-width-classes(\\@l);\n}\n\n@media (min-width: 1600px) {\n    .generate-grid-classes(6, \\@xl);\n    .generate-grid-classes(8, \\@xl);\n    .generate-grid-classes(12, \\@xl);\n    .generate-grid-classes(20, \\@xl);\n    .generate-fixed-width-classes(\\@xl);\n}\n\n.divided-width(@parts) {\n    width:calc(100% / @parts);\n}\n\n.child-width-1-8 > * { .divided-width(8); }\n\n@media (min-width: 640px) {\n    .child-width-1-8\\@s > * { .divided-width(8); }\n}\n\n@media (min-width: 960px) {\n    .child-width-1-8\\@m > * { .divided-width(8); }\n}\n\n@media (min-width: 1200px) {\n    .child-width-1-8\\@l > * { .divided-width(8); }\n}\n\n@media (min-width: 1600px) {\n    .child-width-1-8\\@xl > * { .divided-width(8); }\n}\n\n.uk-width-1-8 {\n    width: calc(100% / 8);\n}\n","\n.icone-adicionar {\n    display: inline-block;\n    background-image: url(../img/iconadicionarbranco.svg) !important;\n    width: 20px;\n    height: 20px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-editar {\n    display: inline-block;\n    background-image: url(../img/iconeeditar.svg) !important;\n    width: 16px;\n    height: 16px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-excluir {\n    display: inline-block;\n    background-image: url(../img/iconedeletar.svg) !important;\n    width: 14px;\n    height: 16px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-alerta {\n    display: inline-block;\n    background-image: url(../img/iconealerta.svg) !important;\n    width: 47px;\n    height: 47px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    flex-shrink: 0;\n    aspect-ratio: 1 / 1;\n}\n\n.icone-circulo-card-aluno {\n    display: inline-block;\n    background-image: url(../img/circulocard.svg) !important;\n    width: 12px;\n    height: 12px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-excluir-card-aluno {\n    display: inline-block;\n    background-image: url(../img/iconedeletarbranco.svg) !important;\n    width: 12px;\n    height: 13px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-info-medicas-card-aluno {\n    display: inline-block;\n    background-image: url(../img/iconeinfomed.svg) !important;\n    width: 35px;\n    height: 25px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-avatar {\n    display: inline-block;\n    background-image: url(../img/avatar-default.png) !important;\n    width: 40px;\n    height: 40px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-logo-menu {\n    display: inline-block;\n    background-image: url(../img/logologinbranco.png) !important;\n    width: 104px;\n    height: 46px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-logo-login {\n    display: inline-block;\n    background-image: url(../img/logo.png) !important;\n    width: 150px;\n    height: 66px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-salvar-mobile {\n    display: inline-block;\n    background-image: url(../img/iconesalvarmobile.svg) !important;\n    width: 35px;\n    height: 35px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-voltar-mobile {\n    display: inline-block;\n    background-image: url(../img/iconevoltarmobile.svg) !important;\n    width: 35px;\n    height: 35px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-pdf {\n    display: inline-block;\n    background-image: url(../img/icone-pdf.png) !important;\n    width: 16px;\n    height: 20px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-png {\n    display: inline-block;\n    background-image: url(../img/icone-png.png) !important;\n    width: 16px;\n    height: 20px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-x {\n    display: inline-block;\n    background-image: url(../img/icone-x.png) !important;\n    width: 11px;\n    height: 11px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-editar-nota {\n    display: inline-block;\n    background-image: url(../img/icone-editar-nota.svg) !important;\n    width: 22px;\n    height: 22px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-arquivo-baixar {\n    display: inline-block;\n    background-image: url(../img/icone-arquivo-baixar.svg) !important;\n    width: 20px;\n    height: 20px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-status-entregue {\n    display: inline-block;\n    background-image: url(../img/icone-status-entregue.svg) !important;\n    width: 20px;\n    height: 20px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-status-pendente {\n    display: inline-block;\n    background-image: url(../img/pendente.svg) !important;\n    width: 20px;\n    height: 20px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.checkbox-presente {\n    width: 22px;\n    height: 22px;\n    border: 2px solid #ddd;\n    border-radius: 50%;\n    background-color: #ddd;\n    background-image: url(../img/iconevcheckbox.svg) !important;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 12px 12px;\n    cursor: pointer;\n    position: relative;\n    transition: background-color 0.2s ease;\n}\n\n.checkbox-ausente {\n    width: 22px;\n    height: 22px;\n    border: 2px solid #ddd;\n    border-radius: 50%;\n    background-color: #ddd;\n    background-image: url(../img/iconexcheckbox.svg) !important;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 10px 10px;\n    cursor: pointer;\n    position: relative;\n    transition: background-color 0.2s ease;\n}\n\n.demanda-atencao {\n    width: 40px;\n    height: 40px;\n    background-image: url(../img/demandaAtencao.svg) !important;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 30px 30px;\n    cursor: pointer;\n    position: relative;\n    transition: background-color 0.2s ease;\n}\n\n.atingiu-o-esperado {\n    width: 40px;\n    height: 40px;\n    background-image: url(../img/atingiuOEsperado.svg) !important;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 30px 30px;\n    cursor: pointer;\n    position: relative;\n    transition: background-color 0.2s ease;\n}\n\n.superou-se {\n    width: 40px;\n    height: 40px;\n    background-image: url(../img/superou-se.svg) !important;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 30px 30px;\n    cursor: pointer;\n    position: relative;\n    transition: background-color 0.2s ease;\n}\n\n.nao-atingiu {\n    width: 40px;\n    height: 40px;\n    background-image: url(../img/naoAtingiu.svg) !important;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 30px 30px;\n    cursor: pointer;\n    position: relative;\n    transition: background-color 0.2s ease;\n}\n\n.fonte-icone-mobile {\n    font-size: 11px !important;\n}\n\n.icone-adicionar-link {\n    display: inline-block;\n    background-image: url(../img/iconebotaosalvarlink.svg) !important;\n    width: 40px;\n    height: 40px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-deletar-link {\n    display: inline-block;\n    background-image: url(../img/iconebotaodeletarlink.svg) !important;\n    width: 40px;\n    height: 40px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-check-on {\n    display: inline-block;\n    background-image: url(../img/iconebotaocheckon.svg) !important;\n    width: 20px;\n    height: 20px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-check-off {\n    display: inline-block;\n    background-image: url(../img/iconebotaocheckoff.svg) !important;\n    width: 20px;\n    height: 20px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-uncheck-on {\n    display: inline-block;\n    background-image: url(../img/iconebotaouncheckon.svg) !important;\n    width: 20px;\n    height: 20px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-uncheck-off {\n    display: inline-block;\n    background-image: url(../img/iconebotaouncheckoff.svg) !important;\n    width: 20px;\n    height: 20px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-justificativa {\n    display: inline-block;\n    background-image: url(../img/iconejustificativa.svg) !important;\n    width: 20px;\n    height: 20px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-minha-turma {\n    display: inline-block;\n    background-image: url(../img/iconeminhaturma.svg) !important;\n    width: 24px;\n    height: 24px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-matricula {\n    display: inline-block;\n    background-image: url(../img/iconematricula.svg) !important;\n    width: 20px;\n    height: 20px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-status {\n    display: inline-block;\n    background-image: url(../img/iconepontoverde.svg) !important;\n    width: 20px;\n    height: 20px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-ensino {\n    display: inline-block;\n    background-image: url(../img/iconeensino.svg) !important;\n    width: 20px;\n    height: 20px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-ensino-grande {\n    display: inline-block;\n    background-image: url(../img/iconeensino.svg) !important;\n    width: 30px;\n    height: 30px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-turno {\n    display: inline-block;\n    background-image: url(../img/iconeturno.svg) !important;\n    width: 20px;\n    height: 20px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-professor {\n    display: inline-block;\n    background-image: url(../img/iconeprofessor.svg) !important;\n    width: 20px;\n    height: 16px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-avaliacoes {\n    display: inline-block;\n    background-image: url(../img/iconeavaliacoes.svg) !important;\n    width: 20px;\n    height: 20px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-avaliacoes-pendente {\n    display: inline-block;\n    background-image: url(../img/iconeavaliacoespendente.svg) !important;\n    width: 30px;\n    height: 30px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-prova-pendente {\n    display: inline-block;\n    background-image: url(../img/iconeprovapendente.svg) !important;\n    width: 30px;\n    height: 30px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-prova-download {\n    display: inline-block;\n    background-image: url(../img/iconeprovadownload.svg) !important;\n    width: 18px;\n    height: 23px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-prova-upload {\n    display: inline-block;\n    background-image: url(../img/iconeprovaupload.svg) !important;\n    width: 18px;\n    height: 23px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.icone-prova-deletar {\n    display: inline-block;\n    background-image: url(../img/iconedeletar.svg) !important;\n    width: 18px;\n    height: 23px !important;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n@media (max-width: 768px) {\n    .icone-logo-menu {\n        width: 80px;\n        height: 30px;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 959px) {\n    .icone-logo-menu {\n        width: 90px !important;\n        height: 38px !important;\n    }\n}\n\n@media (max-width: 959px) {\n    .icone-logo-menu {\n        width: 70px !important;\n        height: 28px !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
